import application from 'application/application';

import moment from 'moment';

import angular from 'angular';

const controller = 'DefaultMovementsListController';

application
	.controller(controller, [
		'$scope',
		'$rootScope',
		'$http',
		'$state',
		'$stateParams',
		'API',
		'helper',
		'notification',
		'authentication',
		'permissions',
		'googleAPI',
		'environment',
		'$timeout',
		'$interval',
		'$location',
		'downloadService',
		'integracaoGoogleCalendar', //aqui google agenda
		'filterSelect',
		(
			$scope,
			$rootScope,
			$http,
			$state,
			$stateParams,
			API,
			helper,
			notification,
			authentication,
			permissions,
			googleAPI,
			environment,
			$timeout,
			$interval,
			$location,
			downloadService,
			integracaoGoogleCalendar, //aqui google agenda
			filterSelect
		) => {
			$rootScope.treatCompoments();

			if (
				$location.url().match(/movimentacoes\/detalhes\/andamento/g) ||
				$location.url().match(/movimentacoes\/detalhes\/publicacao/g)
			) {
				$scope.paginateMovements = true;
			} else {
				$scope.paginateMovements = false;
			}

			$rootScope.showChatWidget = false;

			$scope.loadingAnexo = false;
			$scope.idAnexoLoading = [];
			$scope.idAnexoLoadingSpinner = [];

			if (localStorage.getItem('__idAnexoLoading__'))
				$scope.idAnexoLoading = JSON.parse(
					localStorage.getItem('__idAnexoLoading__')
				);

			const defautEmptyEmail = {
				email: ''
			};

			$scope.validateEmail = /(^[a-z0-9.!#$%&'+\/=?^_`{|​}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+(\.[[a-zA-Z0-9]+)?)(\s?\;\s?[a-z0-9.!#$%&'+\/=?^_`{|​}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+(\.[[a-zA-Z0-9]+)?)*?$/i;

			$scope.placeHolderText = 'Adicione mais emails separando por ";"';

			$scope.publishEmail = [];

			$scope.saveEmail = [];

			$scope.emptyEmail = helper.cloneSimpleObject(defautEmptyEmail);

			$scope.environmentPageMov = null;

			$scope.deleteProcessOptions = {
				deleteLinkedDeadlines: 1
			};

			$scope.shouldDeleteDeadlineType = 'publicação'; // publicação, andamento
			$scope.shouldDeleteDeadlineOption = 1;

			let calendarGridValue = sessionStorage.getItem('__calendarGrid__');

			$rootScope.getDaysDeleteTrash();

			let closeTrashInfoMessageSession = sessionStorage.getItem(
				'__closeTrashInfoMessage__'
			);

			$scope.showTrashInfoMessage =
				closeTrashInfoMessageSession == true ||
				closeTrashInfoMessageSession == 'true'
					? false
					: true;

			$rootScope.calendarGrid = calendarGridValue === 'true' ? true : false;

			$scope.isMobile = false;

			$scope.currentPageUrl = () => {
				const url = $location.$$url.split('?')[0];

				switch (url) {
					case '/movimentacoes/publicacoes/pastas':
						$scope.environmentPageMov = '3';
						break;
					case '/movimentacoes/publicacoes':
						$scope.environmentPageMov = '2';
						break;
					case '/movimentacoes/processos/pastas':
						$scope.environmentPageMov = '4';
						break;
					case '/movimentacoes/todas-conta':
						$scope.environmentPageMov = '1';
						break;
					case '/movimentacoes/lixeira':
						$scope.environmentPageMov = '5';
						break;
					case '/movimentacoes':
						let count = 0;
						let rota = 'root.default.movements.list';

						['recordPublications', 'createMovements'].forEach((item, index) => {
							if (permissions.has(item) && count == 0) {
								rota += index == 0 ? '2' : '1';
								count += 1;
							}
						});

						if (count > 0)
							$state.transitionTo(rota, { inherit: false, reload: rota });
						break;
					default:
						break;
				}
			};

			$scope.verifyLocal = () => {
				$scope.currentPageUrl();
				setTimeout(() => {
					$rootScope.verifyEnvironment($scope.environmentPageMov);

					if (
						$location.$$url.contains('/movimentacoes/todas-conta') &&
						!permissions.has('createMovements')
					) {
						$state.transitionTo('root.default.initial', {
							inherit: false,
							reload: true
						});
					}
				}, 200);
			};

			$scope.verifyLocal();
			$scope.filter = $.extend({}, $stateParams);

			let selecionados = JSON.parse(sessionStorage.getItem('__selected__'));

			if (selecionados) {
				$scope.filter.caderno = selecionados.IdsCadernos;
				$scope.filter.diario = selecionados.IdsDiarios;
				$scope.filter.palavraChave = selecionados.IdsPalavraChave;
				$scope.filter.lido = selecionados.Lido;
				$scope.filter.pesquisa = selecionados.pesquisa;
			}

			$rootScope.params = helper.cloneSimpleObject($scope.filter);

			$rootScope.periodsFolderTypeSelected =
				$stateParams.dataInicial && !$stateParams.folderType ? true : false;

			$scope.recordValuesAccount = () => {
				$scope.valuePublicationAccountStorage = sessionStorage.getItem(
					'__publicationPaste__'
				);

				$scope.valueProcessAccountStorage = sessionStorage.getItem(
					'__processPaste__'
				);

				$scope.valueAllOfAccountStorage = sessionStorage.getItem(
					'__allOfAccount__'
				);
			};

			$scope.recordValuesAccount();

			$scope.disableMail = false;
			$scope.showAllSelected = false;

			if (
				$rootScope.pageSelected == 'Key' ||
				$rootScope.pageSelected == 'pastaPubli'
			) {
				$rootScope.dataSelecionada = true;
				$rootScope.periodsFolderType = false;
			}

			$scope.actionlote = () => {
				setTimeout(() => {
					if (
						!$rootScope.newPublicationChecked ||
						!$rootScope.newPublicationChecked.length
					)
						$scope.itemCheckedDisable = true;
				}, 500);
			};

			$scope.actionlote();

			// Regex de validação de urls;
			$scope.linkValidade = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/i;

			const types = [
				'identificador',
				'diario',
				'palavraChave',
				'fonte',
				'orgaoJudicial',
				'lido',
				'tipo',
				'dataInicial',
				'dataFinal',
				'composedId',
				'pesquisa',
				'caderno'
			];

			const blocked = localStorage.getItem('__authenticationUserBlocked__');

			/** Lista de filtros possíveis. */
			const movementsFiltersNames = {
				q: {
					url: 'q',
					request: 'q'
				},
				idSituacao: {
					url: 'idSituacao',
					request: 'idSituacao'
				},
				arquivada: {
					url: 'idSituacao',
					request: 'idSituacao'
				},
				pasta: {
					url: 'pasta',
					request: 'IdPastaUsuarioCliente'
				},
				tipo: {
					url: 'tipo',
					request: 'IdTipoMovProcesso',
					enum: {
						andamentos: -1,
						publicacoes: -2,
						inss: -4,
						properties: {
							andamentos: {
								label: 'Andamentos'
							},
							publicacoes: {
								label: 'Publicações'
							},
							inss: {
								label: 'Processos INSS'
							}
						}
					},
					values: {
						andamentos: -1,
						publicacoes: -2,
						inss: -4
					}
				},
				dataInicial: {
					url: 'dataInicial',
					request: 'DataMovimentoInicio'
				},
				dataFinal: {
					url: 'dataFinal',
					request: 'DataMovimentoFim'
				},
				fonte: {
					url: 'fonte',
					request: 'IdFontePesquisa',
					download: 'IdFonteProcesso'
				},
				diario: {
					url: 'diario',
					request: 'IdsDiarios'
				},
				identificador: {
					url: 'identificador',
					request: 'IdentificacaoFonteProcesso'
				},
				orgaoJudicial: {
					url: 'orgaoJudicial',
					request: 'IdsOrgaosJudiciarios'
				},
				valorParametro: {
					url: 'valorParametro',
					request: 'ValorParametroFontePesquisa'
				},
				palavraChave: {
					url: 'palavraChave',
					request: 'IdsPalavraChave'
				},
				lido: {
					url: 'lido',
					request: 'Lido'
				},
				pesquisa: {
					url: 'pesquisa',
					request: 'pesquisa'
				},
				composedId: {
					url: 'composedId',
					request: 'composedId'
				},
				caderno: {
					url: 'caderno',
					request: 'IdsCadernos'
				}
			};

			$scope.emptyVariation = {};

			$scope.options = [
				{
					idTipoPalavraChave: -2,
					name: 'Variação de pesquisa'
				},
				{
					idTipoPalavraChave: -3,
					name: 'Variação de exclusão'
				}
			];

			$scope.recordsFilters = [];

			$scope.allOfAccount = false;

			$scope.openDownloadMovements = false;

			$scope.loadingGrid = false;

			$scope.listAllAttachmentsModal = [];

			$scope.palavraChaveSelecionada = [];

			$scope.rename = {};

			$scope.movementInAction = null;

			$scope.email = '';

			$scope.quickToggle = true;

			$scope.readySourcesParams = true;

			$scope.tooltipSendEmail = 'Adicione mais emails separando por ";"';

			$scope.groupData = JSON.parse(localStorage.getItem('__groupUserData__'));

			$scope.userClient = authentication.getUserData('nome');

			$scope.loadingSide = $scope.loadingTitle = true;

			$scope.stateParamsFilter = helper.cloneSimpleObject($scope.filter);

			$scope.badgeFilterDate = helper.cloneSimpleObject(
				$scope.stateParamsFilter
			);

			const dataSyncGoogle = integracaoGoogleCalendar.recoverInfos();

			$rootScope.noSync =
				dataSyncGoogle && dataSyncGoogle.sincronizado ? false : true;

			$scope.getScopedInputValue = scopedInput =>
				scopedInput && scopedInput.$viewValue;

			$scope.processesCredits;

			$scope.groupSelected = localStorage.getItem('__groupSelected__');

			$scope.groupUserSelected =
				$scope.groupSelected == null || $scope.groupSelected == 'false'
					? false
					: true;

			$scope.userData = JSON.parse(
				localStorage.getItem('__authenticationUserData__')
			);

			$scope.placeholderDate = new Date().toLocaleString('pt-BR');

			$scope.variations = [];

			$scope.parameterUsers = [];

			$scope.keyWordsVariations = helper.responseStore().setItemsPerPage(1);

			$scope.allNotebooks = helper.responseStore();

			$scope.searchVariations = helper.responseStore().setCurrentPage(1);

			$scope.exclusions = helper.responseStore().setCurrentPage(1);

			$scope.declined = helper.responseStore().setCurrentPage(1);

			$scope.keywordDiaries = helper.responseStore().setCurrentPage(1);

			$scope.processHeader = helper.responseStore().setItemsPerPage(1);

			$scope.clientUserDiaries = helper.responseStore();

			$scope.movements = helper.responseStore().setItemsPerPage(20);

			$scope.briefcase = helper.responseStore().setItemsPerPage(1);

			$scope.clientUserJudicialOrgansList = helper.responseStore();

			$scope.identifiersFilterList = helper.responseStore();
			$scope.identifiersFilterHasNoResults = false;

			$scope.requestedProcessesSourcesParams = helper.responseStore();

			$scope.diaries = helper.responseStore();

			// list of agendas
			$scope.agendas = helper.responseStore();

			// list of event types
			$scope.eventsTypes = helper.responseStore();
			$scope.eventsNotifications = helper.responseStore();

			$scope.selectedType = null;

			// list of recurring types
			$scope.recurringEventTypes = helper.responseStore();

			// list of agenda reminder types
			$scope.agendaReminderTypes = helper.responseStore();

			// list of events
			$scope.events = helper.responseStore().setItemsPerPage(20);

			$scope.foundProcessesIndividual = helper
				.responseStore()
				.setItemsPerPage(20);

			/** Toggles */
			$scope.toggleObservations = false;

			$scope.itemChecked = false;

			$scope.folderType = 0;

			$scope.loadingPage = true;

			/** Toggles */
			$scope.itemChecked = false;

			$scope.itemCheckedDisable = true;

			$scope.clearAll = false;

			$scope.blockDownload = false;

			$scope.printing = false;

			$scope.previousFilters = {};

			//aqui
			$scope.popoverGrid = false;

			$rootScope.environmentNotGrid =
				$scope.environmentPageMov != '2' ? true : false;

			$scope.quantityPerPage = 20;

			if (localStorage.getItem('__hasGroupUserPermission__'))
				$rootScope.hasGroupUserPermission = JSON.parse(
					localStorage.getItem('__hasGroupUserPermission__')
				);
			else {
				$rootScope.hasGroupUserPermission = true;
			}

			//Palavra Chave
			$scope.expanded = false;
			$scope.titleKeywords = 'Todas palavras-chave';
			$scope.keyWordClose = false;
			$scope.pageKeywords = 10;
			$scope.actual = 10;
			$scope.pageKeywordsActual = 1;
			$scope.keywordPesq = false;
			$scope.keyWordCheckTotal = [];

			//Diarios
			$scope.expandedDiary = false;
			$scope.diaryClose = false;
			$scope.titleDiaries = 'Todos diários';
			$scope.hasDiary = false;
			$scope.actualDiary = 10;
			$scope.badgeDiary = [];
			$scope.diarySearch = '';
			$scope.paginacaoDiario = [];

			//Tribunais
			$scope.titleCourts = 'Todos tribunais';

			//Fontes
			$scope.titleSources = 'Todas fontes';

			$scope.activeDiaries = helper.responseStore();
			$scope.activesShowing = 10;

			const dataFinalPadrao = new Date();
			const dataInicialPadrao = new Date().setDate(
				dataFinalPadrao.getDate() - 14
			);

			function formatDateRange(startDate, endDate) {
				const options = { day: '2-digit', month: '2-digit', year: 'numeric' };

				const start = new Date(startDate).toLocaleDateString('pt-BR', options);
				const end = new Date(endDate).toLocaleDateString('pt-BR', options);

				return `${start} até ${end}`;
			}

			$scope.onInit = () => {
				let getEventsNotifications = sessionStorage.getItem(
					'__EVENTS_NOTIFICATIONS__'
				);

				if (getEventsNotifications) {
					let eventsNotificationsTypes = JSON.parse(
						getEventsNotifications || '[]'
					);

					if (eventsNotificationsTypes && eventsNotificationsTypes.length > 1) {
						$scope.eventsNotifications.setItems(eventsNotificationsTypes);
						$scope.eventsNotifications.setReady(true);
					}
				} else {
					$scope.fetchDeadlineNotification();
				}
			};

			$scope.fetchDeadlineNotification = async () => {
				await $rootScope.fetchDeadlineNotificationId();

				let getEventsNotifications = sessionStorage.getItem(
					'__EVENTS_NOTIFICATIONS__'
				);

				if (getEventsNotifications) {
					let eventsNotificationsTypes = JSON.parse(
						getEventsNotifications || '[]'
					);

					if (eventsNotificationsTypes && eventsNotificationsTypes.length > 1) {
						$scope.eventsNotifications.setItems(eventsNotificationsTypes);
						$scope.eventsNotifications.setReady(true);
					}
				}
			};

			$scope.updateDataSource = newValue => {
				if (newValue) {
					$scope.dateSource = {
						value: newValue
					};
				} else {
					if (
						$rootScope.pageSelected == 'Key' ||
						$rootScope.pageSelected == 'pastaPubli' ||
						$rootScope.pageSelected == 'keyword' ||
						$location.$$url.includes('/publicacoes')
					) {
						$scope.dateSource = {
							value: 'Período - últimos 15 dias'
						};
					} else if (
						$rootScope.pageSelected == 'todas' ||
						$location.$$url.includes('/todas-conta')
					) {
						$scope.filter.dataInicial = null;
						$scope.filter.dataFinal = null;

						$scope.dateSource = {
							value: 'Todos períodos'
						};
					} else if (
						$rootScope.pageSelected == 'processos' ||
						$location.$$url.includes('/processos/pastas') ||
						$location.$$url.includes('/lixeira')
					) {
						$scope.filter.dataInicial = null;
						$scope.filter.dataFinal = null;

						$scope.dateSource = {
							value: 'Todos períodos'
						};
					}
				}
			};

			if ($scope.filter.dataInicial && $scope.filter.dataFinal) {
				if (
					($rootScope.pageSelected == 'Key' ||
						$rootScope.pageSelected == 'pastaPubli' ||
						$rootScope.pageSelected == 'keyword' ||
						($rootScope.pageSelected == undefined &&
							$location.$$url.includes('/publicacoes'))) &&
					moment(new Date($scope.filter.dataInicial)).format('YYYY-MM-DD') ==
						moment(new Date(dataInicialPadrao)).format('YYYY-MM-DD') &&
					moment(new Date($scope.filter.dataFinal)).format('YYYY-MM-DD') ==
						moment(new Date(dataFinalPadrao)).format('YYYY-MM-DD')
				) {
					$rootScope.dataSelecionada = false;

					$scope.dateSource = {
						value: 'Período - últimos 15 dias'
					};
				} else {
					$scope.dateSource = {
						value: formatDateRange(
							$scope.filter.dataInicial,
							$scope.filter.dataFinal
						)
					};
				}
			} else {
				$rootScope.dataSelecionada = false;
				$scope.updateDataSource();
			}

			// Data do dia em cadastrar prazo
			let defaultEmptyData = {
				_dia: moment().format('DD/MM/YYYY')
			};

			$rootScope.formCreatePrazo.taskToEdit = helper.cloneSimpleObject(
				defaultEmptyData
			);

			// $scope.tituloModal = 'Deseja excluir a movimentação?';
			// $scope.botaoConfirmarModal = 'Sim, quero excluir a movimentação';
			// $scope.mensagemModal =
			// 	'Ao excluir movimentações, você elimina todas as informações referentes a este documento. A ação de excluir é definitiva e irreversível.';

			$scope.pagination = {
				paginaAtual: 0,
				paginaTotal: 0,
				totalItens: 0,
				quantiaPorPagina: 0,
				hasNext: false
			};

			$scope.deleteMultiple = false;

			$scope.listAddEmail = emails => {
				if (emails) {
					emails = emails.split(';');

					emails.forEach(email => {
						$scope.publishEmail.push({ email: email });
					});
				}

				$scope.formatedEmail($scope.publishEmail);
			};

			$scope.formatedEmail = emails => {
				$scope.publishEmail = [];
				var email = [];

				emails.forEach(value => email.push(value.email));

				if (emails.length > 0) email = email.join(';');

				$scope.saveEmail.email = email;
			};

			//****************** Métodos de marcação da listagem ******************
			//Marca ou desmarca todos os registros da listagem
			$scope.toggleAllMovements = toggle => {
				$scope.clearAll = !toggle;
				$scope.itemChecked = !toggle;

				if (toggle) $scope.movements.getCheckedItems();

				$scope.movements
					.getItems()
					.forEach(mov => mov.checked == $scope.clearAll);

				if ($scope.clearAll === false) {
					$rootScope.newPublicationChecked = [];

					$scope.movements
						.getItems()
						.forEach(item => (item.__checked__ = false));
				}

				if (toggle) $scope.itemCheckedDisable = true;

				$scope.blockDownload = false;
			};

			$scope.openModalMarcarComoLidoAll = email => {
				let emails = email.split(';');

				if (emails.length > 1) {
					for (let index1 = 0; index1 < emails.length; index1++) {
						for (let index2 = 0; index2 < emails.length; index2++) {
							if (emails[index1] == emails[index2 + index1 + 1]) {
								return notification.danger(
									'Mesmo endereço de email utilizado!'
								);
							}
						}
					}
				}

				if ($scope.filter.lido == 'true') {
					$('#modalAllDownloads').modal('hide');
					$scope.downloadMovements($scope.saveFileType, false);
				} else {
					$('#modalAllDownloads').modal('hide');
					$('#modalToggleAsReadAll').modal('show');
				}
			};

			//Seleciona registros marcados da listagem
			$scope.selectPublication = item => {
				$rootScope.newPublicationChecked = $rootScope.newPublicationChecked
					? $rootScope.newPublicationChecked
					: [];
				if (item.__checked__ === true) {
					$rootScope.newPublicationChecked.push(item);
				} else {
					$rootScope.newPublicationChecked = $rootScope.newPublicationChecked.filter(
						value => item.idMovProcessoCliente !== value.idMovProcessoCliente
					);
				}

				const hasTrue = $scope.movements.items.some(item => item.__checked__);
				const hasFalse = $scope.movements.items.some(item => !item.__checked__);

				if (hasTrue) {
					if (hasFalse) {
						$('#check-all').prop('indeterminate', true);
						$scope.allSelected = false;
					} else {
						$('#check-all').prop('indeterminate', false);
						$('#check-all').prop('checked', true);
					}
				}

				const checked = $rootScope.newPublicationChecked;

				if (!checked || checked.length === 0) {
					$('#check-all').prop('indeterminate', false);
					$('#check-all').prop('checked', false);
				}

				if (!checked || checked.length < 2) $scope.itemCheckedDisable = true;
				else $scope.itemCheckedDisable = false;
			};

			//Seleciona todos os registros marcados da listagem
			$scope.selectAllPublication = item => {
				$scope.clearAll = false;
				$scope.showAllSelected = false;
				$rootScope.newPublicationChecked = $rootScope.newPublicationChecked
					? $rootScope.newPublicationChecked
					: [];
				setTimeout(() => {
					item.map(value => {
						if (value.__checked__ === true) {
							if (!!$rootScope.newPublicationChecked) {
								$rootScope.newPublicationChecked = $rootScope.newPublicationChecked.filter(
									item =>
										item.idMovProcessoCliente !== value.idMovProcessoCliente
								);
							}

							$rootScope.newPublicationChecked.push(value);
						} else {
							$rootScope.newPublicationChecked = $rootScope.newPublicationChecked.filter(
								elem => value.idMovProcessoCliente !== elem.idMovProcessoCliente
							);
							$rootScope.newPublicationChecked = [];
						}

						const hasTrue = $scope.movements.items.some(
							item => item.__checked__
						);
						const hasFalse = $scope.movements.items.some(
							item => !item.__checked__
						);

						if (hasTrue) {
							if (hasFalse) {
								$('#check-all').prop('indeterminate', true);
								$scope.allSelected = false;
							} else {
								$('#check-all').prop('indeterminate', false);
								$('#check-all').prop('checked', true);
								$scope.movements.items.forEach(
									item => (item.__checked__ = true)
								);
							}
						}
					});
					const checked = $rootScope.newPublicationChecked;

					if (!checked || checked.length < 2) $scope.itemCheckedDisable = true;
					else $scope.itemCheckedDisable = false;
				}, 0);
			};

			/**
			 * marca os registros selecionados caso usuario mude pagina ou realize
			 * outra ação que precise manter os registros
			 */
			$scope.checkSelected = () => {
				if (!!$rootScope.newPublicationChecked)
					$rootScope.newPublicationChecked.forEach(function(i) {
						$scope.movements.items.forEach(item =>
							i.idMovProcessoCliente === item.idMovProcessoCliente
								? (item.__checked__ = true)
								: item.__checked__
						);
					});
			};

			/**
			 * Metodo auto-invocável que verifica se tem registro selecionados,
			 * para habilitar ou não as ações em lote
			 */
			($scope.showPubGroupIcons = () => {
				const checked = $rootScope.newPublicationChecked;

				if (!checked || checked.length < 2) $scope.itemCheckedDisable = true;
				else $scope.itemCheckedDisable = false;
			})();

			//****************** FIM dos MÉTODOS de MARCAÇÃO ******************

			//************ Métodos relacionados a pasta processos *************
			/** Sidebar */
			$scope.showSidebar = {
				show: false
			};

			/**
			 * metodo para mostrar ou não side bar com detalhes do processo dentro
			 * pasta processo
			 */
			$scope.showEspecifcSidebar = (id, idFonte) => {
				$scope.showSidebar.show = !$scope.showSidebar.show;

				if (id) $scope.showSidebar.idFonteProcesso = id;

				if (idFonte) $scope.showSidebar.idFonte = idFonte;
			};

			/** Filtro fonte processos*/
			$scope.filterByIdFonte = item =>
				$scope.showSidebar.idFonteProcesso == item.idFonteProcesso;

			$scope.filterByIdentificadorId = item => $scope.showSidebar.id == item.id;

			$scope.lastDate = item => {
				if (!item || !Array.isArray(item)) return null;

				// Ordena os itens com base na propriedade `dataHoraAndamentoProcesso`
				const sortedItem = item
					.filter(entry => entry.hasOwnProperty('dataHoraAndamentoProcesso'))
					.sort((a, b) =>
						b.dataHoraAndamentoProcesso.localeCompare(
							a.dataHoraAndamentoProcesso
						)
					);

				// Retorna o primeiro item (mais recente)
				return sortedItem.length > 0 ? sortedItem[0] : null;
			};

			$scope.filterCabecalho = item =>
				item.idSituacaoPesquisaProcessoUsuarioCliente == -1 ||
				item.idSituacaoPesquisaProcessoUsuarioCliente == -7 ||
				item.idSituacaoPesquisaProcessoUsuarioCliente == -9;

			$scope.filterIdentificador = item =>
				item.dadosCabecalho.length || item.tiposSujeitos
					? item.tiposSujeitos.length
					: false;

			$scope.filterIgnorarJuiz = item =>
				item.sujeitos.filter(i => i.idTipoSujeitoProcesso != -4).length > 0;

			$scope.filterApenasJuiz = item =>
				item.sujeitos.filter(i => i.idTipoSujeitoProcesso == -4).length > 0;

			$scope.recordProcessHeader = async (responseStore, briefcase) => {
				responseStore.setReady(false);

				await $http({
					...helper.http(API.processHeaders, 'GET'),
					params: {
						ids: briefcase.idProcesso,
						campos: '*',
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null
					}
				})
					.then(response => {
						responseStore.setItems(response.data.itens[0]);
					})

					.finally(() => responseStore.setReady(true));
			};

			//************************** FIM dos MÉTODOS **************************

			//************ Chama pararametros de usuarios *************************

			$scope.recordParametersUsers = async () => {
				const userParamsSession = sessionStorage.getItem('parametros-usuarios');

				let dataParameterUsers = null;

				if (
					userParamsSession &&
					userParamsSession != undefined &&
					userParamsSession != 'undefined'
				) {
					dataParameterUsers = JSON.parse(userParamsSession);
				}
				let record = dataParameterUsers;

				if (record) {
					$scope.parameterUsers = record;

					/***************** GRID Variáveis **********************/
					$rootScope.grid =
						$scope.parameterUsers.idTipoVisualizacao == -1 ? false : true;
					$scope.exibirInfosGrid = $scope.parameterUsers.exibirInfo;
					/******************************************************/

					$scope.idQtdItensPagina = $scope.parameterUsers.idParamUsuarioProdAdv;
					$scope.quantityPerPage = $scope.parameterUsers.qtdRegistroMovPorPagina
						? $scope.parameterUsers.qtdRegistroMovPorPagina
						: 20;

					return;
				}

				await $http({
					...helper.http(API.parametersUsers, 'GET'),
					params: {
						...helper.httpFields(['*'])
					}
				})
					.then(({ data: { itens } }) => {
						if (itens.length) {
							$scope.parameterUsers = itens[0];
							$scope.parameterUsers.naoTipo = false;
							$scope.parameterUsers.idTipoVisualizacao = itens[0]
								.idTipoVisualizacao
								? itens[0].idTipoVisualizacao
								: -1;
							itens[0];
							$scope.parameterUsers.qtdRegistroMovPorPagina = itens[0]
								.qtdRegistroMovPorPagina
								? itens[0].qtdRegistroMovPorPagina
								: 20;
						} else {
							$scope.parameterUsers = {
								qtdRegistroMovPorPagina: 20,
								idTipoVisualizacao: -1,
								exibirInfo: true,
								naoTipo: true
							};
						}

						$scope.idQtdItensPagina =
							$scope.parameterUsers.idParamUsuarioProdAdv;
						$scope.quantityPerPage = $scope.parameterUsers
							.qtdRegistroMovPorPagina
							? $scope.parameterUsers.qtdRegistroMovPorPagina
							: 20;

						/***************** GRID Variáveis **********************/
						$rootScope.grid =
							$scope.parameterUsers.idTipoVisualizacao == -1 ? false : true;
						$scope.exibirInfosGrid = $scope.parameterUsers.exibirInfo;
						/******************************************************/

						sessionStorage.setItem(
							'parametros-usuarios',
							JSON.stringify($scope.parameterUsers)
						);

						if ($scope.parameterUsers.novaAgenda === undefined) {
							$scope.parameterUsers.novaAgenda = true;
						}

						sessionStorage.setItem(
							'__calendarGrid__',
							JSON.stringify($scope.parameterUsers.novaAgenda)
						);

						$rootScope.calendarGrid = $scope.parameterUsers.novaAgenda;
					})
					.finally(() => {
						let termUse = JSON.parse(localStorage.getItem('__acceptedTerms__'));

						termUse && $rootScope.popUps();
					});
			};

			//************************** FIM dos MÉTODOS **************************

			//************ Métodos relacionados a pasta publicações *************

			/**
			 * Metodo para trazer diarios somente com pesquisa ativa para mostrar
			 * dentro de pasta palavra chave
			 */
			$scope.recordActiveDiaries = (responseStore, briefcase) => {
				responseStore.setReady(false);
				$http({
					...helper.http(API.diaries, 'searchPublication'),
					params: {
						IdsPalavraChave:
							briefcase && briefcase.idPalavraChave
								? briefcase.idPalavraChave
								: null,
						IdGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null,
						SomenteComPesquisaAtiva: true
					}
				})
					.then(response => {
						const {
							data: { itens }
						} = response;

						responseStore.setItems(itens);
					})
					.finally(() => responseStore.setReady(true));
			};

			//Exibi mais diarios com pesquisa ativa
			$scope.expandActiveDiaries = () => {
				if ($scope.activesShowing < $scope.activeDiaries.getItems().length) {
					$scope.activesShowing += 10;
				} else {
					$scope.activesShowing = 10;
				}
			};

			//verifica o tipo de variação da palavra chave
			$scope.verifyVariations = value => {
				const pesquisa = value.filter(
					item =>
						item.idTipoPalavraChave === -2 &&
						[-1, -5, -4].includes(item.idSituacaoPalavraChave)
				);

				const exclusao = value.filter(
					item =>
						item.idTipoPalavraChave === -3 &&
						[-1, -5, -4].includes(item.idSituacaoPalavraChave)
				);

				const recusada = value.filter(
					item =>
						item.idSituacaoPalavraChave === -3 &&
						[-2, -3].includes(item.idTipoPalavraChave)
				);

				$scope.searchVariations.setItems(pesquisa);
				$scope.searchVariations.setReady(true);

				$scope.exclusions.setItems(exclusao);
				$scope.exclusions.setReady(true);

				$scope.declined.setItems(recusada);
				$scope.declined.setReady(true);
			};

			//Método para trazer variações
			$scope.recordKeyWordsVariations = (responseStore, briefcase) => {
				if ($scope.allOfAccount) return;

				if ($scope.paginateMovements) return;

				if ([-1, -2, -4].includes(briefcase.idSituacaoPalavraChave)) {
					$http({
						...helper.http(
							API.searchPublicationUserClient,
							'palavraChaveVariacoes',
							{
								ID: briefcase.idPalavraChave ? briefcase.idPalavraChave : null
							}
						),
						params: {
							...helper.httpFields(['*'])
						}
					})
						.then(({ data: { itens } }) => {
							const searchPublication = itens;

							$scope.verifyVariations(searchPublication);
						})
						.finally(() => responseStore.setReady(true));
				}
			};

			//**************** FIM dos MÉTODOS de PASTA PUBLICAÇÕES ****************

			/**
			 * Método para trazer diários para filtro de todos os diários.
			 * utilizados em todas da conta e pasta publicações
			 */
			$scope.recordDiaries = (responseStore, briefcase) => {
				responseStore.setReady(false);

				var idPalavraChave = null;

				if (briefcase)
					idPalavraChave = briefcase.idPalavraChave
						? briefcase.idPalavraChave
						: briefcase.palavraChave;

				$http({
					...helper.http(API.diaries, 'searchPublication'),
					params: {
						IdsPalavraChave: idPalavraChave != null ? idPalavraChave : null,
						IdGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null,
						SomenteComPesquisaAtiva: true
					}
				})
					.then(response => {
						const {
							data: { itens }
						} = response;

						itens.sort((a, b) => a.nomeDiario.localeCompare(b.nomeDiario));

						if (!$scope.filter.caderno || !$scope.filter.diario) {
							const e = itens.filter(e => e.idDiario == $scope.filter.diario);

							if (e.length === 0)
								$scope.clearFilter($scope.filter, ['caderno']);
						}

						responseStore.setItems(itens);

						if ($scope.filter.diario) {
							$scope.recordNotebook($scope.allNotebooks, $scope.filter.diario);

							const d = itens.filter(e => e.idDiario == $scope.filter.diario);

							if (d.length === 1)
								$scope.recordsFilters.nomeDiario = d[0].nomeDiario;
						}
					})
					.finally(() => responseStore.setReady(true));
			};

			/**
			 * Método para trazer cadernos para filtro de todos os cadernos,
			 * utilizados em todas da conta e pasta publicações
			 */
			$scope.recordNotebook = (responsestore, diarieId) => {
				let DataHoraInicio =
					moment($scope.filter.dataInicial).format('YYYY-MM-DD 00:00:00') ||
					null;
				let DataHoraFinal =
					moment($scope.filter.dataFinal).format('YYYY-MM-DD 23:59:59') || null;

				if (DataHoraInicio) {
					DataHoraInicio = DataHoraInicio.replace('T', ' ');
				}
				if (DataHoraFinal) {
					DataHoraFinal = DataHoraFinal.replace('T', ' ');
				}

				let keywords = '';

				if ($scope.keyWordAccount && $scope.keyWordAccount.length > 0) {
					$scope.keyWordAccount.forEach(k => {
						if (k.checked) {
							if (keywords.length > 0) keywords += ',';
							keywords += k.idPalavraChave;
						}
					});
				}
				if (keywords == '') keywords = null;

				$http({
					...helper.http(API.notebookUserGroup, 'GET'),
					params: {
						...helper.httpFields(['*']),
						IdsDiario: diarieId,
						paginaAtual: 1,
						registrosPorPagina: 999,
						SomenteComMovimentoAtivo: true,
						DataHoraInicio: DataHoraInicio,
						DataHoraFim: DataHoraFinal,
						Lido: $scope.filter.lido || null,
						IdsPalavrasChaves: keywords || null
					}
				})
					.then(({ data: { itens } }) => {
						if (itens)
							itens.sort((a, b) =>
								a.descricaoCadernoDiario.localeCompare(b.descricaoCadernoDiario)
							);

						responsestore.setItems(itens);

						if ($scope.filter.caderno) {
							const c = itens.filter(
								e => e.idCadernoDiario == $scope.filter.caderno
							);

							if (c.length === 1)
								$scope.recordsFilters.nomeCaderno = c[0].descricaoCadernoDiario;
						}
					})
					.finally(() => {
						responsestore.setReady(true);
					});
			};

			/**
			 * Recupera processos.
			 *
			 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
			 *
			 * @example
			 * // Cria uma instância de armazenamento de resposta.
			 * $scope.briefcase = helper.responseStore();
			 *
			 * // Recupera as aplicações.
			 * $scope.recordBriefcase($scope.briefcase);
			 */
			$scope.recordBriefcase = responseStore => {
				if ($scope.allOfAccount) {
					$scope.recordMovements($scope.movements);

					if ($scope.publicationPermission) {
						$scope.recordKeyWordsVariations($scope.keyWordsVariations, {
							idPalavraChave: null
						});
						$scope.environmentPageMov == '1' &&
							$scope.recordDiaries($scope.diaries);
					}

					return;
				}

				let pastaId = $stateParams.pasta;

				if (pastaId.length && /\D/.test(pastaId)) {
					pastaId = '';
				}
				if (
					typeof pastaId == 'string' &&
					(pastaId.length == 0 || pastaId.length > 18)
				) {
					const url = $location.$$url;

					if (url.includes('/movimentacoes/publicacoes')) {
						setTimeout(() => {
							const params = {};

							$state.transitionTo('root.default.movements.list', params, {
								inherit: false,
								reload: true
							});
						}, 1000);
					}
					if (url.includes('/movimentacoes/processos')) {
						setTimeout(() => {
							const params = {};

							$state.transitionTo(
								'root.default.movements.processList',
								params,
								{
									inherit: false
								}
							);
						}, 1000);
					}

					return;
				}

				const url = $location.$$url;

				if (
					(url.contains('/movimentacoes/publicacoes') &&
						!permissions.has('recordPublications')) ||
					(url.contains('/movimentacoes/processos') &&
						!permissions.has('createMovements'))
				) {
					setTimeout(() => {
						const params = {};

						$state.transitionTo('root.default.initial', params, {
							inherit: false,
							reload: true
						});
					}, 1000);

					return;
				}

				$http({
					...helper.http(API.briefcase, 'GET'),
					params: {
						registrosPorPagina: 20,
						ids: $stateParams.pasta,
						campos: '*',
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null
					}
				})
					.then(response => {
						let briefcase = response.data.itens[0] || false;

						if (briefcase) {
							responseStore.setItems(briefcase);

							$scope.folderType = briefcase.idTipoPasta;

							$rootScope.recordFolderToSubmenu(briefcase);

							if (briefcase.idTipoPasta == -3) {
								$scope.recordProcessHeader($scope.processHeader, briefcase);
							} else if (
								briefcase.idTipoPasta == -2 &&
								$scope.publicationPermission
							) {
								$scope.recordKeyWordsVariations(
									$scope.keyWordsVariations,
									briefcase
								);
								$scope.environmentPageMov == '1' &&
									$scope.recordDiaries($scope.diaries, briefcase);
								$scope.recordActiveDiaries($scope.activeDiaries, briefcase);
							}
						}

						if (!briefcase) {
							if ($scope.environmentPageMov == '4') $scope.notExistProc = true;
							else if ($scope.environmentPageMov == '3')
								$scope.notExistPubli = true;
						}

						$scope.recordMovements($scope.movements);
					})
					.finally(() => responseStore.setReady(true));
			};

			//**************************************************************/
			/**
			 * Métodos relacionados a filtros de todas da conta,
			 * pasta palavra chave
			 * */

			/**
			 * Método detecta se houve alteração no filtro de diário,
			 * para trazer cadernos
			 */
			$scope.changedNotebook = filter => {
				$scope.selectedFilter(filter);

				$scope.recordNotebook($scope.allNotebooks, filter.diario);
			};

			/**
			 * Método detecta se houve alteração no filtro de tribunais,
			 * para trazer fontes
			 */
			$scope.changedSources = filter => {
				$scope.selectedFilter(filter);

				const folder = $scope.briefcase.getItems();

				$scope.requestedProcessesSourcesParams.setReady(false);

				$scope.recordRequestedProcessesSourcesParams(folder.numeroProcesso);
			};

			/**
			 * Método detecta se houve alteração no filtro de movimentações,
			 * para limpar filtros se for andamentos
			 */
			$scope.changedMovements = filter => {
				if (filter.tipo == 'andamentos') {
					$scope.clearFilter(filter, ['palavraChave', 'diario', 'caderno']);

					if ($scope.environmentPageMov == '5') {
						if ($scope.keyWordAccount)
							$scope.clearAppointments('key', $scope.keyWordAccount);
						if ($scope.diaryAccount)
							$scope.clearAppointments('diary', $scope.diaryAccount);
						if ($scope.notebooksAccount)
							$scope.clearAppointments('notebook', $scope.notebooksAccount);
					}

					if ($scope.environmentPageMov == '1') {
						if ($scope.keyWordAccount)
							$scope.clearAppointments('key', $scope.keyWordAccount);
						if ($scope.diaryAccount)
							$scope.clearAppointments('diary', $scope.diaryAccount);
						if ($scope.notebooksAccount)
							$scope.clearAppointments('notebook', $scope.notebooksAccount);
					}
				}

				$scope.selectedFilter(filter);
			};

			/**
			 * Método detecta se houve alteração no filtro de palavras chave,
			 * para trazer diários
			 */
			$scope.changedDiary = filter => {
				$scope.selectedFilter(filter);

				$scope.recordDiaries($scope.diaries, filter);
			};

			/**
			 * Método detecta se houve alteração no filtro de périodos,
			 * para para verificar e para limpar filtros ou não
			 */
			$scope.changedPeriods = (value, clear) => {
				if (clear) {
					localStorage.setItem('__allowFilters__', true);

					$scope.clearData = true;

					$scope.filter.dataInicial = undefined;
					$scope.filter.dataFinal = undefined;

					if (
						$rootScope.pageSelected == 'Key' ||
						$rootScope.pageSelected == 'pastaPubli' ||
						$rootScope.pageSelected == 'keyword' ||
						($rootScope.pageSelected == undefined &&
							$location.$$url.includes('/publicacoes'))
					) {
						let dataFinal = new Date();
						let dataInicial = new Date();

						dataFinal.setHours(23, 59, 59);
						dataInicial.setDate(dataFinal.getDate() - 14);
						dataInicial.setHours(0, 0, 0);

						$scope.filter.dataInicial = dataInicial.toISOString();
						$scope.filter.dataFinal = dataFinal.toISOString();

						if (!$scope.previousFilters) {
							$scope.previousFilters = {};
						}

						$scope.previousFilters.dataInicial = $scope.filter.dataInicial;
						$scope.previousFilters.dataFinal = $scope.filter.dataFinal;
					}

					$rootScope.dateMovements = [];
					$rootScope.dateMovements[0] = $scope.filter.dataInicial;
					$rootScope.dateMovements[1] = $scope.filter.dataFinal;

					$rootScope.dataSelecionada = false;
					$scope.allPeriods(clear);

					$scope.updateDataSource();
				}
			};

			$scope.changeDataRange = dateArr => {
				if (dateArr.length > 1) {
					$scope.filter.dataInicial = dateArr[0];
					$scope.filter.dataFinal = dateArr[1];
					$scope.changedPeriods(dateArr);
				}
			};

			$rootScope.$$listeners['air-datepicker-range-change'] = [];
			$rootScope.$on('air-datepicker-range-change', (event, params) => {
				if ($location.$$url.contains('/movimentacoes')) {
					if (params && params.date && params.date.length == 2) {
						$scope.filter.dataInicial = params.date[0];
						$scope.filter.dataFinal = params.date[1];

						$scope.dateSource = {
							value: params.formattedDate
						};
					} else if (params && params.date.length == 1) {
						$scope.updateDataSource(params.formattedDate);
						$scope.dateSource = {
							value: params.formattedDate
						};
					} else if (params && params.date.length == 0) {
						$scope.updateDataSource();
						if ($scope.filter.dataInicial) delete $scope.filter.dataInicial;
						if ($scope.filter.dataFinal) delete $scope.filter.dataFinal;
					}

					if (
						$rootScope.$$phase !== '$apply' &&
						$rootScope.$$phase !== '$digest'
					) {
						$rootScope.$apply();
					}
					$scope.diaryChanges = true;
				}
			});

			$rootScope.isAirDatepickerRangeOpen = false;
			$scope.onClickAirDatepickerRange = () => {
				if ($rootScope.isAirDatepickerRangeOpen) {
					$('#air-datepicker-range').trigger('blur');
				} else {
					$('#air-datepicker-range').trigger('focus');
				}
			};

			/**
			 * Método que verifica se esta na pasta publicações para mudar o nome,
			 * do filtro ultimos 15 dias
			 */
			$scope.allPeriods = clear => {
				const e = document.getElementById('air-datepicker-range');

				const value = e.value.indexOf('até');
				const valueFolderType = e.value.indexOf('últimos');

				if (
					value > 0 &&
					clear &&
					($rootScope.pageSelected == 'pastaPubli' ||
						$rootScope.pageSelected == 'Key')
				) {
					e.value = 'Período - últimos 15 dias';
					$rootScope.periodsFolderType = true;
				} else if (value > 0 && clear) {
					$scope.filter.dataInicial = null;
					$scope.filter.dataFinal = null;

					e.value = 'Todos períodos';
				} else if (e.value !== 'Todos períodos' && valueFolderType < 0) {
					if ($rootScope.dateMovements.length > 1) {
						$scope.filter.dataInicial = $rootScope.dateMovements[0];
						$scope.filter.dataFinal = $rootScope.dateMovements[1];

						if (!$scope.previousFilters) {
							$scope.previousFilters = {};
						}
						$scope.previousFilters.dataInicial = $scope.filter.dataInicial;
						$scope.previousFilters.dataFinal = $scope.filter.dataFinal;
					}
				}
			};

			/**
			 * Método para verificar se existe filtros
			 */
			$scope.selectedFilter = filters => {
				$scope.diaryChanges = true;

				var value = filters;

				let filterKeys = Object.keys(movementsFiltersNames).filter(
					e => e !== 'pasta' && e !== 'q' && e !== 'p'
				);

				Object.keys(filters).some(key => {
					filterKeys.some(_key => {
						var e = key === _key && value[key] != undefined;

						if (e) $scope.existFilter = e;
					});
				});

				if (filters.length === 0) $scope.existFilter = false;
			};

			$scope.selectedFilter($scope.filter);

			//********************** FIM dos MÉTODOS *************************

			//Médoto que tratara filtros selecionados pelo usuário
			$scope.filterMovements = (filters, clear) => {
				/*
				Pega no localStorage o dateRangeHasMovements, onde é guardado se a data selecionada possui movimentações.
				Se não existir; Ou se existir, mas não houver movimentos; Ou se existir, mas as datas forem diferentes das datas selecionadas:
				Ele valida se a página atual tem movimentações, e usa essa informação para guardar se esse dataRange deve permanecer com os filtros ativos ou não.
				*/
				let dateRangeHasMovements = localStorage.getItem(
					'__dateRangeHasMovements__'
				);

				if (dateRangeHasMovements) {
					dateRangeHasMovements = JSON.parse(dateRangeHasMovements);
				}

				if (
					$scope.badgeFilterDate &&
					$scope.badgeFilterDate.dataInicial &&
					$scope.badgeFilterDate.dataFinal &&
					(!dateRangeHasMovements ||
						(dateRangeHasMovements &&
							dateRangeHasMovements.dataInicial &&
							dateRangeHasMovements.dataFinal &&
							!(
								compareDates(
									$scope.badgeFilterDate.dataInicial,
									dateRangeHasMovements.dataInicial
								) &&
								compareDates(
									$scope.badgeFilterDate.dataFinal,
									dateRangeHasMovements.dataFinal
								)
							)) ||
						(dateRangeHasMovements && !dateRangeHasMovements.hasMovements))
				) {
					if (
						$scope.movements &&
						$scope.movements.items &&
						$scope.movements.items.length &&
						$scope.movements.items.length > 0
					) {
						dateRangeHasMovements = {
							dataInicial: $scope.badgeFilterDate.dataInicial,
							dataFinal: $scope.badgeFilterDate.dataFinal,
							hasMovements: true
						};

						localStorage.setItem(
							'__dateRangeHasMovements__',
							JSON.stringify(dateRangeHasMovements)
						);
					} else {
						dateRangeHasMovements = {
							dataInicial: $scope.badgeFilterDate.dataInicial,
							dataFinal: $scope.badgeFilterDate.dataFinal,
							hasMovements: false
						};
					}
				}

				if (
					dateRangeHasMovements &&
					filters &&
					dateRangeHasMovements.dataInicial &&
					dateRangeHasMovements.dataFinal &&
					filters.dataInicial &&
					filters.dataFinal &&
					compareDates(
						dateRangeHasMovements.dataInicial,
						filters.dataInicial
					) &&
					compareDates(dateRangeHasMovements.dataFinal, filters.dataFinal) &&
					dateRangeHasMovements.hasMovements
				) {
					localStorage.setItem(
						'__allowFilters__',
						dateRangeHasMovements.hasMovements
					);
				} else {
					localStorage.setItem('__allowFilters__', false);
				}

				//verificar se e necessario
				localStorage.setItem('__removeClass__', true);
				$scope.allPeriods(clear);

				if ($stateParams.pasta) filters.pasta = $stateParams.pasta;

				filters.p = $stateParams.p;

				if (filters.valorParametro && !filters.fonte) {
					delete filters.valorParametro;
				}

				if (filters.tipo === 'andamentos') {
					delete filters.palavraChave;
					delete filters.diario;
					delete filters.caderno;
				}

				if (
					filters &&
					filters.dataInicial != undefined &&
					filters.dataInicial != null
				) {
					const final = filters.dataFinal;
					const Inicial = filters.dataInicial;

					filters.dataFinal = moment(final).format('YYYY-MM-DDTHH:mm:ss');
					filters.dataInicial = moment(Inicial).format('YYYY-MM-DDTHH:mm:ss');
				}

				if (
					($scope.environmentPageMov == '2' &&
						$stateParams.folderType != '-2') ||
					$scope.environmentPageMov == '5' ||
					$scope.environmentPageMov == '3' ||
					$scope.environmentPageMov == '1'
				) {
					($scope.environmentPageMov == '2' ||
						$scope.environmentPageMov == '5' ||
						$scope.environmentPageMov == '1') &&
						$scope.keyWordAccount &&
						$scope.verifyFilters.keyword(filters);
					$scope.diaryAccount && $scope.verifyFilters.diary(filters);
					$scope.notebooksAccount && $scope.verifyFilters.notebook(filters);
				}

				if (
					filters.diario ||
					filters.caderno ||
					filters.palavraChave ||
					filters.lido ||
					filters.pesquisa
				) {
					let selecionados = {
						IdsCadernos: filters.caderno,
						IdsDiarios: filters.diario,
						IdsPalavraChave: filters.palavraChave,
						Lido: filters.lido,
						pesquisa: filters.pesquisa
					};

					sessionStorage.setItem('__selected__', JSON.stringify(selecionados));
					delete filters.diario;
					delete filters.caderno;
					delete filters.palavraChave;
					delete filters.lido;
					delete filters.pesquisa;
				} else {
					sessionStorage.removeItem('__selected__');
				}

				filters.paginaAtual = undefined;
				sessionStorage.setItem('__pageMovements__', 1);

				if (
					!angular.equals(filters, $stateParams) &&
					$rootScope.pageSelected != 'pastaPubli' &&
					$rootScope.pageSelected != 'Key'
				) {
					$state.transitionTo($state.current.name, filters, {
						inherit: false,
						reload: `root.default.movements.list${$scope.environmentPageMov}`
					});
				} else if (
					$rootScope.pageSelected == 'pastaPubli' ||
					$rootScope.pageSelected == 'Key'
				) {
					$rootScope.datePeriods(filters);
				}

				$rootScope.cleanSelectedMov();
			};

			/**
			 * Médoto que verifica se existe algum registro selecionado nos
			 * filtros de palavras chave, diários, cadernos
			 * na pagina de publicações geral
			 */
			$scope.verifyFilters = {
				keyword: filters => {
					var idsPalavras = [];

					$scope.keyWordAccount.forEach(k => {
						if (k.checked) idsPalavras.push(k.idPalavraChave);
					});

					idsPalavras.length
						? (filters.palavraChave = idsPalavras.join(','))
						: delete filters.palavraChave;

					idsPalavras.length
						? localStorage.setItem(
								'__keywordsChecked__',
								JSON.stringify($scope.keyWordAccount.filter(k => k.checked))
						  )
						: localStorage.removeItem('__keywordsChecked__');
				},
				diary: filters => {
					var idsDiarios = [];

					$scope.diaryAccount.forEach(k => {
						if (k.checked) idsDiarios.push(k.idDiario);
					});

					idsDiarios.length
						? (filters.diario = idsDiarios.join(','))
						: delete filters.diario;

					idsDiarios.length
						? localStorage.setItem(
								'__diarysChecked__',
								JSON.stringify($scope.diaryAccount.filter(k => k.checked))
						  )
						: localStorage.removeItem('__diarysChecked__');
				},
				notebook: filters => {
					if ($scope.notebooksAccount) {
						var idsCadernos = [];

						$scope.notebooksAccount.forEach(k => {
							if (k.checked) idsCadernos.push(k.idCadernoDiario);
						});

						idsCadernos.length
							? (filters.caderno = idsCadernos.join(','))
							: delete filters.caderno;

						idsCadernos.length
							? localStorage.setItem(
									'__notebooksChecked__',
									JSON.stringify($scope.notebooksAccount.filter(k => k.checked))
							  )
							: localStorage.removeItem('__notebooksChecked__');
					}
				}
			};

			/**
			 * Método detecta se houve alteração no filtro de fontes,
			 * para salvar id de fonte e valor do Parametro
			 */
			$scope.beforeFilterBySourceParams = (composedId = '') => {
				composedId = composedId.toString();

				const [processSourceId, parameterValueId] = composedId.split('.');

				$scope.filter.composedId = composedId;

				if (processSourceId) $scope.filter.fonte = processSourceId;

				if (parameterValueId) $scope.filter.valorParametro = parameterValueId;
			};

			/**
			 * Método verifica se existe perido selecionado dentro de pasta publicação
			 */
			$scope.verifyPeriods = arr => {
				if (
					(arr[0] == 'dataInicial' || arr.length == 0) &&
					$rootScope.pageSelected == 'Key'
				)
					$rootScope.periodsFolderType = true;
			};

			/**
			 * Método para limpar filtros
			 */
			$scope.clearFilter = (f, arr, clearAll = false) => {
				$scope.verifyPeriods(arr);

				if (clearAll) arr = types;

				arr.map(item => delete f[item]);

				if (JSON.stringify(f) === JSON.stringify({})) f = [];

				$scope.selectedFilter(f);

				if (clearAll) $scope.filterMovements($scope.filter, clearAll);
				if (!clearAll) filterSelect.removeOption(arr);
			};

			$scope.clearFilter($scope.filter, ['#', 'authentication', 'pasta', 'p']);

			/**
			 * Método para limpar filtros selecionados dos badges
			 */
			$scope.clearFilterSelected = (f, arr, clearAll = false) => {
				$scope.verifyPeriods(arr);

				arr.map(item => delete f[item]);

				if (clearAll) $scope.filterMovements($scope.filter, clearAll);
			};

			//Médoto que verifica se existe filtro
			$scope.hasFilter = filters => {
				if (filters && filters.dataInicial && filters.dataFinal) {
					if (
						moment(new Date(filters.dataInicial)).format('YYYY-MM-DD') ==
							moment(new Date(dataInicialPadrao)).format('YYYY-MM-DD') &&
						moment(new Date(filters.dataFinal)).format('YYYY-MM-DD') ==
							moment(new Date(dataFinalPadrao)).format('YYYY-MM-DD')
					) {
						delete filters.dataInicial;
						delete filters.dataFinal;
					}
				}

				if ($scope.periodsFolderType) {
					delete filters.dataInicial;
					delete filters.dataFinal;
				}

				let filterKeys = Object.keys(movementsFiltersNames).filter(
					e => e !== 'pasta' && e !== 'q' && e !== 'p'
				);

				let selects = sessionStorage.getItem('__selected__');

				if (selects) return true;

				return Object.keys(filters).some(key =>
					filterKeys.some(
						_key => key === _key && $stateParams[key] != undefined
					)
				);
			};

			//Médoto que verifica se existe filtro
			$scope.hasFilterNew = () => {
				const url = $location.$$url;

				if (
					url.includes('/movimentacoes/publicacoes') &&
					$scope.movementsPagesLength != 0
				) {
					localStorage.setItem('__allowFilters__', true);

					return true;
				}

				if (
					url.includes('/movimentacoes/todas-conta') ||
					url.includes('/movimentacoes/processos/') ||
					url.includes('/movimentacoes/lixeira') ||
					($scope.filter &&
						($scope.filter.diario ||
							$scope.filter.lido ||
							$scope.filter.palavraChave ||
							$scope.filter.caderno ||
							$scope.filter.pesquisa))
				) {
					localStorage.setItem('__allowFilters__', true);

					return true;
				}

				/*
				No caso do previousFilters estar vazio, ele tentará pegar a
				informação do filter.dataInicial e filter.dataFinal, ou será
				definido como undefined
				*/
				if (!$scope.previousFilters) {
					if (Object.keys($scope.filter).length > 1) {
						$scope.previousFilters = {
							dataInicial: $scope.filter.dataInicial,
							dataFinal: $scope.filter.dataFinal
						};
					} else {
						$scope.previousFilters = {
							dataInicial: undefined,
							dataFinal: undefined
						};
					}
				}

				if (
					$rootScope.dateMovements &&
					$rootScope.dateMovements[0] &&
					$rootScope.dateMovements[1]
				) {
					$scope.filter.dataInicial = $rootScope.dateMovements[0];
					$scope.filter.dataFinal = $rootScope.dateMovements[1];
				}
				/*
				No caso da data do filtro ser alterada e ficar diferente da data anterior
				A data anterior deverá ser alterada e os filtros deverão ser habilitados novamente
				*/
				if (
					$scope.filter &&
					$scope.filter.dataInicial &&
					$scope.filter.dataFinal &&
					$scope.previousFilters &&
					!(
						$scope.filter.dataInicial === $scope.previousFilters.dataInicial &&
						$scope.filter.dataFinal === $scope.previousFilters.dataFinal
					)
				) {
					if (
						$scope.previousFilters.dataInicial &&
						$scope.previousFilters.dataInicial
					) {
						localStorage.setItem('__allowFilters__', true);
					}

					$scope.previousFilters.dataInicial = $scope.filter.dataInicial;
					$scope.previousFilters.dataFinal = $scope.filter.dataFinal;
				}

				var dados = [];

				let campos = [
					'existFilter',
					'hasKeyWords',
					'hasDiary',
					'dataSelecionada'
				];
				let valor = false;

				let saved = $scope.hasFilter($scope.stateParamsFilter);

				campos.forEach(value => {
					if ($scope[value]) valor = true;
				});

				if ($scope.filter && $scope.environmentPageMov == '3') {
					let filterKeys = Object.keys(movementsFiltersNames).filter(
						e =>
							e !== 'pasta' &&
							e !== 'q' &&
							e !== 'p' &&
							e !== 'dataInicial' &&
							e !== 'dataFinal'
					);

					[$scope.filter, $stateParams].forEach(data => {
						filterKeys.forEach(key => {
							var e = data[key] ? data[key] : false;

							if (e) dados.push({ [key]: e });
						});
					});

					if (
						!dados.length &&
						$rootScope.periodsFolderType &&
						!$scope.hasDiary &&
						!$rootScope.periodsFolderTypeSelected
					)
						valor = false;

					if (valor && !$rootScope.periodsFolderType) valor = true;
				}

				if (!$scope.filter.pesquisa) delete $scope.filter.pesquisa;

				if (
					$.isEmptyObject($scope.filter) &&
					$scope.environmentPageMov == '2' &&
					!$rootScope.periodsSubpoena
				)
					valor = false;

				if ($scope.clearData) valor = true;

				if ($scope.keyWordCheckTotal && $scope.keyWordCheckTotal.length)
					valor = true;

				let allowFilters = localStorage.getItem('__allowFilters__');

				if (allowFilters) {
					allowFilters = JSON.parse(allowFilters);
				} else {
					allowFilters = true;
				}

				if ($scope.movements.hasNotItems() && !allowFilters) {
					return false;
				}

				return (saved && (valor || !valor)) || (!saved && valor) ? true : false;
			};

			/**
			 * Recupera movimentações.
			 *
			 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
			 *
			 * @example
			 * // Cria uma instância de armazenamento de resposta.
			 * $scope.movements = helper.responseStore();
			 *
			 * // Recupera as aplicações.
			 * $scope.recordMovements($scope.movements);
			 */
			$scope.recordMovements = async responseStore => {
				$scope.blockRequestTryAgain = true;
				setTimeout(() => {
					/** Define os filtros informados na URL. */
					//Recupera pagina da listagem salva
					const page = sessionStorage.getItem('__pageMovements__');

					!page &&
						sessionStorage.setItem(
							'__pageMovements__',
							responseStore.getCurrentPage()
						);

					responseStore.setCurrentPage(
						sessionStorage.getItem('__pageMovements__')
					);

					queryConvert().map(name => {
						let movementFilter = movementsFiltersNames[name.key];

						if (movementFilter) {
							if (movementFilter.enum)
								name.value = movementFilter.enum[name.value];

							if (Array.isArray(movementFilter.request))
								movementFilter.request.map(param =>
									$scope.movements.setFilter(param, name.value)
								);
							else
								$scope.movements.setFilter(movementFilter.request, name.value);
						}
					});

					if (
						!responseStore.getFilters().DataMovimentoInicio &&
						($rootScope.pageSelected == 'Key' ||
							$rootScope.pageSelected == 'pastaPubli')
					) {
						const dataInicial = new Date();

						const I = new Date(
							dataInicial.getFullYear(),
							dataInicial.getMonth(),
							dataInicial.getDate() - 14
						);

						const inicial = moment(I).format('YYYY-MM-DDT00:00:00');
						const final = moment(dataInicial).format('YYYY-MM-DDT23:59:59');

						$scope.movements.setFilter('DataMovimentoInicio', inicial);
						$scope.movements.setFilter('DataMovimentoFim', final);
					}

					$scope.clearData = false;

					if (!!responseStore.filters.pesquisa)
						responseStore.filters.pesquisa = $scope.filter.pesquisa;

					const quantity = $scope.quantityPerPage || 20;

					let parameter = {};

					$scope.valueAllOfAccountStorage = sessionStorage.getItem(
						'__allOfAccount__'
					);

					const pastaProcess = JSON.parse(
						sessionStorage.getItem('__processPaste__')
					);
					const pastaPubli = JSON.parse(
						sessionStorage.getItem('__publicationPaste__')
					);

					$scope.environmentPageMov == '2' && !pastaProcess && !pastaPubli
						? (parameter = { idTipoMovProcesso: -2 })
						: (parameter = {});

					if ($scope.environmentPageMov == '5') parameter = {};

					const rota = $scope.allOfAccount
						? API.movementsClients
						: API.movements;

					const method = $scope.allOfAccount ? 'POST' : 'GET';

					let selecionados = JSON.parse(sessionStorage.getItem('__selected__'));

					if (selecionados) {
						responseStore.filters.IdsCadernos = selecionados.IdsCadernos;
						responseStore.filters.IdsDiarios = selecionados.IdsDiarios;
						responseStore.filters.IdsPalavraChave =
							selecionados.IdsPalavraChave;

						responseStore.filters.Lido = selecionados.Lido;
						responseStore.filters.pesquisa = selecionados.pesquisa;
					}

					const userParamsSession = sessionStorage.getItem(
						'parametros-usuarios'
					);

					let dataParameterUsers = null;

					if (
						userParamsSession &&
						userParamsSession != undefined &&
						userParamsSession != 'undefined'
					) {
						dataParameterUsers = JSON.parse(userParamsSession);
					}

					let record = dataParameterUsers;

					if (method == 'GET') {
						var req = $http({
							...helper.http(rota, method),
							params: {
								...helper.httpFields(['*']),
								...parameter,
								ordenacao: '-dataHoraInclusao',
								paginaAtual: responseStore.getCurrentPage(),
								possuiDataLixeira:
									$scope.environmentPageMov == '5' ? true : false,
								registrosPorPagina: quantity,
								idGrupoUsuarios:
									$scope.groupUserSelected && $scope.groupData
										? $scope.groupData.idGrupo
										: null,
								...responseStore.getFilters()
							}
						});
					} else {
						var req = $http({
							...helper.http(rota, method),
							data: {
								itens: [
									{
										...parameter,
										ordenacao: '-dataHoraInclusao',
										paginaAtual: responseStore.getCurrentPage(),
										possuiDataLixeira:
											$scope.environmentPageMov == '5' ? true : false,
										registrosPorPagina: record.qtdRegistroMovPorPagina || 20,
										idGrupoUsuarios:
											$scope.groupUserSelected && $scope.groupData
												? $scope.groupData.idGrupo
												: null,
										...responseStore.getFilters()
									}
								]
							},
							messageOverride: {
								success() {},
								error() {}
							}
						});
					}

					req
						.then(({ data }) => {
							responseStore.setItems(data.itens);
							sessionStorage.setItem(
								'__pageMovements__',
								responseStore.getCurrentPage()
							);

							const filters = responseStore.getFilters();
							const hasItems = data.itens && data.itens.length > 0;

							const hasOnlyIdPastaUsuarioCliente =
								Object.keys(filters).length === 1 &&
								filters.hasOwnProperty('IdPastaUsuarioCliente');

							if (hasOnlyIdPastaUsuarioCliente) {
								$scope.hasNotList = !hasItems;
							} else {
								$scope.hasNotList = false;
							}

							if (!location.pathname.includes('detalhes')) {
								sessionStorage.paginacao = JSON.stringify(data.paginacao);

								sessionStorage.filters = JSON.stringify(
									responseStore.getFilters() || null
								);

								sessionStorage.movements = JSON.stringify(
									data.itens.map(item => {
										return {
											id: item.movimento.id,
											type: item.movimento.idTipoMovProcesso,
											hasLinkedDeadline:
												item.movimento.prazosAvencer ||
												item.movimento.prazosVencido
										};
									})
								);
							}

							$scope.movementsLength = data.paginacao
								? data.paginacao.registrosTotal
								: 0;

							$scope.movementsPagesLength = Math.ceil(
								$scope.movementsLength / quantity
							);

							$scope.checkSelected();

							$.extend($scope.pagination, {
								paginaAtual: responseStore.getCurrentPage(),
								paginaTotal: data.paginacao.paginaTotal,
								quantiaPorPagina: quantity,
								hasNext:
									responseStore.getCurrentPage() < $scope.movementsPagesLength,
								totalItens: data.paginacao ? data.paginacao.registrosTotal : 0
							});

							// aqui chamava orgãos

							const folder = $scope.briefcase.getItems();

							if ($stateParams.orgaoJudicial) $scope.getCourts();
							if ($stateParams.composedId)
								$scope.recordRequestedProcessesSourcesParams(
									folder.numeroProcesso
								);

							$scope.listingHibben = false;

							if ($scope.sendORestore)
								$scope.sendORestore == 'restore'
									? ($scope.restore = false)
									: ($scope.send = false);
							if ($scope.deleteDefinitive) $scope.deleteDefinitive = false;

							setTimeout(() => {
								if (
									$scope.parameterUsers.exibirInfo &&
									data.itens.length &&
									$scope.environmentPageMov == '2'
								)
									$scope.viewInfos();
							}, 3000);
						})
						.catch(error => {
							if (
								$scope.environmentPageMov == '1' ||
								$scope.environmentPageMov == '2' ||
								$scope.environmentPageMov == '3'
							) {
								if (error.status === 500) {
									$scope.tryAgainScreen = true;
									$scope.blockRequestTryAgain = false;
								} else {
									$scope.blockRequestTryAgain = false;
									$scope.tryAgainScreen = false;
								}
							}

							$scope.sendORestore == 'restore'
								? ($scope.restore = false)
								: ($scope.send = false);

							if ($scope.deleteDefinitive) $scope.deleteDefinitive = false;
						})
						.finally(() => {
							responseStore.setReady(true);
							$scope.listingHibben = false;
						});
				}, 400);
			};

			/**
			 * Método para vefiricar nome da página
			 */
			$scope.getFolderName = briefcase => {
				$scope.recordValuesAccount();

				if ($scope.environmentPageMov == '5') {
					return 'Lixeira';
				}

				const title =
					$scope.environmentPageMov == '1' && $stateParams.folderType != -2
						? 'Todas da conta'
						: $scope.environmentPageMov == '2'
						? 'Publicações'
						: null;

				if (title) {
					return title;
				}

				const brief = briefcase.getItems();

				$scope.loadingTitle = false;

				if (!$scope.rename.nome && !$scope.rename.loaded) {
					$scope.rename.nome = brief.nome || '';
					$scope.rename.loaded = true;
				}

				if (brief.nome == '') {
					return brief.numeroProcesso;
				} else if ($scope.notExistProc || $scope.notExistPubli) {
					return $scope.notExistProc
						? 'Processo não encontrado'
						: 'Publicação não encontrada';
				} else {
					return brief.nome || 'Todas da conta';
				}
			};

			/**
			 * Método que traz Órgãos Judiciais relacionadas ao processo
			 */
			$scope.recordRequestedProcessesJudicialOrgans = processNumber => {
				$scope.clientUserJudicialOrgansList.setReady(false);
				$http({
					...helper.http(API.requestedProcessesJudicialOrgans, 'GET'),
					params: {
						...helper.httpFields(['idOrgaoJudiciario,nomeOrgaoJudiciario']),
						numeroProcesso: processNumber
					}
				})
					.then(({ data: { itens = [] } }) => {
						$scope.clientUserJudicialOrgansList.setItems(itens);

						if ($stateParams.orgaoJudicial) {
							const o = itens.filter(
								o => o.idOrgaoJudiciario == $stateParams.orgaoJudicial
							);

							if (o.length === 1)
								$scope.recordsFilters.nomeOrgaoJudiciario =
									o[0].nomeOrgaoJudiciario;
						}
					})
					.finally(() => {
						$scope.clientUserJudicialOrgansList.setReady(true);

						if ($stateParams.orgaoJudicial) {
							$scope.titleCourts = $scope.clientUserJudicialOrgansList
								.getItems()
								.filter(
									item => item.idOrgaoJudiciario == $stateParams.orgaoJudicial
								)[0].nomeOrgaoJudiciario;
						}

						$scope.clientUserJudicialOrgansList.hasItems()
							? ($scope.notCourts = false)
							: ($scope.notCourts = true);
					});
			};

			/**
			 * Método que traz registros do filtro de todos identificadores
			 */
			$scope.recordRequestedProcessesSameNumberRelatedProcess = processNumber => {
				$scope.identifiersFilterRequest = $http({
					...helper.http(API.requestedProcessesSameNumberRelatedProcess, 'GET'),
					params: {
						...helper.httpFields(['*']),
						numeroProcesso: processNumber
					}
				})
					.then(({ data: { itens = [] } }) => {
						$scope.identifiersFilterList.setItems(itens);
						$scope.identifiersFilterHasNoResults = !itens.length;
						$scope.identifiersFilterLoadedProcessNumber = processNumber;
					})
					.finally(() => {
						$scope.identifiersFilterLoading = false;
					});

				return $scope.identifiersFilterRequest;
			};

			$scope.loadIdentifiersFilter = () => {
				const folder = $scope.briefcase.getItems();
				const processNumber = folder && folder.numeroProcesso;

				if (!processNumber || $scope.folderType !== -3) return;
				if ($scope.identifiersFilterLoadedProcessNumber === processNumber)
					return;
				if ($scope.identifiersFilterLoading)
					return $scope.identifiersFilterRequest;

				$scope.identifiersFilterLoading = true;
				$scope.identifiersFilterHasNoResults = false;
				$scope.identifiersFilterList.setItems([]);

				return $scope.recordRequestedProcessesSameNumberRelatedProcess(
					processNumber
				);
			};

			$scope.hasIdentifierFilterOption = identifier => {
				return $scope.identifiersFilterList
					.getItems()
					.some(item => item.identificacao === identifier);
			};

			/**
			 * Método que traz registros do filtro de todos fontes
			 */
			$scope.recordRequestedProcessesSourcesParams = processNumber => {
				$scope.requestedProcessesSourcesParams.setReady(false);
				$scope.readySourcesParams = true;

				$http({
					...helper.http(API.requestedProcessesSourcesParams, 'GET'),
					params: {
						...helper.httpFields(['*']),
						idOrgaoJudiciario: $scope.filter.orgaoJudicial,
						numeroProcesso: processNumber
					}
				})
					.then(({ data: { itens = [] } }) => {
						const sourceParamsList = [];

						itens.map(item => {
							const { idFontePesquisa, nomeFontePesquisa, parametros } = item;

							if (!parametros.length)
								sourceParamsList.push({
									composedId: idFontePesquisa,
									idFontePesquisa,
									nomeFontePesquisa
								});
							else
								parametros.map(param => {
									const {
										nomeValorParamFontePesq,
										idValorParamFontePesq
									} = param;

									sourceParamsList.push({
										composedId: `${idFontePesquisa}.${idValorParamFontePesq}`,
										idFontePesquisa,
										nomeFontePesquisa: `${nomeFontePesquisa} - ${nomeValorParamFontePesq}`,
										idValorParamFontePesq
									});
								});
						});

						$scope.requestedProcessesSourcesParams.setItems(sourceParamsList);

						if ($stateParams.composedId) {
							const c = sourceParamsList.filter(
								c => c.composedId == $stateParams.composedId
							);

							if (c.length === 1)
								$scope.recordsFilters.nomeFontePesquisa =
									c[0].nomeFontePesquisa;

							$scope.titleSources = $scope.requestedProcessesSourcesParams
								.getItems()
								.filter(
									item => item.composedId == $stateParams.composedId
								)[0].nomeFontePesquisa;
						}
					})
					.finally(() => {
						$scope.requestedProcessesSourcesParams.setReady(true);
						$scope.readySourcesParams = false;
						$scope.requestedProcessesSourcesParams.hasItems()
							? ($scope.notSources = false)
							: ($scope.notSources = true);
					});
			};

			/**
			 * Verifica se existe uma página anterior à atual.
			 */
			$scope.hasMovementsPrevPage = () => {
				let paginaAtual = JSON.parse(
					sessionStorage.getItem('__pageMovements__')
				);

				return paginaAtual > 1 ? true : false;
			};

			/**
			 * PAGINAÇÃO DA LISTAGEM DE MOVIMENTAÇÕES
			 */
			$scope.paginationMovements = toWhere => {
				$scope.listingHibben = true;
				let paginaAtual = JSON.parse(
					sessionStorage.getItem('__pageMovements__')
				);

				if (toWhere == 'first') paginaAtual = 1;
				else if (toWhere == 'last') paginaAtual = $scope.movementsPagesLength;
				else if (toWhere == 'prev') {
					let currentPage = paginaAtual ? Number(paginaAtual) : 1;

					paginaAtual = currentPage > 1 ? currentPage - 1 : 1;
				} else if (toWhere == 'next')
					paginaAtual = paginaAtual ? Number(paginaAtual) + 1 : 2;

				sessionStorage.setItem('__pageMovements__', paginaAtual);

				$scope.recordMovements($scope.movements);
			};

			//Marca movimentos da listagem como NÃO LIDAS
			$scope.setMovementsAsUnread = (responseStore, movements) => {
				if ($scope.printingUnread || $scope.printingUnreadInd) return;

				const individual = movements ? true : false;

				!individual
					? ($scope.printingUnread = true)
					: ($scope.printingUnreadInd = true);

				if (!movements)
					movements = responseStore.filter(
						item => item.__checked__ && item.lido
					);
				else movements = [movements];

				let movementsData = [];

				movements.map(movement => {
					let movementData = {
						id: movement.id,
						idMovProcessoCliente: movement.idMovProcessoCliente
					};

					if ($stateParams.pasta)
						movementData.pastasRelacionadas = movement.pastasMovimento.filter(
							pasta => pasta.id == $stateParams.pasta
						);

					if ($scope.groupUserSelected)
						movementData.idGrupoUsuarios = $scope.groupData.idGrupo;

					movementsData.push(movementData);
				});

				if (movementsData.length)
					$http({
						...helper.http(API.movementMarkAsUnread, 'PUT'),
						data: {
							itens: movementsData
						},
						messageOverride: {
							success(response, notify) {
								let message = '';

								const tipo = movements
									? movements[0].movimento.idTipoMovProcesso
									: null;

								if (tipo == -1)
									message =
										movementsData.length > 1
											? 'Os andamentos foram marcados como não lidos!'
											: 'O andamento foi marcado como não lido!';
								else if (tipo == -2)
									message =
										movementsData.length > 1
											? 'As publicações foram marcadas como não lidas!'
											: 'A publicação foi marcada como não lida!';
								else
									message =
										movementsData.length > 1
											? 'As movimentações foram marcadas como não lidas!'
											: 'A movimentação foi marcada como não lida!';

								notify.success(message);
							}
						},
						noCancelOnRouteChange: true
					})
						.then(response => {
							movements &&
								movements.map(item => {
									$.extend(item, { lido: false });
								});

							response.data.itens[0].forEach(r => {
								$scope.movements.getItems().forEach(m => {
									if (r.idMovProcessoCliente === m.idMovProcessoCliente)
										m.lido = false;
								});
							});
							movements && $scope.movements.rowbackItems(movements);
						})

						.finally(() => {
							setTimeout(() => {
								!individual
									? ($scope.printingUnread = false)
									: ($scope.printingUnreadInd = false);
							}, 500);

							movements && $scope.movements.setItemsAsNotBusy(movements);

							const { Lido } = $scope.movements.getFilters();

							if (Lido && movements.length <= 1) {
								$scope.pagination.totalItens--;

								$scope.movements.setItems(
									$scope.movements
										.getItems()
										.filter(item => item.id !== movements[0].id)
								);
							}

							if (movements.length >= 1 && Lido != undefined) {
								$scope.pagination.totalItens -= movements.length;

								movements.forEach(function(i) {
									$scope.movements.setItems(
										$scope.movements.items.filter(item => item.id !== i.id)
									);
								});
							}

							let markTrue =
								individual &&
								($scope.stateParamsFilter.lido ||
									$scope.stateParamsFilter.lido == 'false')
									? true
									: false;
							let markFalse =
								!individual &&
								($scope.stateParamsFilter.lido ||
									$scope.stateParamsFilter.lido == 'false')
									? true
									: false;

							markTrue &&
								($rootScope.newPublicationChecked = $rootScope.newPublicationChecked.filter(
									n =>
										movements[0].idMovProcessoCliente != n.idMovProcessoCliente
								));

							markFalse && $rootScope.cleanSelectedMov();

							if (
								!individual &&
								($scope.stateParamsFilter.lido ||
									$scope.stateParamsFilter.lido == 'false')
							)
								$('#div-check-all input[type=checkbox]').prop('checked', false);

							if (
								!$rootScope.newPublicationChecked ||
								$rootScope.newPublicationChecked.length <= 1
							)
								$scope.itemCheckedDisable = true;

							$rootScope.recordValuesProKey();

							$rootScope.getTotalNotRead();

							if ($scope.movements.getItems().length === 0) {
								$scope.treatPageMov();
								$scope.recordMovements($scope.movements);
							}

							if ($scope.movements.getItems().length > 0)
								($scope.stateParamsFilter.lido ||
									$scope.stateParamsFilter.lido == 'false') &&
									$scope.recordMovements($scope.movements);
						});
				else {
					notification.success('Não existem movimentações para marcar.');

					setTimeout(() => {
						!individual
							? ($scope.printingUnread = false)
							: ($scope.printingUnreadInd = false);
					}, 500);
				}
			};

			//Marca movimentos da listagem como LIDAS
			$scope.setMovementsAsRead = (responseStore, movement, details) => {
				if ($scope.printingRead || $scope.printingReadInd) return;

				const individual = movement ? true : false;

				!individual
					? ($scope.printingRead = true)
					: ($scope.printingReadInd = true);

				const tipo = movement ? movement.movimento.idTipoMovProcesso : -3;

				let movementsData = [];
				let movements = responseStore
					? responseStore.filter(item => item.__checked__ && !item.lido)
					: [];

				if (movement) movements = [movement];

				movements.map(movement => {
					let movementData = {
						id: movement.id,
						idMovProcessoCliente: movement.idMovProcessoCliente
					};

					if ($stateParams.pasta)
						movementData.pastasRelacionadas = movement.pastasMovimento.filter(
							pasta => pasta.id == $stateParams.pasta
						);

					if ($scope.groupUserSelected)
						movementData.idGrupoUsuarios = $scope.groupData.idGrupo;

					movementsData.push(movementData);
				});

				if (movementsData.length)
					$http({
						...helper.http(API.movementMarkAsRead, 'PUT'),
						data: {
							itens: movementsData
						},
						messageOverride: {
							success(response, notify) {
								if (!details) {
									let message = '';

									if (tipo == -1)
										message =
											movementsData.length > 1
												? 'Os andamentos foram marcados como lidos!'
												: 'O andamento foi marcado como lido!';
									else if (tipo == -2)
										message =
											movementsData.length > 1
												? 'As publicações foram marcadas como lidas!'
												: 'A publicação foi marcada como lida!';
									else
										message =
											movementsData.length > 1
												? 'As movimentações foram marcadas como lidas!'
												: 'A movimentação foi marcada como lida!';

									notify.success(message);
								}
							}
						}
					})
						.then(response => {
							!details &&
								$scope.movements.updateItems(
									response.data.itens,
									false,
									'idMovProcessoCliente'
								),
								response.data.itens[0].forEach(r => {
									$scope.movements.getItems().forEach(m => {
										if (r.idMovProcessoCliente === m.idMovProcessoCliente)
											m.lido = true;
									});
								});
							() => responseStore.rowbackItems(movements);

							movement && $scope.movements.rowbackItems(movement);
						})

						.finally(() => {
							setTimeout(() => {
								!individual
									? ($scope.printingRead = false)
									: ($scope.printingReadInd = false);
							}, 500);

							movement && $scope.movements.setItemsAsNotBusy(movement);

							const { Lido } = $scope.movements.getFilters();

							if (movements.length >= 1 && Lido != undefined) {
								$scope.pagination.totalItens -= movements.length;

								movements.forEach(function(i) {
									$scope.movements.setItems(
										$scope.movements.items.filter(item => item.id !== i.id)
									);
								});
							}

							movements.map(item => $.extend(item, { lido: true }));

							let markTrue =
								movement &&
								($scope.stateParamsFilter.lido ||
									$scope.stateParamsFilter.lido == 'false')
									? true
									: false;
							let markFalse =
								!movement &&
								($scope.stateParamsFilter.lido ||
									$scope.stateParamsFilter.lido == 'false')
									? true
									: false;

							markTrue &&
								($rootScope.newPublicationChecked = $rootScope.newPublicationChecked.filter(
									n =>
										movements[0].idMovProcessoCliente != n.idMovProcessoCliente
								));

							markFalse && $rootScope.cleanSelectedMov();

							if (
								!individual &&
								($scope.stateParamsFilter.lido ||
									$scope.stateParamsFilter.lido == 'false')
							)
								$('#div-check-all input[type=checkbox]').prop('checked', false);

							if (
								!$rootScope.newPublicationChecked ||
								$rootScope.newPublicationChecked.length <= 1
							)
								$scope.itemCheckedDisable = true;

							$rootScope.recordValuesProKey();

							$rootScope.getTotalNotRead();

							if ($scope.movements.getItems().length === 0) {
								$scope.treatPageMov();
								$scope.recordMovements($scope.movements);
							}

							if ($scope.movements.getItems().length > 0)
								($scope.stateParamsFilter.lido ||
									$scope.stateParamsFilter.lido == 'false') &&
									$scope.recordMovements($scope.movements);
						});
				else if (!details) {
					notification.success('Não existem movimentações para marcar.');

					setTimeout(() => {
						!individual
							? ($scope.printingRead = false)
							: ($scope.printingReadInd = false);
					}, 500);
				}
			};

			//Método de controle dos botões de ação em lote em mobile
			$scope.toggleButtonActionsMobile = {
				showAndHidden: () => {
					let containerMobile = document.querySelector('.adv-mobile-actions');

					containerMobile.classList.toggle('activeShow');
				},
				hiddenActionsMobile: () => {
					let containerMobile = document.querySelector('.adv-mobile-actions');

					if (!!containerMobile) containerMobile.classList.remove('activeShow');
				}
			};

			//Método para abir modais
			$scope.openGenericModal = (movement, id, action, fn = () => {}) => {
				$scope.closeAllMovements();

				const open = [
					'#modalDeleteMovementNew',
					'#modalDeleteDefinitive'
				].includes(id);

				// $rootScope.configSendEmail.route = 'movements';

				if (!movement || (movement && !movement.length)) {
					$scope.deleteMultiple = false;
				} else {
					$scope.deleteMultiple = true;
				}

				if (id === '#modalDeleteMovementNew') {
					$rootScope.getDaysDeleteTrash();

					if (movement && !movement.length) {
						$scope.shouldDeleteDeadlineType = !!movement.movimento
							.andamentoProcesso
							? 'andamento'
							: 'publicação';

						if (
							movement.movimento.prazosAvencer ||
							movement.movimento.prazosVencido
						) {
							id = '#modalDeleteMovementWithDeadline';
						}
					} else {
						let hasProcess = false;
						let hasPublication = false;

						for (let i = 0; i < movement.length; i++) {
							if (movement[i].movimento.andamentoProcesso) {
								hasProcess = true;
							} else if (movement[i].movimento.publicacao) {
								hasPublication = true;
							}

							if (
								movement[i].movimento.prazosAvencer ||
								movement[i].movimento.prazosVencido
							) {
								id = '#modalDeleteMovementWithDeadline';
							}
						}

						if (hasProcess && hasPublication) {
							$scope.shouldDeleteDeadlineType = 'movimentos';
						} else if (hasProcess) {
							$scope.shouldDeleteDeadlineType = 'andamentos';
						} else if (hasPublication) {
							$scope.shouldDeleteDeadlineType = 'publicações';
						}
					}
				}

				if (action) {
					$scope.movementInAction = movement;
				}

				if (id == '#modalSendEmailComponent') {
					$rootScope.configSendEmail.action =
						$scope.newPublicationChecked &&
						$scope.newPublicationChecked.length > 1
							? $scope.newPublicationChecked
							: movement;

					$rootScope.configSendEmail.route = 'movements';
					$rootScope.configSendEmail.title = 'Enviar por email';
				}

				$('.modal').modal('hide');

				fn;

				const el = $(id);

				if ($rootScope.hasGroupUserPermission || !open)
					el.modal && el.modal('show');
				else if (!$rootScope.hasGroupUserPermission)
					$('#modalNotPermitted').modal('show');

				id == '#modalSendEmail' &&
					setTimeout(() => {
						$('#inputEmailText').focus(); // Dá foco no input
					}, 500);
			};

			$scope.openAddKeywords = () => {
				$('#modalAddKeywords').modal('show');
			};

			//  NÃO EXCLUA ESSA PARTE DO CÓDIGO (Botão de Inativar e Ativa Palavra-chave #72894)

			// $scope.changeStateModal = () => $('#modalChangeState').modal('show');
			// $scope.changeState = publications => {
			// 	publications.disabledBtnWhileLoading = true;

			// 	let items = {
			// 		idUsuarioCliente: $scope.userData.idUsuarioCliente,
			// 		listaPesquisaPublicacao: [],
			// 		idGrupoUsuarios: $scope.groupUserSelected
			// 			? $scope.groupData.idGrupo
			// 			: null
			// 	};

			// 	publications.map(publication => {
			// 		items.listaPesquisaPublicacao.push({
			// 			flAtualizacao: true,
			// 			idPesqPublicUsuarioCliente: publication.id,
			// 			flAtivo: !$scope.isAnyActiveKey
			// 		});
			// 	});

			// 	$http({
			// 		...helper.http(API.searchPublicationUserClient, 'POST'),
			// 		data: {
			// 			itens: [items]
			// 		},
			// 		messageOverride: {
			// 			success(response, notify) {
			// 				if ($scope.isAnyActiveKey)
			// 					notify.success('Palavra-chave inativada!');
			// 				else notify.success('Palavra-chave ativada!');
			// 			}
			// 		}
			// 	})
			// 		.then(() => {
			// 			publications.map(item => {
			// 				item.disabledBtnWhileLoading = false;

			// 				if ($scope.isAnyActiveKey) {
			// 					item.palavraChave.flAtivo = false;
			// 					item.palavraChave.situacaoPalavraChave.id = -2;
			// 					item.palavraChave.situacaoPalavraChave.nome = 'Inativa';
			// 					item.palavraChave.idSituacaoPalavraChave = -2;
			// 				} else {
			// 					item.palavraChave.flAtivo = true;
			// 					item.palavraChave.situacaoPalavraChave.id = -1;
			// 					item.palavraChave.situacaoPalavraChave.nome = 'Ativa';
			// 					item.palavraChave.idSituacaoPalavraChave = -1;
			// 				}
			// 			});

			// 			$scope.isAnyActiveKey = !$scope.isAnyActiveKey;

			// 			$('#modalAlert').modal('hide');
			// 			$('#modalChangeState').modal('hide');
			// 			$('#modalEditKeywordVariationExcluded').modal('hide');
			// 			$('#modalEditKeywordVariationSearch').modal('hide');

			// 			setTimeout(() => {
			// 				$scope.removeDataDiaries();
			// 				$state.go(
			// 					$state.current.name,
			// 					{ paginaAtual: 1, pasta: $stateParams.pasta },
			// 					{ inherit: false, reload: true }
			// 				);
			// 			}, [250]);
			// 		})
			// 		.finally(() => $scope.keyWordsVariations.setNotLoading());
			// };

			/** Método para ativar e inativar variação */
			$scope.changeStateVariation = variation => {
				if ($scope.editVariation) return;

				$scope.editVariation = true;

				const status = variation.idSituacaoPalavraChave === -5;

				$http({
					...helper.http(API.keyWordsClient, 'alterarSituacaoVariacao'),
					method: 'PUT',
					data: {
						itens: [
							{
								idPalavraChave: variation.id,
								flStatus: status
							}
						]
					},
					messageOverride: {
						success(response, notify) {
							if (status) {
								notify.success('Variação ativada!');
							} else {
								notify.success('Variação inativada!');
							}
						}
					}
				})
					.then(() => {
						$('#modalEditKeywordVariationSearch').modal('hide');
						$('#modalEditKeywordVariationExcluded').modal('hide');

						$scope.recordKeyWordsVariations(
							$scope.keyWordsVariations,
							$scope.briefcase.getItems()
						);
					})
					.catch(() => {
						setTimeout(() => {
							$scope.editVariation = false;
						}, 100);
					})
					.finally(() => {
						$scope.keyWordsVariations.setNotLoading();
						setTimeout(() => {
							$scope.editVariation = false;
						}, 100);
					});
			};

			$scope.campoVazio = () => {
				if ($scope.validation == false) {
					notification.danger(
						'NÃO É POSSÍVEI INSERIR UMA PALAVRA-CHAVE COM MENOS DE 3 CARACTÉRES!'
					);
				}
			};

			$scope.treatWord = wordVariation => {
				if (!wordVariation) return;

				const palavras = wordVariation
					.split(',')
					.map(item => item.replace(/\s+/g, ''));
				const invalidCount = palavras.filter(item => item.length <= 2).length;

				const inputElement = angular.element(
					document.querySelector('#inputCreateVariation')
				);

				inputElement.removeClass('valid-input invalid-input');

				invalidCount > 0
					? inputElement.addClass('invalid-input')
					: inputElement.addClass('valid-input');

				$scope.variationValid = invalidCount > 0 ? false : true;

				if (invalidCount == 0) {
					$scope.validation = true;
				} else {
					$scope.validation = false;
				}
			};

			$scope.validation = {};

			$scope.InputChanged = () => {
				var inputElement = document.getElementById('inputCreateVariation');

				if (inputElement)
					inputElement.addEventListener('input', function(event) {
						var valorInput = event.target.value;

						$scope.treatWord(valorInput);
					});
			};

			setTimeout(() => {
				$scope.InputChanged();
			}, 3000);

			/** Cadastrar uma nova variação. */
			$scope.createVariations = (responseStore, items, reset) => {
				responseStore.recording = true;

				items = items.palavraChave
					.split(',')
					.map(item => ({ ...items, palavraChave: item.trim() }));

				let variations = {
					idCliente: $scope.userData.idCliente,
					idUsuarioCliente: $scope.userData.idUsuarioCliente,
					idSituacaoPalavraChave: -4,
					listaPalavraChave: []
				};

				items.map(item => variations.listaPalavraChave.push(item));

				$scope.$resetFormValidation('createVariation')();

				$http({
					...helper.http(API.keyWordsClient, 'POST'),
					data: {
						itens: [variations]
					},
					messageOverride: {
						success(response, notify) {
							const { idpalavrachaveprincipal } = response.data.itens[0][0];

							if (items[0].idPalavraChavePrincipal == idpalavrachaveprincipal)
								notify.success('Variação cadastrada!');
							else if (
								items[0].idPalavraChavePrincipal != idpalavrachaveprincipal
							)
								notify.danger('Variação cadastrada para outra palavra chave');
						},
						error(response, notify) {
							const { mensagem } = response.data.status;
							const messageError =
								response.data.status.erros &&
								response.data.status.erros.length &&
								response.data.status.erros[0].mensagem;

							notify.danger(messageError ? messageError : mensagem);

							// if (mensagem.indexOf('JÁ EXISTE') > 1)
							// 	notify.danger(
							// 		'Palavra-chave informada já existe em outro tipo'
							// 	);
						}
					}
				})
					.then(() => {
						$scope.recordKeyWordsVariations(
							$scope.keyWordsVariations,
							$scope.briefcase.getItems()
						);

						$('#keywordTipe').val('');

						setTimeout(() => {
							$('#keywordTipe').triggerHandler('change');
						}, 300);

						if (typeof reset === 'function') helper.defer(() => reset());
					})

					.finally(() => {
						$('.modal').modal('hide');

						responseStore.recording = false;

						$scope.emptyVariation = {};
					});
			};

			/**
			 * Método para verificar situação da variação para dar nome ao botão
			 * de editar variação
			 * */
			$scope.setVariationButtons = situation => {
				let action = 'Ativar';

				if (situation == -1 || situation == -4) action = 'Inativar';
				else if (situation == -3) action = 'Recusado';
				else if (situation == -5) action = 'Ativar';
				else action = 'Inativo';

				return action;
			};

			/** Consulta crédito para vefiricar busca de andamentos, utilizado
			 * em pasta processos
			 * */
			$scope.buscaAndamentosFn = async (fonts, i) => {
				// $scope.printing = true;

				$scope.searchInAction = fonts;

				$scope.searchSituation =
					fonts[0].idSituacaoPesquisaProcessoUsuarioCliente;

				$http({
					...helper.http(API.userClientFunctionalities, 'GET'),
					params: {
						idFuncionalidade: -32
					}
				}).then(response => {
					helper.defer(() => {
						$scope.processesCredits = response.data.itens[0].qtdDisponivel || 0;

						const unlimited = response.data.itens[0]
							.totalContratadoUsuarioCliente
							? false
							: true;

						$scope.searchPublicationStatus =
							$scope.searchSituation == -1 ? 'active' : 'inactive';
						$scope.toggleSearchTitle = `Deseja ${
							$scope.searchSituation == -1 ? 'inativar' : 'ativar'
						} a busca automática de andamentos?`;
						$scope.toggleSearchDescription =
							'Ao inativar, você opta por deixar de receber andamentos relacionados a esta fonte do processo. Essa ação retornará um crédito para a Central de Buscas.';

						if (
							$scope.processesCredits <= 0 &&
							document.getElementById('id-toggle--' + i).value == 'false' &&
							!unlimited
						) {
							notification.danger('Créditos Insuficientes');

							return;
						} else if (
							$scope.searchSituation == -7 ||
							$scope.searchSituation == -9 ||
							$scope.searchSituation == '-7,-9'
						)
							$scope.toggleSearchDescription =
								'Ao ativar, você opta por receber andamentos relacionados a esta fonte do processo. Essa ação utilizará um crédito da Central de Buscas.';

						$('#modalChangeSearch').modal('show');

						$scope.printing = false;
					});
				});
			};

			/** Ativa ou Inativa busca automática de andamentos em pasta processos */
			$scope.toggleStateSearch = () => {
				$scope.printing = true;

				let newSituation = $scope.searchSituation == -1 ? -7 : -1;

				let notificationMessage = `Busca automática ${
					newSituation == -1 ? 'ativada' : 'inativada'
				}!`;

				let fontsIds = $scope.searchInAction.map(
					font => font.idFontePesquisaProcesso
				);

				$http({
					...helper.http(API.userCustomerAutomaticSearch, 'PUT'),
					data: {
						itens: [
							{
								idSituacaoPesquisaProcesso: newSituation,
								idsFontesPesquisaProcesso: fontsIds
							}
						]
					},
					messageOverride: {
						success(response, notify) {
							notify.success(notificationMessage);
						}
					}
				})
					.then(() => {
						$scope.printing = false;
						if ($scope.searchInAction)
							$scope.searchInAction[0].idSituacaoPesquisaProcessoUsuarioCliente = newSituation;
					})
					.catch(() => {
						$scope.printing = false;
					})
					.finally(() => {
						$('.modal').modal('hide');
					});
			};

			/** navega para pagina de detalhes */
			$scope.getDetails = movements => {
				$scope.openedItems = movements.filter(item => item.__checked__);

				const ids = $scope.openedItems.map(
					movement => movement.idMovProcessoCliente
				);

				let params = helper.cloneSimpleObject($stateParams);

				params.paginaAtual = 1;
				params.movements = ids.join(',');

				$rootScope.pageSelected = null;

				$state.go(
					`root.default.movements.list${$scope.environmentPageMov}.details`,
					params,
					{
						notify: false,
						reload: false
					}
				);
			};

			/** verifica se esta no ambiente de lixeira para marcar registros */
			$scope.checkTrash = (movement, value) => {
				if ($scope.environmentPageMov == '5') {
					if (value == 'click') {
						$scope.movements.getItems().forEach(m => {
							if (m.id === movement.id && !m.__checked__) {
								m.__checked__ = true;
								$scope.selectPublication(movement);
							} else if (m.id === movement.id && m.__checked__) {
								m.__checked__ = false;
								$scope.selectPublication(movement);
							}
						});
					}
				} else if (!$scope.environmentPageMov == '5' && value == 'click') {
					$scope.checkMovementRouter(movement);
				}
			};

			/** verifica se esta no ambiente de lixeira para marcar registros
			 * ou se não for abre pagina de detalhes
			 */
			$scope.checkMovementRouter = movement => {
				if ($scope.environmentPageMov == '5') {
					$scope.movements.getItems().forEach(m => {
						if (m.id === movement.id && !m.__checked__) {
							m.__checked__ = true;
							$scope.selectPublication(movement);
						} else if (m.id === movement.id && m.__checked__) {
							m.__checked__ = false;
							$scope.selectPublication(movement);
						}
					});

					return;
				}

				var nav = helper.cloneSimpleObject($stateParams);

				nav.movementsID = movement.id;
				nav.type =
					movement.movimento.idTipoMovProcesso == -1
						? 'andamento'
						: 'publicacao';
				nav.movementsIDs = movement.movimento.id;

				$rootScope.pageSelected = null;

				$state.transitionTo(
					`root.default.movements.list${$scope.environmentPageMov}.movementsDetails`,
					nav,
					{
						inherit: false
					}
				);
			};

			/** seleciona movimentações marcadas para exclusão ou envio
			 * para a lixeira ou para restauração dos movimentos
			 * */
			$scope.setDeleteModal = movement => {
				$scope.movementInAction = [];

				!movement[0]
					? $scope.movementInAction.push(movement)
					: ($scope.movementInAction = [...$rootScope.newPublicationChecked]);
			};

			/*
			Variavel 'listAllAttachmentsModal' salva um array para ser
			exibido na modal de anexos
			*/
			$scope.openModalAnexo = attachments => {
				$scope.listAllAttachmentsModal = attachments;

				const el = $('#modalAnexos');

				el.modal && el.modal('show');
			};

			/** Método para Download de anexos */
			$scope.attachmentDownload = (attachmentId, fileType = 'pdf') => {
				$scope.loadingAttachment = attachmentId;
				$scope.loadingAnexo = true;

				if (!$scope.idAnexoLoading.includes(attachmentId)) {
					$scope.idAnexoLoading.push(attachmentId);
					localStorage.setItem(
						'__idAnexoLoading__',
						JSON.stringify($scope.idAnexoLoading)
					);
				}
				if (!$scope.idAnexoLoadingSpinner.includes(attachmentId)) {
					$scope.idAnexoLoadingSpinner.push(attachmentId);
				}

				$http({
					...helper.http(API.attachmentDownload, 'GET', {
						ID: attachmentId
					}),
					params: {
						tipoArquivo: fileType,
						IdGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null
					},
					responseType: 'blob'
				})
					.then(response => {
						const { data, status } = response;

						if (status > 299) {
							$scope.loadingAnexo = false;
							$scope.idAnexoLoadingSpinner = [];

							return notification.danger(
								'Não foi possível realizar o download.'
							);
						}

						const regex = /filename=(.*);/;

						const contentDispositionHeader =
							response.headers()['content-disposition'] ||
							`attachment; filename=${Date.now()}.pdf; filename*=UTF-8''${Date.now()}.pdf`;

						const [, filename] = regex.exec(contentDispositionHeader);

						const file = new Blob([data], { type: 'application/pdf' });

						const linkEl = document.createElement('a');

						linkEl.href = URL.createObjectURL(file);

						linkEl.download = filename;

						document.body.appendChild(linkEl);

						linkEl.click();

						$scope.loadingAnexo = false;
						$scope.idAnexoLoadingSpinner = [];

						notification.success('Download concluído!');
					})
					.finally(() => ($scope.loadingAttachment = -1));
			};

			/** Método para abrir modal de renomear processo */
			$scope.openModalRenameProcess = formName => {
				$scope.$resetFormValidation(formName)();

				let folderItem = $scope.$parent.$$prevSibling.processMovements.items.find(
					item => item.id === +$stateParams.pasta
				);

				$scope.rename.nome =
					folderItem && folderItem.nome ? folderItem.nome : $scope.rename.nome;

				$('#modalRenameProcess')
					.one('shown.bs.modal', () => {
						const renameInput = document.getElementById('renameProcess');

						if (renameInput) renameInput.focus();
					})
					.modal('show');
			};

			/** Método para renomear processo */
			$scope.renameProcesses = process => {
				$scope.printing = true;

				$http({
					...helper.http(API.briefcase, 'PUT'),
					data: {
						itens: [
							{
								id: $stateParams.pasta,
								nome: process.nome == '' ? null : process.nome
							}
						]
					},
					messageOverride: {
						success(response, notify) {
							notify.success('Processo renomeado! ');
						}
					}
				}).then(() => {
					const processId = Number(
						$stateParams.pasta ||
							$stateParams.pastaProcesso ||
							$scope.pastaProcesso ||
							$stateParams.processId ||
							$scope.processId ||
							null
					);
					const procMov =
						$scope.$parent &&
						$scope.$parent.$$prevSibling &&
						$scope.$parent.$$prevSibling.processMovements;
					const currentIndex =
						procMov && Array.isArray(procMov.items)
							? procMov.items.findIndex(item => Number(item.id) === processId)
							: -1;
					const newName = process.nome || '';

					$rootScope.cleanSelectedMov();
					sessionStorage.setItem('__pageMovements__', 1);
					$scope.listingHibben = true;
					$scope.itemCheckedDisable = true;
					$scope.printing = false;

					$('#modalRenameProcess').modal('hide');

					helper.defer(() => {
						if ($scope.briefcase && $scope.briefcase.getItems)
							$scope.briefcase.getItems().nome = newName;

						if (processId) {
							$rootScope.$broadcast('processRenamed', {
								id: processId,
								nome: newName,
								index: currentIndex
							});
						}

						$scope.listingHibben = false;
					});
				});
			};

			/** abre modal para exclusão de processo */
			$scope.deleteProcessesModal = () =>
				$('#modalDeleteProcess').modal('show');

			/** Método para exclusão de processo, dentro de pasta processo */
			$scope.deleteProcesses = processHeader => {
				processHeader.disabledBtnWhileLoading = true;

				$http({
					...helper.http(API.disableFolder, 'PUT'),
					data: {
						ids: [+$stateParams.pasta],
						excluirPrazosVinculados:
							$scope.deleteProcessOptions.deleteLinkedDeadlines === 2
								? true
								: false
					},
					messageOverride: {
						success(response, notify) {
							notify.success('Processo excluído com sucesso!');
						}
					}
				})
					.then(() => {
						processHeader.disabledBtnWhileLoading = false;

						$scope.$parent.$$prevSibling.processMovements.items.map(
							(item, index) => {
								if (item.id === +$stateParams.pasta)
									$scope.$parent.$$prevSibling.processMovements.items.splice(
										index,
										1
									);
							}
						);

						helper.defer(() => {
							$('#modalDeleteProcess').modal('hide');
							$scope.$apply();
						});
					})
					.finally(() => {
						$rootScope.deleteAllOfCountValue();
						$rootScope.changeProcessOrder();
						sessionStorage.setItem('__pageMovements__', 1);

						$state.go('root.default.movements.list1', {
							inherit: false,
							reload: 'root.default.movements.list1'
						});
					});
			};

			/* Impressão de movimentos */
			$scope.printMovements = movement => {
				$scope.closeAllMovements();

				$scope.printing = true;
				$scope.loadingPrint = true;

				$scope.movementInAction = movement ? movement : null;

				const checkedItems = $rootScope.newPublicationChecked;

				if (!movement && !checkedItems.length)
					return notification.danger('Nenhum movimento selecionado.');

				const ids = movement
					? movement.movimento.id.toString()
					: checkedItems.map(x => x.movimento.id).join();

				$http({
					...helper.http(API.downloads, 'movements'),
					params: {
						ids,
						tipoArquivo: 'pdf',
						quebrarPaginaImpressao: false,
						idGrupoMovimento:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null
					},
					responseType: 'blob',
					noCancelOnRouteChange: true
				})
					.then(async response => {
						const { data, status } = response;

						const prevIframes = document.querySelectorAll(
							'.__printable-pdf-frame'
						);

						if (prevIframes.length)
							prevIframes.forEach(iframe => iframe.remove());

						if (status > 299)
							return notification.danger('Erro ao imprimir movimentações.');

						const file = new Blob([data], { type: 'application/pdf' });

						await file.dataURL().then(() => {
							if (navigator.userAgent.indexOf('Chrome') !== -1) {
								const iframe = document.createElement('iframe');

								iframe.className = '__printable-pdf-frame';

								iframe.style.position = 'fixed';
								iframe.style.bottom = '-100vh';

								iframe.src = URL.createObjectURL(file);

								document.body.appendChild(iframe);

								iframe.contentWindow.focus();

								setTimeout(() => {
									iframe.contentWindow.print();
								}, 1);
							}
							const isIe = /*@cc_on!@*/ false || !!document.documentMode;

							if (isIe)
								window.navigator.msSaveOrOpenBlob(
									file,
									'msSaveBlob_testFile.pdf'
								);

							if (navigator.userAgent.indexOf('Firefox') !== -1) {
								let newWindow = window.open(
									URL.createObjectURL(file),
									'name',
									'height=800,width=1000'
								);

								newWindow.focus();

								setTimeout(() => newWindow.print(), 1000);
							}

							$timeout(() => {
								$scope.loadingPrint = false;
							}, 1000);
						});
					})
					.finally(() => {
						const hasUnread = movement
							? !movement.lido
							: checkedItems.some(item => !item.lido);

						if (hasUnread) {
							$timeout(() => $('#modalToggleAsRead').modal('show'), 1500);
							if (movement == undefined) $scope.itemCheckedDisable = false;
						}

						$timeout(() => {
							$scope.loadingPrint = false;
						}, 1000);
					});
			};

			$scope.openModalDownloadMovements = file => {
				if ($scope.clearAll) {
					$('#modalDownload').modal('hide');
					$('#modalAllDownloads').modal('show');
					$scope.saveFileType = file;

					$timeout(function() {
						document.getElementById('inputCreateEmail').focus();
					}, 600);
				} else {
					$scope.downloadMovements(file);
				}
			};

			/* Integração de Downloads de movimentos */
			$scope.downloadMovements = (fileType = 'pdf', selectAll) => {
				if (!$scope.openDownloadMovements) {
					$('#modalDownload').modal('hide');

					$scope.blockDownload = true;
					if ($scope.movementInAction == undefined)
						$scope.itemCheckedDisable = false;

					if ($scope.clearAll === false) {
						$scope.showAllSelected = false;
					} else {
						$scope.showAllSelected = true;
					}

					if ($scope.clearAll) {
						let paramsSearch = {
							tipoArquivo: fileType,
							IdPastaUsuarioCliente: $stateParams.pasta,
							IdGrupoUsuarios:
								$scope.groupUserSelected && $scope.groupData
									? $scope.groupData.idGrupo
									: null,
							emails: $scope.saveEmail.email
						};

						if (selectAll) {
							paramsSearch.marcarNaoLidos = true;
						} else {
							paramsSearch.marcarNaoLidos = false;
						}

						$scope.openDownloadMovements = true;

						Object.keys(movementsFiltersNames).map(name => {
							let value = $stateParams[name];

							if (movementsFiltersNames[name].download)
								paramsSearch[movementsFiltersNames[name].download] = value;
							else
								paramsSearch[
									movementsFiltersNames[name].request
								] = movementsFiltersNames[name].values
									? movementsFiltersNames[name].values[value]
									: value;
						});

						if ($scope.environmentPageMov == '2')
							paramsSearch.IdTipoMovProcesso = -2;

						let filters = JSON.parse(sessionStorage.getItem('__selected__'));

						if (filters) {
							for (var prop in filters) {
								paramsSearch[prop] = filters[prop];
							}
						}

						if (
							$('#air-datepicker-range')
								.val()
								.includes('Período')
						) {
							const dataInicial = new Date();

							const I = new Date(
								dataInicial.getFullYear(),
								dataInicial.getMonth(),
								dataInicial.getDate() - 14
							);

							const inicial = moment(I).format('YYYY-MM-DDT00:00:00');
							const final = moment(dataInicial).format('YYYY-MM-DDT23:59:59');

							paramsSearch.DataMovimentoInicio = inicial;
							paramsSearch.DataMovimentoFim = final;
						} else if (
							$('#air-datepicker-range')
								.val()
								.includes('até')
						) {
							let dtIni = $('#air-datepicker-range')
								.val()
								.split(' ')[0]
								.split('/')
								.reverse()
								.join('-');

							let dtFim = $('#air-datepicker-range')
								.val()
								.split(' ')[2]
								.split('/')
								.reverse()
								.join('-');

							const inicial = moment(dtIni).format('YYYY-MM-DDT00:00:00');
							const final = moment(dtFim).format('YYYY-MM-DDT23:59:59');

							paramsSearch.DataMovimentoInicio = inicial;
							paramsSearch.DataMovimentoFim = final;
						}

						$http({
							...helper.http(API.downloads, 'all'),
							method: 'POST',
							data: { itens: [{ ...paramsSearch }] },
							messageOverride: {
								success(response, notify) {
									notify.success(response.data.status.mensagem);
								},
								error(response, notify) {
									notify.danger(response.data.status.mensagem);
								}
							},
							noCancelOnRouteChange: true
						}).finally(() => {
							$scope.toggleAllMovements(true);
							$('#modalToggleAsReadAll').modal('hide');
							$scope.openDownloadMovements = false;
							$scope.saveEmail = [];
							$scope.emptyEmail.email = [];
							$('#inputCreateEmail').removeClass('is-valid');
							$('#inputCreateEmail').removeClass('is-invalid');
						});
					} else {
						const movement = $scope.movementInAction;
						const checkedItems = $rootScope.newPublicationChecked;

						if (!movement && !checkedItems.length)
							return notification.danger('Nenhum movimento selecionado.');

						const ids = movement
							? movement.movimento.id.toString()
							: checkedItems.map(x => x.movimento.id).join();

						notification.success(
							'Download iniciado! Isso pode levar algum tempo.'
						);

						setTimeout(() => {
							const hasUnread = movement
								? !movement.lido
								: checkedItems.some(item => !item.lido);

							if (hasUnread) $('#modalToggleAsRead').modal('show');
						}, 200);

						const params = {
							ids,
							tipoArquivo: fileType,
							idGrupoMovimento:
								$scope.groupUserSelected && $scope.groupData
									? $scope.groupData.idGrupo
									: null
						};

						const api = 'movements';

						downloadService.serviceDownload(params, api);
						$scope.blockDownload = false;
					}
				}
			};

			// Fecha modal de exluir movimentações
			$scope.closeModal = () => {
				if ($scope.movementInAction == undefined)
					$scope.itemCheckedDisable = false;

				if (!$scope.emptyEmail.email) {
					$scope.saveEmail = [];
					$scope.emptyEmail.email = [];
					$('#inputCreateEmail').removeClass('is-valid');
					$('#inputCreateEmail').removeClass('is-invalid');
				}

				$('.modal').modal('hide');
			};

			/* Deletar movimento */
			$scope.deleteMovements = () => {
				$scope.deleteDefinitive = true;

				const movement = $scope.movementInAction;

				const { id: idPastaUsuarioCliente } = $scope.briefcase.getItems();

				let checked = $scope.movementInAction.length;

				let mensagemSucesso =
					checked > 1 ? 'Documentos excluídos!' : 'Documento excluído!';

				const objData = movement.map(movement => {
					let movData = {
						idPastaUsuarioCliente,
						idMovimentoProcessoCliente: movement.movimento.id
					};

					if ($scope.groupUserSelected)
						movData.idGrupoUsuarios = $scope.groupData.idGrupo;
					else movData.idUsuarioCliente = $scope.userData.idUsuarioCliente;

					return movData;
				});

				$http({
					...helper.http(API.briefcase, 'DELETE'),
					method: 'PUT',
					data: objData,
					messageOverride: {
						success(response, notify) {
							notify.success(mensagemSucesso);
						}
					},

					noCancelOnRouteChange: true
				})
					.then(() => {
						const total = $scope.movements.getCheckedItems().length;

						if (total === $scope.quantityPerPage) $scope.listingHibben = true;

						//guarda os movimentos marcados
						let checked = $rootScope.newPublicationChecked
							? $rootScope.newPublicationChecked
							: [];

						//filtra os movimentos para retirar da listagem
						if (checked.length) {
							checked.forEach(c => {
								movement.forEach(m => {
									if (c.idMovProcessoCliente === m.idMovProcessoCliente)
										c.__checked__ = false;
								});
							});
							checked = checked.filter(c => c.__checked__);
							$rootScope.newPublicationChecked = checked;
						} else $rootScope.newPublicationChecked = [];

						//verifica se habilita ou não as ações em lote
						!checked || checked.length < 2
							? ($scope.itemCheckedDisable = true)
							: ($scope.itemCheckedDisable = false);

						$scope.movements.getItems().forEach(m => {
							movement.forEach(r => {
								if (m.idMovProcessoCliente === r.idMovProcessoCliente)
									m.delete = true;
							});
						});

						let mov = $scope.movements.getItems().filter(m => !m.delete);

						$scope.movements.setItems(mov);

						$scope.movementInAction.length > 1 &&
							$('#div-check-all input[type=checkbox]').prop('checked', false);

						$rootScope.updateValues('setMovements');

						$rootScope.getTotalNotRead();

						if (
							$scope.movements.getItems().length === 0 ||
							$scope.movementInAction.length > $scope.quantityPerPage
						)
							$scope.treatPageMov();

						$scope.recordMovements($scope.movements);

						setTimeout(() => {
							$('#modalDeleteDefinitive').modal('hide');
						}, 300);
					})
					.catch(() => {
						$scope.deleteDefinitive = false;
						setTimeout(() => {
							$('#modalDeleteDefinitive').modal('hide');
						}, 300);
					});
			};

			/** Abre modal de deletar palavra chave quando estiver inativa */
			$scope.deleteStateKeywordModal = () =>
				$('#modalDeleteKeyword').modal('show');

			/** Método para inativar palavra chave */
			$scope.toggleStateKeyWord = () => {
				$scope.loadingBtn = true;

				$http({
					...helper.http(API.briefcase, 'inativar'),
					method: 'PUT',
					data: { ids: [$stateParams.pasta] }
				})
					.then(() => ($scope.loadingBtn = false))
					.finally(() => {
						$rootScope.changeAllOfCountValue();
						$rootScope.cleanSelectedMov();

						$('#modalDeleteKeyword').modal('hide');
						$('.modal-backdrop').hide();
						$('.modal').modal('hide');

						$state.transitionTo('root.default.movements.list2', {
							inherit: false,
							reload: true
						});
					});
			};

			/** Altera a quantidade de registro po pagina na listagem */
			$scope.updateQuantityPerPage = quantityPerPage => {
				let filters = {};

				queryConvert().map(filter => (filters[filter.key] = filter.value));

				const userParamsSession = sessionStorage.getItem('parametros-usuarios');

				let dataParameterUsers = null;

				if (
					userParamsSession &&
					userParamsSession != undefined &&
					userParamsSession != 'undefined'
				) {
					dataParameterUsers = JSON.parse(userParamsSession);
				}

				let record = dataParameterUsers;

				$scope.idQtdItensPagina = $scope.idQtdItensPagina
					? $scope.idQtdItensPagina
					: record.idParamUsuarioProdAdv;

				let method = $scope.idQtdItensPagina ? 'PUT' : 'POST';

				$scope.quantityPerPage = quantityPerPage;

				$http({
					...helper.http(API.parametersUsers, method),
					data: {
						itens: [
							{
								id: record.idParamUsuarioProdAdv,
								qtdRegistroMovPorPagina: quantityPerPage || 20
							}
						]
					},
					messageOverride: {
						success() {}
					}
				}).then(() => {
					sessionStorage.setItem('__pageMovements__', 1);
					$scope.listingHibben = true;

					record.qtdRegistroMovPorPagina = quantityPerPage || 20;

					sessionStorage.setItem('parametros-usuarios', JSON.stringify(record));

					$scope.recordMovements($scope.movements);
				});
			};

			/** Método para trazer os registros da agenda */
			$scope.recordAgendas = responseStore => {
				const idUsuarioCliente =
					parseInt(authentication.getUserData('idUsuarioCliente'), 10) ||
					undefined;

				$http({
					...helper.http(API.agendas, 'GET'),
					params: {
						...helper.httpFields(['id']),
						idUsuarioCliente: idUsuarioCliente
					}
				}).then(response => responseStore.setItems(response.data.itens));
			};

			/** Método para verificar os tipos de eventos na agenda */
			$scope.recordEventsTypes = responseStore => {
				const idCliente =
					parseInt(authentication.getUserData('idCliente'), 10) || undefined;

				$http({
					...helper.http(API.eventsTypes, 'GET'),
					params: {
						...helper.httpFields(['id,nome']),
						idCliente,
						ativo: true
					}
				}).then(({ data }) => {
					responseStore.setItems(data.itens);

					// Converte o array para uma string e armazena no Session Storage
					sessionStorage.setItem(
						'__EVENTS_TYPES__',
						JSON.stringify(responseStore.getItems())
					);

					$rootScope.formCreatePrazo.eventsTypes = responseStore;

					$scope.selectedType = data.itens.find(item => item.nome == 'Prazo');
				});
			};

			/** Método para consultar palavra chave */
			$scope.consultarPalavraChave = () => {
				$http({
					...helper.http(API.briefcase, 'keywords'),
					method: 'GET',
					params: {
						...helper.httpFields(['idPalavraChave', 'nomePasta']),
						idPalavraChave: $scope.filter.palavraChave,
						registrosPorPagina: 10,
						paginaAtual: 1,
						IdGrupo:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null
					}
				}).then(response =>
					$scope.palavraChaveSelecionada.push(response.data.itens[0])
				);
			};

			/** Verifica palavra chave selecionada */
			$scope.keyWordsSelected = () => {
				if ($scope.filter.palavraChave) {
					const p = $scope.palavraChaveSelecionada.filter(
						p => p.idPalavraChave == $scope.filter.palavraChave
					);

					if (p.length === 1)
						$scope.recordsFilters.nomePalavraChave = p[0].palavraChave;
				}
			};

			/** Recupera palavras chaves para filtros */
			$scope.recordKeywords = () => {
				var palavras = JSON.parse(localStorage.getItem('__keywords__'));

				if (!!palavras) {
					$scope.palavraChaveSelecionada = palavras;

					$scope.keyWordsSelected();

					return;
				}

				$http({
					...helper.http(API.briefcase, 'GET'),
					params: {
						...helper.httpFields(['idPalavraChave', 'palavraChave']),
						registrosPorPagina: 99999,
						paginaAtual: 1,
						idTipoPasta: '-2',
						ativo: true,
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null
					},
					noCancelOnRouteChange: true
				}).then(response => {
					$scope.palavraChaveSelecionada = response.data.itens;

					localStorage.setItem(
						'__keywords__',
						JSON.stringify(response.data.itens)
					);

					$scope.keyWordsSelected();
				});
			};

			/** verifica se existe variações recusadas para mostrar para o usuario */
			$scope.getDeclinedVariations = type => {
				const declineds = $scope.declined.getItems();

				return declineds.filter(item => item.idTipoPalavraChave === type);
			};

			/** Verifica as permições do usuário */
			permissions
				.loadPermissions()
				.then(async () => {
					if (blocked !== 'true') {
						/** Ações no carregamento da pág */

						$scope.verifyLocal();
						!$scope.palavraChaveSelecionada.length && $scope.keywordsAll();
						!$scope.keyWordAccount && $scope.keywordPubliGeneral();
						!$scope.diaryAccount && $scope.diaryGeneral();

						if (!location.pathname.includes('detalhes')) {
							$scope.publicationPermission = permissions.has(
								'recordPublications'
							);

							$scope.movementPermission = permissions.has('createMovements');

							$scope.showVideo =
								!$scope.publicationPermission && !$scope.movementPermission;

							$scope.allOfAccount = !!!$stateParams.pasta;

							if ($scope.publicationPermission || $scope.movementPermission) {
								await $scope.recordParametersUsers();
								$scope.recordBriefcase($scope.briefcase);
							}
						}
					}
				})
				.finally(() => {
					$scope.loadingPage = false;
					$scope.loadingSide = false;
				});

			/** Verfica se existe permissão para chama método para trazer
			 *  palavras chave
			 */
			$scope.keywordsAll = () => {
				if (
					permissions.has('recordPublications') &&
					$scope.environmentPageMov == '1'
				)
					$scope.recordKeywords();
			};

			/** Método que fica observando se modal de prazos foi fechado
			 *  para resetar form do modal
			 */
			$('#modalCreateAgendaEventComponent').on('hide', () => {
				$rootScope.formCreatePrazo.taskToEdit.processo = {};

				return $scope.$resetFormValidation('createEvent')();
			});

			/** Verifica  existe palavra chave selecionada */
			if ($scope.filter.palavraChave && $scope.environmentPageMov == '1')
				$scope.consultarPalavraChave();

			$scope.googleSync = localStorage.getItem('gapi') == 'false';

			/** Fim das ações */

			/** Integração com a agenda */
			$scope.agendaEventDefault = {
				title: '',
				address: '',
				initialHour: '',
				wholeDay: false,
				eventTypeId: '',
				initialDate: '',
				observation: '',
				reminderTypeId: '',
				finalRecurrenceDate: '',
				recurringEventTypeId: ''
			};

			$scope.agendaEvent = helper.cloneSimpleObject($scope.agendaEventDefault);

			/** prepara registro para criação de vento evento vinculando
			 * movimento na agenda
			 */
			$scope.createAgendaEvent = async form => {
				$rootScope.creationEventLoading = true;

				//Recupera dados de sincronização
				let dataSync = integracaoGoogleCalendar.recoverInfos();

				$scope.googleSync = dataSync.sincronizado;

				const fields = [
					'titulo',
					'dataHora',
					'dataHoraInicio',
					'diaInteiro',
					'idLembrete',
					'idOpcaoLembreteAgenda',
					'idRepetEventoAgenda',
					'localizacao',
					// 'observacao',
					'idTipoEventoAgenda',
					'idMovProcessoCliente',
					'sincronizado'
				];

				let [
					titulo,
					dataHora = `${new Date().getHours()}:30`,
					dataHoraInicio = new Date().toLocaleDateString('pt-BR'),
					diaInteiro,
					idOpcaoLembreteAgenda = $rootScope.formCreatePrazo &&
					$rootScope.formCreatePrazo.idNotificacaoCompromisso
						? $rootScope.formCreatePrazo.idNotificacaoCompromisso
						: -1,
					idRepetEventoAgenda = -1,
					localizacao,
					idProcesso,
					// observacao,
					idTipoEventoAgenda,
					idTipoCompromisso,
					idMovProcessoCliente,
					sincronizado
				] = fields.map(input => $scope.getScopedInputValue(form[input]));

				if (form['localizacao']) {
					localizacao = $scope.getScopedInputValue(form['localizacao']);
				}

				if (
					$rootScope.formCreatePrazo &&
					$rootScope.formCreatePrazo.taskToEdit &&
					$rootScope.formCreatePrazo.taskToEdit.processo
				) {
					idProcesso =
						$rootScope.formCreatePrazo.taskToEdit.processo.idProcesso || null;
				}

				const endHour = $scope.getScopedInputValue(form.dataHoraFim);

				let importante, remoto, presencial;

				if (form && form['importante']) {
					importante =
						form['importante'].$viewValue || form['importante'].$modelValue;
				}

				if (form && form['presencial']) {
					presencial =
						form['presencial'].$viewValue || form['presencial'].$modelValue;
				}

				if (form && form['remoto']) {
					remoto = form['remoto'].$viewValue || form['remoto'].$modelValue;
				}

				const eventDate = `${dataHoraInicio.substr(
					3,
					2
				)}-${dataHoraInicio.substr(0, 2)}-${dataHoraInicio.substr(6)}`;

				let fixDate = eventDate.replace('-', '/').replace('-', '/');

				const initialDate =
					diaInteiro === true
						? new Date(`${fixDate}`).setHours(0, 0, 0)
						: new Date(`${fixDate} ${dataHora}`);

				if (diaInteiro == true || dataHora == '') {
					dataHora = '23:59:59';
				}

				const finalDate = new Date(`${fixDate} ${dataHora}`);

				const HoraAtual = new Date();

				HoraAtual.setHours(HoraAtual.getHours());

				const hour = parseInt(dataHora.substr(0, 2), 10);

				if (hour >= 23) finalDate.setHours(23, 59);
				else if (diaInteiro) {
					finalDate.setHours(23, 59);
				} else {
					finalDate.setHours(endHour.substr(0, 2), endHour.substr(3, 2));
				}

				if (!$scope.validationHours(initialDate, finalDate, form)) return;

				const checkbox = document.querySelector(
					'#modalCreateAgendaEvent #sincronizado'
				);

				if (checkbox) {
					sincronizado = checkbox.checked;
				}

				const event = {
					titulo,
					dataHoraInicio: moment(initialDate).format('YYYY-MM-DDTHH:mm:ss'),
					dataHoraFim: moment(finalDate).format('YYYY-MM-DDTHH:mm:ss'),
					idAgenda: $rootScope.idAgenda
						? $rootScope.idAgenda
						: $scope.agendas.getItems()[0].id,
					diaInteiro,
					idOpcaoLembreteAgenda,
					idRepetEventoAgenda,
					importante,
					localizacao,
					idProcesso,
					observacao: $rootScope.formCreatePrazo.taskToEdit.observacao,
					idTipoEventoAgenda: idTipoEventoAgenda
						? idTipoEventoAgenda
						: idTipoCompromisso,
					idCategoriaEventoAgenda:
						Number(idTipoCompromisso) === -3
							? $rootScope.formCreatePrazo.taskToEdit.idCategoriaEventoAgenda
							: undefined,
					sincronizado: $scope.googleSync ? !sincronizado : false,
					remoto,
					presencial,
					idsMovProcessosVinculados: [
						{
							idMovProcessoCliente: idMovProcessoCliente
								? idMovProcessoCliente
								: $scope.movementInAction.idMovProcessoCliente
						}
					]
				};

				if (event.sincronizado) {
					await integracaoGoogleCalendar.insertGoogleEvent(event, fields, form);
					setTimeout(() => {
						$scope.recordMovements($scope.movements);
						$scope.$resetFormValidation('createEvent')();
						$rootScope.formCreatePrazo.taskToEdit.processo = {};
					}, 500);
				} else {
					delete event['eventoGoogleId'];

					$scope.sendEvent(event, fields, form);
				}
			};

			/** Cria evento de agenda com movimento */
			$scope.sendEvent = (event, fields, form) => {
				return $http({
					...helper.http(API.deadlineEvents, 'POST'),
					data: { itens: [event] },
					messageOverride: {
						success(response, notify) {
							let idTipoEventoAgenda = -3;

							if (
								response &&
								response.data &&
								response.data.itens &&
								response.data.itens[0] &&
								response.data.itens[0].idTipoEventoAgenda
							) {
								idTipoEventoAgenda = response.data.itens[0].idTipoEventoAgenda;
							}

							let nameType =
								idTipoEventoAgenda == -3
									? 'Compromisso'
									: idTipoEventoAgenda == -1
									? 'Tarefa'
									: 'Prazo';

							notify.success(
								`${nameType} cadastrad${
									idTipoEventoAgenda == -1 ? 'a' : 'o'
								} com sucesso.`
							);
						}
					}
				})
					.then(() => {
						$scope.recordMovements($scope.movements);

						fields.map(inputKey =>
							helper.defer(() => {
								const $control = form[inputKey];

								if ($control) {
									switch (inputKey) {
										case 'idRepetEventoAgenda':
										case 'idOpcaoLembreteAgenda':
											$control.$setViewValue(-1);
											break;
										case 'idTipoCompromisso':
											$control.$setViewValue('');
											$control.$$ngModelSet('');
											$control.$$setModelValue('');
											break;
										case 'diaInteiro':
											$control.$setViewValue(false);
											$control.$$ngModelSet(false);
											$control.$$setModelValue(false);
											break;
										case 'dataHoraInicio':
											$control.$setViewValue(moment().format('DD/MM/YYYY'));
											break;
										case 'idTipoEventoAgenda':
										case 'idMovProcessoCliente':
											break;
										default:
											$control.$setViewValue('');
											break;
									}

									$control.$render();
								}
							})
						);

						$rootScope.formCreatePrazo.taskToEdit.processo = {};
						$scope.$resetFormValidation('createEvent')();

						$('#modalCreateAgendaEventComponent').modal('hide');
					})
					.finally(() => ($rootScope.creationEventLoading = false));
			};

			$rootScope.formCreatePrazo.getEventComponent = () => {
				setTimeout(() => {
					window.location.reload();
				}, 1000);
			};

			$scope.recordIntegration = async () => {
				//Recupera dados de sincronização
				$scope.dataSync = integracaoGoogleCalendar.recoverInfos();
				//aqui google agenda
				if (!$scope.dataSync)
					await integracaoGoogleCalendar.permissionIntegracao();
				//Recupera os dados de sincronização
				$scope.dataSync = integracaoGoogleCalendar.recoverInfos();
				$rootScope.sincronizacaoError =
					$scope.dataSync && !!$scope.dataSync.error;
				if ($scope.dataSync && $scope.dataSync.sincronizado) {
					$rootScope.emailGoogleAccount = true;
					$rootScope.emailGoogle = $scope.dataSync.email;
					$scope.sync = true;
				} else {
					$rootScope.emailGoogleAccount = $rootScope.sincronizacaoError
						? true
						: false;
					$rootScope.emailGoogle = false;
				}
				if ($rootScope.sincronizacaoError)
					$('#modalDisabledGoogleCalendarError').modal('show');
			};

			$scope.recordIntegration();

			$scope.openRecoverPastDeadlinesFromMovementsList = () => {
				if ($scope.movementInAction) {
					$rootScope.formCreatePrazo.afterGoogleSync = () => {
						$scope.modalAddEvent();
						$scope.openCreateAgendaEventModal($scope.movementInAction);
					};
				}

				$scope.openRecoverPastDeadlinesComponent('modalCreate');
			};

			$timeout(() => {
				$('#modalRecoverPastDeadlinesOneComponent').on(
					'hidden.bs.modal',
					function() {
						if ($rootScope.recoverPastDeadlinesClosingFromChoice) {
							$scope.sync = false;

							return;
						}

						$scope.syncGoogleEventsSchedule();

						if ($rootScope.formCreatePrazo.modalOpen == 'modalSync') {
							$('#modalSyncAgenda').modal('show');
						} else if ($rootScope.formCreatePrazo.modalOpen == 'modalCreate') {
							$('#modalCreateAgendaEventComponent').modal('show');
						}
						$scope.sync = false;
					}
				);
			}, 5000);

			/** verifica se esta sincronizado com o google agenda */
			$scope.checkSyncDeadlines = async (fn, movement) => {
				if (
					movement &&
					movement.pastasMovimento &&
					movement.pastasMovimento[0] &&
					movement.pastasMovimento[0].idTipoPasta == -3
				) {
					$rootScope.formCreatePrazo.taskToEdit.processo = {
						id: movement.pastasMovimento[0].id,
						nome: movement.pastasMovimento[0].nome,
						fixado: true
					};
				} else if (
					movement &&
					movement.movimento &&
					movement.movimento.andamentoProcesso &&
					movement.movimento.andamentoProcesso.idProcesso &&
					movement.movimento.andamentoProcesso.numeroProcesso
				) {
					$rootScope.formCreatePrazo.taskToEdit.processo = {
						id: movement.movimento.andamentoProcesso.idProcesso,
						nome: movement.movimento.andamentoProcesso.numeroProcesso,
						fixado: true
					};

					if (
						movement.movimento.pastas &&
						movement.movimento.pastas.length > 0 &&
						movement.movimento.pastas[0].nome
					) {
						$rootScope.formCreatePrazo.taskToEdit.processo.nome =
							movement.movimento.pastas[0].nome;
					}
				}

				$scope.closeAllMovements();

				//Recupera dados de sincronização
				let dataSync = integracaoGoogleCalendar.recoverInfos();

				//aqui google agenda
				if (!dataSync) await integracaoGoogleCalendar.permissionIntegracao();

				$rootScope.sincronizacaoError = dataSync.error == true ? true : false;

				if (!$rootScope.sincronizacaoError) {
					//Variavel que guarda se ta sincronizado ou não
					$scope.googleSync = dataSync.sincronizado;
					//Guarda intimação a ser vinculada com prazo
					$scope.movementInAction = movement;
					$rootScope.formCreatePrazo.idsMovProcessosVinculados = [
						{
							idMovProcessoCliente: $scope.movementInAction.idMovProcessoCliente
						}
					];
					//Variavel que guarda se ta sincronizado ou não, de forma geral '$rootScope'
					$rootScope.noSync = !dataSync.sincronizado ? true : false;

					//Verifica se e para mostrar mensagem de sincronização
					const showMessage = !integracaoGoogleCalendar.notAgainSincGoogleAgenda();

					if (!$scope.googleSync && showMessage) {
						$rootScope.formCreatePrazo.afterGoogleSync = () => {
							$scope.modalAddEvent();
							fn(movement);
						};
						$('#modalSyncAgenda').modal('show');
					} else {
						$scope.modalAddEvent();

						fn(movement);
					}
				} else {
					$('#modalDisabledGoogleCalendarError').modal('show');

					$scope.guardDataPrazos = {
						func: fn,
						mov: movement
					};
				}
			};

			//Dessincroniza quando da erro na sincronização
			$scope.disconnectSyncError = async () => {
				$scope.loadingDisconnectError = true;

				let dataSync = integracaoGoogleCalendar.recoverInfos();

				await integracaoGoogleCalendar.disconnectSync(
					dataSync.idAgendaGoogleCalendar
				);

				$('#modalDisabledGoogleCalendarError').modal('hide');

				$scope.loadingDisconnectError = false;
				$rootScope.sincronizacaoError = false;

				$scope.checkSyncDeadlines(
					$scope.guardDataPrazos.func,
					$scope.guardDataPrazos.mov
				);
			};

			/************* METODO PARA PASSAR EVENTO PRA SINCRONIZADO *************/
			$scope.modalAddEvent = () => {
				$rootScope.formCreatePrazo.taskToEdit.sincronizado = $rootScope.noSync;
			};
			/******************************** FIM ********************************/

			$scope.checkGoogleSync = () => ($scope.googleSync = true);

			$scope.showAgain = localStorage.getItem('showSyncMessage') || true;

			/** Abre modal de criação de agenda */
			$scope.openCreateAgendaEventModal = movement => {
				if (
					permissions.has('recordSchedule') &&
					$scope.agendas.items.length === 0 &&
					$scope.eventsTypes.items.length === 0
				) {
					!$rootScope.idAgenda && $scope.recordAgendas($scope.agendas);
					$scope.recordEventsTypes($scope.eventsTypes);
				}
				$scope.movementsPrazo = { ...movement };
				$('#modalCreateAgendaEventComponent').modal('show');
			};

			/** Método prepara movimentos para marcar como LIDAS as movimentações,
			 * quando e feita alguma ação quando ela esta não lida
			 * exemplo: (Enviar por email, Download etc)
			 */
			$scope.markAsReadAfterAction = () => {
				$timeout(() => {
					const movement = $scope.movementInAction;

					$scope.setMovementsAsRead(
						$rootScope.newPublicationChecked,
						movement,
						false
					);

					const checked = helper.cloneSimpleObject(
						$rootScope.newPublicationChecked || {}
					);

					if (checked && checked.length >= 2) {
						$scope.itemCheckedDisable = false;
					} else {
						$scope.itemCheckedDisable = true;
					}
				}, 500);
			};

			/** Método que fecha o modal quando usuário decide manter as
			 * movimentações como NÃO LIDAS
			 */
			$scope.declineMarkAsRead = () => {
				$scope.itemCheckedDisable = true;
				$scope.clearAll = false;
				$scope.itemChecked = false;
				$scope.movementInAction = null;

				$timeout(() => {
					$scope.printing = false;
				}, 300);

				$('#modalToggleAsRead').modal('hide');

				const checked = helper.cloneSimpleObject(
					$rootScope.newPublicationChecked
						? $rootScope.newPublicationChecked
						: []
				);

				if (checked && checked.length >= 2) {
					$scope.itemCheckedDisable = false;
				} else {
					$scope.itemCheckedDisable = true;
				}
			};

			/** OBSERVAÇÕES */
			$scope.editingObservation = null;

			$scope.deletingObservation = null;

			$scope.searchedObservations = false;

			$scope.loadingObservations = false;

			$scope.observationPagination = {
				paginaAtual: 0,
				paginaTotal: 0,
				registrosPorPagina: 10,
				registrosTotal: 0
			};

			$scope.observations = helper.responseStore();

			/** Oculta ou Torna visivel Observações, pasta processo */
			$scope.toggleObservation = () => {
				$scope.toggleObservations = !$scope.toggleObservations;

				if ($scope.toggleObservations && !$scope.searchedObservations) {
					$scope.recordObservations($scope.observations);
				}

				if ($scope.toggleObservations) {
					$timeout(() => {
						const textarea = document.getElementById('anotacao');

						if (textarea) textarea.focus();
					});
				}

				const el = document.getElementById('sourcesProcess');

				if (!el) return;

				if (!el.dataset.origDisplay) {
					const cur = getComputedStyle(el).display;

					el.dataset.origDisplay = cur && cur !== 'none' ? cur : 'block';
				}

				const isHidden = getComputedStyle(el).display === 'none';

				el.style.display = isHidden ? el.dataset.origDisplay : 'none';
			};

			/** Oculta ou Torna visivel opções de excluir/editar Observações,
			 * pasta processo
			 * */
			$scope.toggleAction = observation =>
				(observation.action = observation.action ? !observation.action : true);

			/** Método traz o registro de observações */
			$scope.recordObservations = (responseStore, page = 1) => {
				if ($scope.folderType !== -3) return;

				$scope.loadingObservations = true;

				$http({
					...helper.http(API.annotations, 'GET', {
						pasta: $stateParams.pasta
					}),
					params: {
						...helper.httpFields(['*']),
						ativo: true,
						paginaAtual: page,
						registrosPorPagina: 10
					}
				})
					.then(({ data }) => {
						if (page === 1) responseStore.setItems(data.itens);
						else responseStore.pushItems(data.itens);

						$scope.observationPagination = data.paginacao;
					})
					.finally(() => {
						$scope.searchedObservations = true;

						$scope.loadingObservations = false;
					});
			};

			/** Método que cria observação */
			$scope.createObservation = (observation, responseStore) => {
				$scope.printing = true;

				$http({
					...helper.http(API.annotations, 'POST', {
						pasta: $stateParams.pasta
					}),
					data: { ...observation },
					messageOverride: {
						success(response, notify) {
							notify.success('Observação adicionada!');
						},
						error(response, notify) {
							notify.success('Observação não adicionada!');
						}
					}
				}).then(({ data }) => {
					responseStore.unshiftItems(data.itens);

					observation.anotacao = '';

					$scope.$resetFormValidation('formCreateObservation')();

					$timeout(() => {
						const observationField = document.getElementById('anotacao');

						if (observationField) observationField.focus();
					});

					$scope.printing = false;
				});
			};

			/** Método que edita observação */
			$scope.editAnnotation = (observation, responseStore) => {
				$http({
					...helper.http(API.annotations, 'PUT', {
						pasta: $stateParams.pasta,
						id: observation.id
					}),
					data: { anotacao: observation.anotacao },
					messageOverride: {
						success(response, notify) {
							notify.success('Observação editada!');
						},
						error(response, notify) {
							notify.success('Observação não editada!');
						}
					}
				})
					.then(({ data }) => {
						// Atualiza a anotação na lista diretamente pela responseStore
						responseStore.updateItem(data.itens[0], 'id', observation.id);

						$scope.$resetFormValidation('editObservation')();
					})
					.catch(() => (observation.anotacao = observation.originalText))
					.finally(() => {
						observation.action = false;

						$scope.editingObservation = null;

						$timeout(() => {
							const createObservationField = document.getElementById(
								'anotacao'
							);

							if (createObservationField) createObservationField.focus();
						});
					});
			};

			/** Método que prepara observação pra edição */
			$scope.setEditingObservation = observation => {
				observation.action = false;

				observation.originalText = observation.anotacao;

				$scope.editingObservation = Object.assign({}, observation);

				$timeout(() => {
					const observationField = document.getElementById(
						`editMovimentTextObservations-${observation.id}`
					);

					if (observationField) observationField.focus();
				});
			};

			/** Método que cancela edição de observação */
			$scope.cancelEditingObservation = observation => {
				observation.action = false;

				$scope.editingObservation = null;

				observation.anotacao = observation.originalText;

				$timeout(() => {
					const createObservationField = document.getElementById('anotacao');

					if (createObservationField) createObservationField.focus();
				});
			};

			/** Método que prepara observação para exclusão */
			$scope.setDeletingObservation = observation => {
				observation.action = false;

				$scope.deletingObservation = observation;

				$('#modalInactivateObservation').modal('show');
			};

			/** Método de deleta observação */
			$scope.deleteObservation = responseStore => {
				const observation = $scope.deletingObservation;

				$http({
					...helper.http(API.annotations, 'inativar', {
						pasta: $stateParams.pasta,
						id: observation.id
					}),
					method: 'PUT',
					data: { anotacao: observation.anotacao },
					messageOverride: {
						success(response, notify) {
							notify.success('Observação excluída!');
						},
						error(response, notify) {
							notify.success('Observação não excluída!');
						}
					}
				})
					.then(({ data }) => responseStore.removeItems(data.itens, 'id'))
					.finally(() => {
						$scope.deletingObservation = null;

						$('#modalInactivateObservation').modal('hide');
					});
			};

			//******* Métodos relacionados a filtros publicações gerais ***********

			/** Método que limpa todos os filtros selecionados na pagina de
			 * publicações geral
			 */
			$scope.clearAllCustom = () => {
				if ($stateParams.folderType != '-2' || !$stateParams.folderType) {
					$scope.filter = [];
				} else if ($stateParams.folderType == '-2') {
					$scope.filter = {};

					const data = ['pasta', 'folderType', 'dataInicial', 'dataFinal', 'p'];

					data.forEach(value => {
						$scope.filter[value] = $stateParams[value];
					});

					$scope.verifyPeriods(['dataInicial', 'dataFinal']);
					delete $scope.filter['dataInicial'];
					delete $scope.filter['dataFinal'];
				}

				$scope.keyWordAccount &&
					$scope.keyWordAccount.forEach(k => (k.checked = false));
				$scope.diaryAccount &&
					$scope.diaryAccount.forEach(d => (d.checked = false));
				$scope.notebooksAccount &&
					$scope.notebooksAccount.forEach(n => (n.checked = false));

				$scope.filterMovements($scope.filter, true);
			};

			/** Método que limpa filtro selecionado de forma individual na pagina de
			 * publicações geral
			 */
			$scope.clearFilterCustom = (k, f, index, records, clearAll = false) => {
				const checked = f[index];

				if (checked) {
					records.forEach(item => {
						if (k == 'key' && item.idPalavraChave == checked.idPalavraChave)
							item.checked = false;
						else if (k == 'diary' && item.idDiario == checked.idDiario)
							item.checked = false;
						else if (k == 'notebook' && item.idCadernoDiario == checked.id)
							item.checked = false;
					});
				} else {
					records.forEach(item => (item.checked = false));
				}

				if (k == 'diary' && $scope.badgeNotebook)
					records.forEach(d => {
						$scope.notebooksAccount.forEach(c => {
							if (!d.checked && d.idDiario === c.idDiario) c.checked = false;
						});
					});

				if (clearAll) {
					$scope.filterMovements($scope.filter, clearAll);
				}

				$scope.selectedFilter($scope.filter);
			};

			/** Método que expande o filtro de palavra chave personalizado */
			$scope.expandedKeyword = () => {
				var checkboxes = document.getElementById('checkboxes');
				var arrow = document.getElementById('arrow');

				setTimeout(() => {
					$scope.closeKeyword(checkboxes, arrow);
				}, 100);

				if (!$scope.expanded) {
					if (!$scope.keyWordAccount) {
						$scope.loadingKeywords = true;
						$scope.filterKeywords();
					}

					checkboxes.style.display = 'block';
					$scope.expanded = true;

					arrow.style.transform = 'rotate(180deg)';

					!$scope.notKeyword && $scope.focusElement('inputBuscaPalavra');
				} else {
					checkboxes.style.display = 'none';
					$scope.expanded = false;

					arrow.style.transform = 'rotate(360deg)';
				}
			};

			/** Método para previnir click na tecla enter dentro dos filtros
			 * para não causar erros
			 */
			$scope.keypressEnter = event => {
				event.preventDefault();
			};

			/** Método para focar elemento dos filtros */
			$scope.focusElement = id => {
				setTimeout(() => {
					document.getElementById(id).focus();
				}, 100);
			};

			/** Método que fecha filtro de palavra chave personalidado */
			$scope.closeKeyword = (checkboxes, arrow) => {
				$(document).click(function(e) {
					if ($(e.target).is('.clickoutCampanha ')) return;

					if (!$(e.target).is('.searching')) {
						if (($scope.expanded = true)) {
							checkboxes.style.display = 'none';
							$scope.expanded = false;

							arrow.style.transform = 'rotate(360deg)';
						}
					}
				});
			};

			/** Método para pesquisa de palavra chave dentro do filtro */
			$scope.keywordSearch = async (keyword, clear) => {
				$scope.keywordPesq = true;

				if (keyword.length > 2) $scope.filterKeywords(keyword, true);
				else if (keyword.length == 0) {
					$scope.keywordPesq = false;
					$scope.clearRecordsKey = true;
					$scope.keyWordClose = false;
					await $scope.filterKeywords(null, true, clear);
					$scope.keywordSelected('');
					$scope.clearRecordsKey = false;
				}
			};

			/** Método que verifica se existe uma palavra chave selecionada
			 * dentro do filtro
			 */

			$scope.keywordSelected = keyword => {
				var keyWordChecked = $scope.keyWordAccount.filter(key => key.checked);

				const keyWordPesq = $scope.palavraChavesUsuario.filter(item => {
					return (
						item.nomePastaUsuarioCliente
							.toLowerCase()
							.indexOf(keyword.toLowerCase()) > -1 && !item.checked
					);
				});

				$scope.keyWordAccount = [];

				if (keyWordChecked) $scope.keyWordAccount = [...keyWordChecked];

				$scope.keyWordAccount.push(...keyWordPesq);

				if (!keyword) $scope.keyWordAccount = $scope.palavraChavesUsuario;

				$scope.keyWordIcon(keyword);
			};

			/** Método que verifica se existe filtro selecionado */
			$scope.hasFilters = (filter, checked, allCheck) => {
				$scope.diaryChanges = true;

				if (filter === 'key') {
					$scope.keyWordCheckTotal = $scope.keyWordAccount.filter(
						k => k.checked
					);

					if (
						typeof checked === 'boolean' &&
						$scope.keyWordCheckTotal.length === 0
					) {
						$scope.titleKeywords = 'Todas palavras-chave';

						return;
					}

					if (checked === undefined) {
						let selects = JSON.parse(sessionStorage.getItem('__selected__'));

						if (!selects || !selects.IdsPalavraChave) {
							$scope.titleKeywords = 'Todas palavras-chave';

							return;
						}

						let array = selects.IdsPalavraChave.split(',');

						array.forEach(d => {
							$scope.keyWordAccount.find(
								diary => diary.idPalavraChave == d
							).checked = true;
						});

						$scope.keyWordCheckTotal = $scope.keyWordAccount.filter(
							k => k.checked
						);
					}

					$scope.hasKeyWords = $scope.keyWordCheckTotal.length ? true : false;

					$scope.titleKeywords = $scope.keyWordCheckTotal.length
						? `${$scope.keyWordCheckTotal.length} Palavra(s)-chave selecionada(s)`
						: 'Todas palavras-chave';

					$scope.keywordFalse = checked == false ? true : false;
					checked || checked == false
						? ($scope.keywordChanges = true)
						: ($scope.keywordChanges = false);

					if (
						$scope.keywordChanges &&
						$scope.diaryAccount &&
						(checked || checked == false)
					) {
						$scope.notCheckParamsUrl = true;
					}

					if (!$scope.keyWordCheckTotal.length && $scope.diaryAccount) {
						$scope.diaryAccount.forEach(n => {
							n.checked = false;
						});
						$scope.hasFilters('diary');
					}
				} else if (filter === 'diary') {
					if (allCheck) {
						$scope.clickCheckboxDiary = true;
					} else {
						$scope.clickCheckboxDiary = false;
					}

					$scope.diaryCheckTotal = $scope.diaryAccount.filter(k => k.checked);

					if (
						typeof checked === 'boolean' &&
						$scope.diaryCheckTotal.length === 0
					) {
						$scope.titleDiaries = 'Todos diários';

						if ($scope.notebooksAccount) {
							$scope.clearAppointments('notebook', $scope.notebooksAccount);
						}

						$scope.hasDiary = false;
						$scope.diaryUnchecked = true;

						return;
					}

					if (checked === undefined) {
						let selects = JSON.parse(sessionStorage.getItem('__selected__'));

						if (!selects || !selects.IdsDiarios) {
							$scope.titleDiaries = 'Todos diários';

							return;
						}

						let array = selects.IdsDiarios.split(',');

						array.forEach(d => {
							let foundDiaryAccount = $scope.diaryAccount.find(
								diary => diary.idDiario == d
							);

							if (foundDiaryAccount) foundDiaryAccount.checked = true;
						});

						$scope.diaryCheckTotal = $scope.diaryAccount.filter(k => k.checked);
					}

					if (!$scope.diaryCheckTotal.length && $scope.filter.diario)
						$scope.diaryUnchecked = true;

					$scope.hasDiary = $scope.diaryCheckTotal.length ? true : false;

					$scope.titleDiaries = $scope.diaryCheckTotal.length
						? `${$scope.diaryCheckTotal.length} Diário(s) selecionado(s)`
						: 'Todos diários';

					if ($scope.diaryCheckTotal.length) {
						$scope.diaryFalse =
							$scope.keywordFalse || checked == false ? true : false;
					} else {
						$scope.notebooksAccount &&
							$scope.notebooksAccount.forEach(n => (n.checked = false));
					}

					$scope.diaryChanges = true;
					if (!$scope.diaryCheckTotal.length && $scope.notebooksAccount) {
						$scope.notebooksAccount.forEach(n => {
							n.checked = false;
						});
						$scope.hasFilters('notebook');
					}

					if ($scope.notebooksAccount) {
						$scope.diaryAccount.forEach(d => {
							$scope.notebooksAccount.forEach(n => {
								if (d.idDiario === n.idDiario && !d.checked && n.checked)
									n.checked = false;
							});
						});
						$scope.hasFilters('notebook');
					}
				} else if (filter === 'notebook' && !!$scope.notebooksAccount) {
					$scope.notebookCheckTotal = $scope.notebooksAccount.filter(
						k => k.checked
					);

					$scope.titleNotebooks = $scope.notebookCheckTotal.length
						? `${$scope.notebookCheckTotal.length} Caderno(s) selecionado(s)`
						: 'Todos cadernos';
				}
			};

			/** Método que controla icone de limpar pesquisa dentro do
			 * filtro de palavra chave
			 */
			$scope.keyWordIcon = pesq => {
				if (pesq) $scope.keyWordClose = true;
				else {
					$scope.keyWordClose = false;
					$scope.keywordPesq = false;
				}
			};

			/** Método que marca todos os registros nos filtros */
			$scope.markAllAppointments = (f, records) => {
				if (f == 'diary') {
					if (
						$scope.hasDiary === true &&
						$scope.diaryUnchecked === false &&
						$scope.clickCheckboxDiary
					) {
						return;
					} else {
						$scope.hasDiary = true;
						$scope.diaryUnchecked = false;
					}
				}

				records.forEach(r => {
					r.checked = true;
				});

				$scope.hasFilters(f, true, true);
			};

			/** Método que desmarca registro selecionados nos filtros */
			$scope.clearAppointments = (f, records) => {
				if (f == 'key') {
					$scope.hasKeyWords = false;
					$scope.keyWordsUnchecked = true;
				} else if (f == 'diary') {
					$scope.hasDiary = false;
					$scope.diaryUnchecked = true;
				}

				// const checked = records.filter(r => r.checked);

				records.forEach(r => {
					r.checked = false;
				});

				$scope.hasFilters(f, false);

				// checked.length && f == 'key' && $scope.filterDiaries();
				if (f == 'key') $scope.keywordChanges = true;
			};

			/** Método que limpa pesquisa dentro dos filtros */
			$scope.clearSearch = (key, id, param) => {
				if (key == 'palavra') {
					$scope.keyWordSearch = '';
					$scope.keyWordClose = false;
					$scope.keywordSearch($scope.keyWordSearch, param);
				} else if (key == 'diario') {
					$scope.diarySearch = '';
					$scope.diaryClose = false;
					$scope.dailySearch($scope.diarySearch);
				} else if (key == 'caderno') {
					$scope.notebooksSearch = '';
					$scope.notebooksClose = false;
					$scope.notebookSearch($scope.notebooksSearch, param);
				} else if (key == 'tribunais') {
					$scope.courtsClose = false;
					$scope.notCourts = false;
					$scope.courtsSearch = '';
					$scope.clientUserJudicialOrgansList.setItems($scope.guardCourts);
				} else if (key == 'fontes') {
					$scope.sourcesClose = false;
					$scope.notSources = false;
					$scope.sourcesSearch = '';
					$scope.requestedProcessesSourcesParams.setItems($scope.guardSources);
				}

				document.getElementById(id).value = '';
			};

			/** Método que traz as palavras chave para preencher o filtro */
			$scope.filterKeywords = async (page, param, clear) => {
				if (!$scope.keywordPesq) {
					const pageSaved = parseInt(localStorage.getItem('__pageKeyword__'));

					$scope.pageKeywords = !page && pageSaved ? pageSaved : 10;

					if (page) $scope.actual += 10;

					let sub = $scope.actual >= 100 ? 2 : $scope.actual > 10 ? 1 : 1;

					if (clear) {
						$scope.pageKeywordsActual = 1;
					} else {
						$scope.pageKeywordsActual = parseInt(
							$scope.actual.toString().substring(0, sub)
						);
					}

					if (!page) $scope.actual = $scope.pageKeywords;
				} else {
					$scope.pageKeywords = 999;
					$scope.pageKeywordsActual = 1;
				}

				await $http({
					...helper.http(API.briefcase, 'filterKeywords'),
					params: {
						...helper.httpFields(['*']),
						registrosPorPagina: $scope.pageKeywords,
						paginaAtual: $scope.pageKeywordsActual,
						nome: $scope.keywordPesq ? page : null,
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null
					},
					noCancelOnRouteChange: true
				})
					.then(response => {
						if (response.data.itens) {
							$scope.paginacaoKeywords = response.data.paginacao;
							response.data.itens.length < 10
								? ($scope.paginacaoDisabled = true)
								: ($scope.paginacaoDisabled = false);

							!$scope.keyWordClose &&
								response.data.itens.length < 10 &&
								localStorage.setItem('key', 'disabled');

							$scope.keyHidden = localStorage.getItem('key');

							if ($scope.pageKeywordsActual > 1)
								$scope.palavraChavesUsuario.push(...response.data.itens);
							else if (!$scope.keywordPesq)
								$scope.palavraChavesUsuario = response.data.itens;
							else {
								$scope.palavraChavesUsuario.push(...response.data.itens);

								$scope.palavraChavesUsuario = Array.from(
									new Set(
										$scope.palavraChavesUsuario.map(s => s.idPalavraChave)
									)
								).map(id => {
									return $scope.palavraChavesUsuario.find(
										s => s.idPalavraChave === id
									);
								});
							}

							$scope.keyWordAccount = $scope.palavraChavesUsuario;

							$scope.notKeyword =
								!$scope.keyWordAccount.length &&
								!$scope.palavraChavesUsuario.length
									? true
									: false;

							if ($scope.clearRecordsKey && $scope.keyWordCheckTotal) {
								$scope.keyWordCheckTotal.forEach(key => {
									$scope.keyWordAccount.forEach(k => {
										if (k.idPalavraChave === key.idPalavraChave)
											k.checked = true;
									});
								});
							}

							$scope.keywordPesq && $scope.keywordSelected(page);
							!$scope.keywordPesq &&
								localStorage.setItem('__pageKeyword__', $scope.actual);

							if (
								($scope.filter.palavraChave ||
									$scope.keyWordCheckTotal.length) &&
								!$scope.keyWordsUnchecked
							) {
								$scope.badgeKeyword = [];
								if (
									!$scope.keyWordCheckTotal.length &&
									$scope.filter.palavraChave
								) {
									const ids = $scope.filter.palavraChave.split(',');

									ids.forEach(id => {
										$scope.keyWordAccount.forEach(key => {
											if (key.idPalavraChave == id) key.checked = true;
										});
									});
								}

								var exits = !$scope.keyWordCheckTotal
									? JSON.parse(localStorage.getItem('__keywordsChecked__'))
									: $scope.keyWordCheckTotal;
								var hasChecked = [...exits];

								hasChecked.forEach(e => {
									$scope.keyWordAccount.forEach(k => {
										if (e.idPalavraChave == k.idPalavraChave && k.checked) {
											var has = exits.filter(
												h => h.idPalavraChave != k.idPalavraChave
											);

											exits = [...has];
										}
									});
								});

								exits.length && $scope.keyWordAccount.push(...exits);

								$scope.keyWordAccount.forEach(k => {
									if (k.checked)
										$scope.badgeKeyword.push({
											nomePalavraChave: k.nomePastaUsuarioCliente,
											idPalavraChave: k.idPalavraChave
										});
								});

								if (param) {
									$scope.hasFilters('key', true);
								} else {
									$scope.hasFilters('key');
								}

								!page &&
									$scope.filter.palavraChave &&
									$scope.filter.diario &&
									$scope.filterDiaries();
							}
						}
					})
					.finally(() => {
						$scope.loadingKeywords = false;
					});
			};

			/** verifica se existe permissão ou se esta na página de
			 * publicações para chamar o método que traz palavras chave
			 * */
			$scope.keywordPubliGeneral = () => {
				if (
					($scope.environmentPageMov == '2' ||
						$scope.environmentPageMov == '5' ||
						$scope.environmentPageMov == '1') &&
					permissions.has('recordPublications') &&
					$scope.filter.palavraChave
				)
					$scope.filterKeywords();
			};

			/** Método que expande o filtro de diários personalizado */
			$scope.expandedDiaries = () => {
				if ($scope.keywordChanges) {
					$scope.diarySearch = '';
					$scope.loadingDiary = true;
					$scope.diaryClose = false;
					$scope.diaryPesq = false;
					if (document.getElementById('inputBuscaDiario'))
						document.getElementById('inputBuscaDiario').value = '';
					$scope.filterDiaries(null, 'key', true);
				} else if (
					!$scope.diaryAccount ||
					$scope.diaryAccount.length === 0 ||
					!$scope.keyWordCheckTotal.length
				) {
					$scope.loadingDiary = true;

					if (document.getElementById('inputBuscaDiario')) {
						if (document.getElementById('inputBuscaDiario').value) {
							if (
								document.getElementById('inputBuscaDiario').value.length > 2
							) {
								$scope.filterDiaries(
									document.getElementById('inputBuscaDiario').value,
									undefined,
									true
								);
							} else {
								$scope.filterDiaries(null, undefined, true);
							}
						}
						if (
							!$scope.diaryAccount &&
							!document.getElementById('inputBuscaDiario').value
						) {
							$scope.filterDiaries(null, undefined, true);
						} else {
							$scope.loadingDiary = false;
						}
					} else {
						$scope.filterDiaries(null, undefined, true);
					}
				} else if ($scope.keyWordCheckTotal.length) {
					if (document.getElementById('inputBuscaDiario')) {
						if (document.getElementById('inputBuscaDiario').value) {
							if (
								document.getElementById('inputBuscaDiario').value.length > 2
							) {
								$scope.filterDiaries(
									document.getElementById('inputBuscaDiario').value,
									undefined,
									true
								);
							}
						}
					}

					if ($scope.clickKey) {
						$scope.filterDiaries(null, undefined, true);
					}
				}

				var checkboxes = document.getElementById('checkboxesDiaries');
				var arrow = document.getElementById('arrowDiaries');

				setTimeout(() => {
					$scope.closeDiaries(checkboxes, arrow);
				}, 100);

				if (!$scope.expandedDiary) {
					checkboxes.style.display = 'block';
					$scope.expandedDiary = true;

					arrow.style.transform = 'rotate(180deg)';

					!$scope.notDiary && $scope.focusElement('inputBuscaDiario');
				} else {
					checkboxes.style.display = 'none';
					$scope.expandedDiary = false;

					arrow.style.transform = 'rotate(360deg)';
				}
			};

			/** Método que fecha filtro de diários personalizado */
			$scope.closeDiaries = (checkboxes, arrow) => {
				$(document).click(function(e) {
					if ($(e.target).is('.clickoutCampanha ')) return;

					if (!$(e.target).is('.searchingDiary')) {
						if (($scope.expandedDiary = true)) {
							checkboxes.style.display = 'none';
							$scope.expandedDiary = false;

							arrow.style.transform = 'rotate(360deg)';

							$scope.keywordChanges = false;
						}
					}
				});
			};

			/** Método que controla icone de limpar pesquisa dentro do
			 * filtro de diários
			 */
			$scope.diaryIcon = pesq => {
				if (pesq) $scope.diaryClose = true;
				else {
					$scope.diaryClose = false;
					$scope.diaryPesq = false;
				}
			};

			/** Método para pesquisa de diários dentro do filtro */
			$scope.dailySearch = async diary => {
				$scope.diaryPesq = true;

				if (diary.length > 2) $scope.filterDiaries(diary, undefined, true);
				else if (diary.length == 0) {
					$scope.diaryPesq = false;
					$scope.diaryClose = false;
					$scope.clearRecordsDia = true;
					await $scope.filterDiaries(null, undefined, true);
					$scope.diarySelected('');
					$scope.clearRecordsDia = false;
				}
			};

			/** Método que verifica se existe diário selecionado
			 * dentro do filtro
			 */
			$scope.diarySelected = diary => {
				if (diary || diary == '') {
					const diaryChecked = $scope.diaryAccount.filter(
						diary => diary.checked
					);

					if ($scope.diariosUsuario) {
						const diaryPesq = $scope.diariosUsuario.filter(item => {
							return (
								item.nomeDiario.toLowerCase().indexOf(diary.toLowerCase()) >
									-1 && !item.checked
							);
						});

						$scope.diaryAccount = [];

						if (diaryChecked.length) $scope.diaryAccount = [...diaryChecked];

						$scope.diaryAccount.push(...diaryPesq);

						if (!diary) $scope.diaryAccount = $scope.diariosUsuario;
					}
					$scope.diaryIcon(diary);
				}
			};

			$scope.returnDiariesUrls = async () => {
				if (!$scope.filter.diario) localStorage.removeItem('__diarysChecked__');

				$scope.existDiary = JSON.parse(
					localStorage.getItem('__diarysChecked__')
				);

				if (!$scope.existDiary && $scope.filter.diario)
					await $http({
						...helper.http(API.diaries, 'GET'),
						params: {
							campos: '*',
							IDs: $scope.filter.diario,
							SomenteComPesquisaAtiva: true
						}
					}).then(response => {
						$scope.existDiary = [];

						response.data.itens.forEach(value => {
							let infos = {
								checked: true,
								descricaoDiario: value.descricao,
								idDiario: value.id,
								nomeDiario: value.nome
							};

							$scope.existDiary.push(infos);
						});

						localStorage.setItem(
							'__diarysChecked__',
							JSON.stringify($scope.existDiary)
						);
					});
			};
			/** Método que traz diários para preencher o filtro */
			$scope.filterDiaries = async (page, k, param) => {
				const { paginaTotal } = $scope.paginacaoDiario;

				let equals =
					$scope.pageDiaryActual && paginaTotal
						? $scope.pageDiaryActual === paginaTotal
							? true
							: false
						: false;

				equals =
					$scope.keywordChanges ||
					$scope.keyWordsUnchecked ||
					$scope.diaryPesq ||
					$scope.clearRecordsDia
						? false
						: equals;

				if (equals) return;

				var idPalavraChave = [];

				if (['1', '2', '5'].includes($scope.environmentPageMov)) {
					$scope.keyWordAccount &&
						$scope.keyWordAccount.forEach(k => {
							if (k.checked) idPalavraChave.push(k.idPalavraChave);
						});

					if (idPalavraChave.length) idPalavraChave = idPalavraChave.join(',');
				} else {
					let pasta = $scope.briefcase.getItems();
					let id = pasta.idPalavraChave
						? pasta.idPalavraChave
						: pasta.palavraChave;

					idPalavraChave.push(id);
				}

				if (!$scope.diaryPesq) {
					const pageSaved = !k
						? parseInt(localStorage.getItem('__pageDiary__'))
						: 10;

					$scope.pageDiary = !page && pageSaved ? pageSaved : 10;

					if (page) $scope.actualDiary += 10;
					else if (k) $scope.actualDiary = 10;

					let sub =
						$scope.actualDiary >= 100 ? 2 : $scope.actualDiary > 10 ? 1 : 1;

					$scope.pageDiaryActual = parseInt(
						$scope.actualDiary.toString().substring(0, sub)
					);

					if (!page) $scope.actualDiary = $scope.pageDiary;
				} else {
					$scope.pageDiaryActual = 1;
					$scope.pageDiary = 999;
				}

				if ($scope.environmentPageMov == '5') {
					$scope.estaNaLixeiraDiario = true;
				} else {
					$scope.estaNaLixeiraDiario = null;
				}

				await $http({
					...helper.http(API.diaries, 'searchPublication'),
					params: {
						IdsPalavraChave:
							idPalavraChave.length && idPalavraChave[0]
								? idPalavraChave
								: null,
						IdGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null,
						nome: $scope.diaryPesq ? page : null,
						SomenteComPesquisaAtiva: true,
						Lixeira: $scope.estaNaLixeiraDiario
					}
				}).then(async response => {
					if (response.data.paginacao) {
						$scope.paginacaoDiario = response.data.paginacao;
					} else {
						$scope.paginacaoDiario.length = 0;
					}

					const {
						data: { itens }
					} = response;

					itens.sort((a, b) => a.nomeDiario.localeCompare(b.nomeDiario));

					if ($scope.pageDiaryActual > 1) $scope.diariosUsuario.push(...itens);
					else if (!$scope.diaryPesq) $scope.diariosUsuario = itens;
					else {
						$scope.diariosUsuario.push(...response.data.itens);

						$scope.diariosUsuario = Array.from(
							new Set($scope.diariosUsuario.map(s => s.idDiario))
						).map(id => {
							return $scope.diariosUsuario.find(s => s.idDiario === id);
						});
					}

					$scope.diaryAccount = $scope.diariosUsuario;

					$scope.notDiary =
						!$scope.diaryAccount.length && !$scope.diariosUsuario.length
							? true
							: false;

					if ($scope.clearRecordsDia) {
						$scope.diaryCheckTotal.forEach(key => {
							$scope.diaryAccount.forEach(k => {
								if (k.idDiario === key.idDiario) k.checked = true;
							});
						});
					}

					$scope.diaryPesq && $scope.diarySelected(page);
					!$scope.diaryPesq &&
						localStorage.setItem('__pageDiary__', $scope.actualDiary);

					if (
						$scope.keywordFalse &&
						$scope.keyWordCheckTotal.length &&
						$scope.diaryCheckTotal
					) {
						let array = $scope.diaryCheckTotal.map(
							d => $scope.diaryAccount.filter(c => d.idDiario == c.idDiario)[0]
						);

						$scope.diaryCheckTotal = array.filter(d => d != undefined);

						$scope.diaryCheckTotal.forEach(t => {
							$scope.diaryAccount.forEach(d => {
								if (t.idDiario == d.idDiario) d.checked = true;
							});
						});
					} else if ($scope.keywordFalse && !$scope.keyWordCheckTotal.length) {
						$scope.diaryCheckTotal = [];
					}

					if (
						($scope.filter.diario && !$scope.badgeDiary.length) ||
						($scope.diaryCheckTotal && !$scope.keywordFalse)
					) {
						if ($scope.diaryCheckTotal == undefined)
							$scope.diaryCheckTotal = [];

						if (
							$scope.filter.diario &&
							!$scope.diaryCheckTotal.length &&
							!$scope.notCheckParamsUrl
						) {
							$scope.diaryCheckTotal = [];

							if (!$scope.diaryUnchecked) {
								const ids = $scope.filter.diario.split(',');

								ids.forEach(id => {
									$scope.diaryAccount.forEach(key => {
										if (key.idDiario == id) key.checked = true;
									});
								});
							}
						}

						var exits = null;

						if (
							!$scope.diaryCheckTotal.length &&
							!$scope.notCheckParamsUrl &&
							!$scope.diaryUnchecked
						) {
							await $scope.returnDiariesUrls();
							exits = $scope.existDiary;
						} else {
							exits = $scope.diaryCheckTotal;
						}

						if (!exits) exits = [];

						var hasChecked = [...exits];

						hasChecked.forEach(e => {
							$scope.diaryAccount.forEach(k => {
								if (e.idDiario == k.idDiario) k.checked = true;
								if (e.idDiario == k.idDiario && k.checked) {
									var has = exits.filter(h => h.idDiario != k.idDiario);

									exits = [...has];
								}
							});
						});

						exits.length && $scope.diaryAccount.push(...exits);

						$scope.diaryAccount = Array.from(
							new Set($scope.diaryAccount.map(s => s.idDiario))
						).map(id => {
							return $scope.diaryAccount.find(s => s.idDiario === id);
						});

						if (
							$scope.filter.diario &&
							!$scope.badgeDiary.length &&
							!$scope.diaryUnchecked
						) {
							$scope.diaryAccount.forEach(k => {
								if (k.checked)
									$scope.badgeDiary.push({
										nomeDiario: k.nomeDiario,
										idDiario: k.idDiario
									});
							});

							$scope.badgeDiary = Array.from(
								new Set($scope.badgeDiary.map(s => s.idDiario))
							).map(id => {
								return $scope.badgeDiary.find(s => s.idDiario === id);
							});
						}

						$scope.filter.diario &&
							!$scope.diaryPesq &&
							$scope.pageNotebookNew();
					}

					!$scope.badgeDiary.length &&
						localStorage.removeItem('__pageNotebook__');

					if (param) {
						$scope.hasFilters('diary', true);
					} else {
						$scope.hasFilters('diary');
					}

					$scope.keywordFalse = false;

					$scope.loadingDiary = false;

					$scope.keywordChanges = false;
					$scope.keyWordsUnchecked = false;
				});
			};

			$scope.diaryGeneral = () => {
				if (
					['1', '2', '3', '5'].includes($scope.environmentPageMov) &&
					permissions.has('recordPublications') &&
					!$scope.filter.palavraChave &&
					$scope.filter.diario
				)
					$scope.filterDiaries();
			};

			/** CADERNOS */
			$scope.expandedNotebook = false;
			$scope.titleNotebooks = 'Todos cadernos';
			$scope.notebooksClose = false;
			$scope.pageNotebook = 10;
			$scope.badgeNotebook = [];

			/** Método que expande o filtro de cadernos personalizado */
			$scope.expandedNotebooks = () => {
				if ($scope.diaryChanges) {
					$scope.loadingNotebook = true;
					$scope.notebooksSearch = '';
					$scope.notebooksClose = false;
					document.getElementById('inputBuscaCaderno').value = '';
					$scope.notebookPesq = false;
					$scope.pageNotebookNew();
				}

				var checkboxes = document.getElementById('checkboxesNotebooks');
				var arrow = document.getElementById('arrowNotebooks');

				setTimeout(() => {
					$scope.closeNotebook(checkboxes, arrow);
				}, 100);

				if (!$scope.expandedNotebook) {
					checkboxes.style.display = 'block';
					$scope.expandedNotebook = true;

					arrow.style.transform = 'rotate(180deg)';

					$scope.focusElement('inputBuscaCaderno');
				} else {
					checkboxes.style.display = 'none';
					$scope.expandedNotebook = false;

					arrow.style.transform = 'rotate(360deg)';
				}

				$scope.diaryChanges = false;
			};

			/** Método que controla icone de limpar pesquisa dentro do
			 * filtro de cadernos
			 */
			$scope.notebooksIcon = pesq => {
				if (pesq) $scope.notebooksClose = true;
				else {
					$scope.notebooksClose = false;
					$scope.notebookPesq = false;
				}
			};

			/** Método para pesquisa de cadernos dentro do filtro */
			$scope.notebookSearch = async (notebook, param) => {
				$scope.notebookPesq = true;

				if (notebook.length > 2) {
					$scope.pageNotebookNew(notebook);
				} else if (notebook.length == 0) {
					$scope.notebookPesq = false;
					$scope.clearRecordsNot = true;
					$scope.notebooksClose = false;
					await $scope.pageNotebookNew(undefined, param);
					$scope.notebooksSelected('');
					$scope.clearRecordsNot = false;
				}
			};

			/** Método que verifica se existe caderno selecionado
			 * dentro do filtro
			 */
			$scope.notebooksSelected = searchQuery => {
				if (searchQuery ? true : searchQuery == '') {
					$scope.notebooksAccount = $scope.notebooksAccount
						.filter(notebook => notebook.checked)
						.concat(
							$scope.cadernosUsuario.filter(item => {
								return (
									item.descricaoCadernoDiario
										.toLowerCase()
										.indexOf(searchQuery.toLowerCase()) > -1 && !item.checked
								);
							})
						);

					if (!searchQuery) {
						$scope.notebooksAccount = $scope.cadernosUsuario;
					}

					$scope.notebooksIcon(searchQuery);
				}
			};

			/** Método que fecha filtro de cadernos personalidado */
			$scope.closeNotebook = (checkboxes, arrow) => {
				$(document).on('click', function(e) {
					if ($(e.target).is('.clickoutCampanha ')) return;

					if (!$(e.target).is('.searchingNotebook')) {
						if ($scope.expandedNotebook === true) {
							checkboxes.style.display = 'none';
							$scope.expandedNotebook = false;
							arrow.style.transform = 'rotate(360deg)';
						}
					}
				});
			};

			/** Método que verifica paginação do filtro de caderno
			 * pernosalizado
			 */
			$scope.pageNotebookNew = (page, param) => {
				if ($scope.diaryChanges) $scope.pageNotebookActual = 0;

				var pNotebook = null;

				if (!$scope.paginacaoCaderno) pNotebook = true;
				else
					pNotebook =
						$scope.pageNotebookActual !== $scope.paginacaoCaderno.paginaTotal;

				$scope.paginacaoCaderno = $scope.paginacaoCaderno
					? $scope.paginacaoCaderno
					: [];

				const selectedDiaryIds = $scope.diaryAccount
					.filter(diary => diary.checked)
					.map(diary => diary.idDiario)
					.join(',');

				pNotebook =
					$scope.clearRecordsNot || $scope.notebookPesq ? true : pNotebook;

				if (selectedDiaryIds && pNotebook)
					$scope.filterNotebook(selectedDiaryIds, page, param);
			};

			$scope.returnNotebookUrls = async () => {
				if (!$scope.filter.caderno)
					localStorage.removeItem('__notebooksChecked__');

				$scope.existNotebook = JSON.parse(
					localStorage.getItem('__notebooksChecked__')
				);

				if (!$scope.existNotebook && $scope.filter.caderno) {
					let DataHoraInicio =
						moment($scope.filter.dataInicial).format('YYYY-MM-DD 00:00:00') ||
						null;
					let DataHoraFinal =
						moment($scope.filter.dataFinal).format('YYYY-MM-DD 23:59:59') ||
						null;

					if (DataHoraInicio) {
						DataHoraInicio = DataHoraInicio.replace('T', ' ');
					}
					if (DataHoraFinal) {
						DataHoraFinal = DataHoraFinal.replace('T', ' ');
					}

					let keywords = '';

					if ($scope.keyWordAccount && $scope.keyWordAccount.length > 0) {
						$scope.keyWordAccount.forEach(k => {
							if (k.checked) {
								if (keywords.length > 0) keywords += ',';
								keywords += k.idPalavraChave;
							}
						});
					}
					if (keywords == '') keywords = null;

					await $http({
						...helper.http(API.notebookUserGroup, 'GET'),
						params: {
							campos: '*',
							IdsDiario: $scope.filter.diario,
							IDs: $scope.filter.caderno,
							paginaAtual: 1,
							registrosPorPagina: 999,
							SomenteComMovimentoAtivo: true,
							DataHoraInicio: DataHoraInicio,
							DataHoraFim: DataHoraFinal,
							Lido: $scope.filter.lido || null,
							IdsPalavrasChaves: keywords || null
						}
					}).then(response => {
						$scope.existNotebook = [];

						$scope.existNotebook.push(...response.data.itens);

						$scope.existNotebook.forEach(value => (value.checked = true));

						localStorage.setItem(
							'__notebooksChecked__',
							JSON.stringify($scope.existNotebook)
						);
					});
				}
			};

			/** Método que traz cadernos para preencher o filtro */
			$scope.filterNotebook = async (diarieId, page, param) => {
				if (!$scope.notebookPesq) {
					const pageSaved = page
						? parseInt(localStorage.getItem('__pageNotebook__'))
						: 10;

					$scope.pageNotebook = !page && pageSaved ? pageSaved : 10;

					if (page) $scope.actualNotebook += 10;
					else $scope.actualNotebook = 10;

					let sub =
						$scope.actualNotebook >= 100
							? 2
							: $scope.actualNotebook > 10
							? 1
							: 1;

					$scope.pageNotebookActual = $scope.actualNotebook
						? parseInt($scope.actualNotebook.toString().substring(0, sub))
						: 1;

					if (!page) $scope.actualNotebook = $scope.pageNotebook;
				} else {
					$scope.pageNotebookActual = 1;
					$scope.pageNotebook = 999;
				}

				if ($scope.environmentPageMov == '5') {
					$scope.estaNaLixeiraCaderno = true;
				} else {
					$scope.estaNaLixeiraCaderno = null;
				}

				let filterDataInicial = null;
				let filterDataFinal = null;

				if (
					$scope.filter.dataInicial == undefined &&
					$scope.filter.dataFinal == undefined &&
					($scope.environmentPageMov == '2' || $scope.environmentPageMov == '3')
				) {
					filterDataInicial = moment(new Date().setHours(0, 0))
						.subtract(15, 'days')
						.format('YYYY-MM-DDTHH:mm:ss');
					filterDataFinal = moment(new Date().setHours(23, 59)).format(
						'YYYY-MM-DDTHH:mm:ss'
					);
				}

				let DataHoraInicio =
					filterDataInicial !== null
						? filterDataInicial
						: moment($scope.filter.dataInicial).format('YYYY-MM-DD 00:00:00') ||
						  null;
				let DataHoraFinal =
					filterDataFinal !== null
						? filterDataFinal
						: moment($scope.filter.dataFinal).format('YYYY-MM-DD 23:59:59') ||
						  null;

				if (DataHoraInicio) {
					DataHoraInicio = DataHoraInicio.replace('T', ' ');
				}
				if (DataHoraFinal) {
					DataHoraFinal = DataHoraFinal.replace('T', ' ');
				}

				let keywords = '';

				if ($scope.keyWordAccount && $scope.keyWordAccount.length > 0) {
					$scope.keyWordAccount.forEach(k => {
						if (k.checked) {
							if (keywords.length > 0) keywords += ',';
							keywords += k.idPalavraChave;
						}
					});
				}
				if (keywords == '') keywords = null;

				await $http({
					...helper.http(API.notebookUserGroup, 'GET'),
					params: {
						...helper.httpFields(['*']),
						IdsDiario: diarieId,
						descricao: $scope.notebookPesq ? page : null,
						paginaAtual: $scope.pageNotebookActual,
						registrosPorPagina: $scope.pageNotebook,
						SomenteComMovimentoAtivo: true,
						Lixeira: $scope.estaNaLixeiraCaderno,
						DataHoraInicio: DataHoraInicio,
						DataHoraFim: DataHoraFinal,
						Lido: $scope.filter.lido || null,
						IdsPalavrasChaves: keywords || null
					}
				}).then(async response => {
					$scope.paginacaoCaderno = response.data.paginacao;

					const {
						data: { itens }
					} = response;

					if (itens)
						itens.sort((a, b) =>
							a.descricaoCadernoDiario.localeCompare(b.descricaoCadernoDiario)
						);

					if ($scope.pageNotebookActual > 1)
						$scope.cadernosUsuario.push(...itens);
					else if (!$scope.notebookPesq && !param)
						$scope.cadernosUsuario = itens;
					else {
						$scope.cadernosUsuario.push(...itens);

						$scope.cadernosUsuario = Array.from(
							new Set($scope.cadernosUsuario.map(s => s.idCadernoDiario))
						).map(id => {
							return $scope.cadernosUsuario.find(s => s.idCadernoDiario === id);
						});
					}

					var notebookChecked = [];

					if (!!$scope.notebooksAccount) {
						var notebookChecked = $scope.notebooksAccount.filter(
							n => n.checked
						);

						var diary = $scope.diaryAccount.filter(n => n.checked);
					}

					$scope.notebooksAccount = $scope.cadernosUsuario;

					if ($scope.clearRecordsNot) {
						$scope.notebookCheckTotal.forEach(key => {
							$scope.notebooksAccount.forEach(k => {
								if (k.idCadernoDiario === key.idCadernoDiario) k.checked = true;
							});
						});
					}

					$scope.notebookPesq && $scope.notebooksSelected(page);
					!$scope.notebookPesq &&
						localStorage.setItem('__pageNotebook__', $scope.actualNotebook);

					if (notebookChecked.length)
						diary.forEach(d => {
							notebookChecked.forEach(n => {
								$scope.notebooksAccount.forEach(not => {
									const id = d.idDiario === n.idDiario ? n.idDiario : null;
									const equals = id === not.idDiario ? true : false;

									if (equals && n.idCadernoDiario == not.idCadernoDiario)
										not.checked = true;
								});
							});
						});

					if (
						$scope.diaryFalse &&
						Array.isArray($scope.notebookCheckTotal) &&
						$scope.notebookCheckTotal.length
					) {
						let array = $scope.notebookCheckTotal.map(
							d =>
								$scope.notebooksAccount.filter(
									c => d.idCadernoDiario == c.idCadernoDiario
								)[0]
						);

						$scope.notebookCheckTotal = array.filter(d => d != undefined);

						$scope.notebookCheckTotal.forEach(t => {
							$scope.notebooksAccount.forEach(d => {
								if (t.idCadernoDiario == d.idCadernoDiario) d.checked = true;
							});
						});
					} else if (
						$scope.diaryFalse &&
						(!$scope.notebookCheckTotal ||
							(Array.isArray($scope.notebookCheckTotal) &&
								!$scope.notebookCheckTotal.length))
					) {
						$scope.notebookCheckTotal = [];
					}

					if (
						$scope.filter.caderno ||
						($scope.notebookCheckTotal && !$scope.diaryFalse)
					) {
						if (!$scope.notebookCheckTotal) {
							const ids = $scope.filter.caderno.split(',');

							ids.forEach(id => {
								$scope.notebooksAccount.forEach(key => {
									if (key.idCadernoDiario == id) key.checked = true;
								});
							});
						}

						var exits = null;

						if (!$scope.notebookCheckTotal) {
							await $scope.returnNotebookUrls();
							exits = $scope.existNotebook;
						} else {
							exits = $scope.notebookCheckTotal;
						}

						var hasChecked = [...exits];

						hasChecked.forEach(e => {
							$scope.notebooksAccount.forEach(k => {
								if (e.idCadernoDiario == k.idCadernoDiario && k.checked) {
									var has = exits.filter(
										h => h.idCadernoDiario != k.idCadernoDiario
									);

									exits = [...has];
								}
							});
						});

						exits.length && $scope.notebooksAccount.push(...exits);

						$scope.notebooksAccount = Array.from(
							new Set($scope.notebooksAccount.map(s => s.idCadernoDiario))
						).map(id => {
							return $scope.notebooksAccount.find(
								s => s.idCadernoDiario === id
							);
						});

						if ($scope.filter.caderno && !$scope.badgeNotebook.length) {
							$scope.notebooksAccount.forEach(k => {
								if (k.checked)
									$scope.badgeNotebook.push({
										nomeCaderno: k.descricaoCadernoDiario,
										id: k.idCadernoDiario,
										idDiario: k.idDiario
									});
							});

							$scope.badgeNotebook = Array.from(
								new Set($scope.badgeNotebook.map(s => s.id))
							).map(id => {
								return $scope.badgeNotebook.find(s => s.id === id);
							});
						}
					}

					$scope.hasFilters('notebook');

					$scope.loadingNotebook = false;

					$scope.diaryChanges = false;
				});
			};

			//************************** TRIBUNAIS *************************

			$scope.expandedCourtsFilter = false;

			/** Método que expande o filtro de tribunais personalizado */
			$scope.expandedCourts = () => {
				var checkboxes = document.getElementById('checkboxesCourts');
				var arrow = document.getElementById('arrowCourts');

				setTimeout(() => {
					$scope.closeCourts(checkboxes, arrow);
				}, 100);

				if ($scope.clientUserJudicialOrgansList.hasNotItems())
					$scope.getCourts();

				if (!$scope.expandedCourtsFilter) {
					checkboxes.style.display = 'block';
					$scope.expandedCourtsFilter = true;

					arrow.style.transform = 'rotate(180deg)';
				} else {
					checkboxes.style.display = 'none';
					$scope.expandedCourtsFilter = false;

					arrow.style.transform = 'rotate(360deg)';
				}
			};

			/** Método que fecha filtro de tribunais personalidado */
			$scope.closeCourts = (checkboxes, arrow) => {
				$(document).on('click', function(e) {
					if ($(e.target).is('.clickoutCampanha')) return;

					if (!$(e.target).is('.searchingCourts')) {
						if ($scope.expandedCourtsFilter === true) {
							checkboxes.style.display = 'none';
							$scope.expandedCourtsFilter = false;
							arrow.style.transform = 'rotate(360deg)';
						}
					}
				});
			};

			$scope.getCourts = () => {
				const folder = $scope.briefcase.getItems();

				if (folder && $scope.folderType === -3) {
					$scope.recordRequestedProcessesJudicialOrgans(folder.numeroProcesso);
				}
			};

			$scope.courtsSearch = '';
			$scope.courtsClose = false;
			/** Método para pesquisa de palavra chave dentro do filtro */
			$scope.coursPesq = async courts => {
				if (courts.length > 2) {
					if (!$scope.guardCourts)
						$scope.guardCourts = helper.cloneSimpleObject(
							$scope.clientUserJudicialOrgansList.getItems()
						);

					let record = $scope.guardCourts.filter(item => {
						return (
							item.nomeOrgaoJudiciario
								.toLowerCase()
								.indexOf(courts.toLowerCase()) > -1
						);
					});

					$scope.clientUserJudicialOrgansList.setItems(record);

					record.length
						? ($scope.notCourts = false)
						: ($scope.notCourts = true);

					if (courts.length) $scope.courtsClose = true;
				} else if (!courts.length && $scope.guardCourts) {
					$scope.clientUserJudicialOrgansList.setItems($scope.guardCourts);
					$scope.notCourts = false;
					$scope.courtsClose = false;
				}
			};

			$scope.coursSelected = organs => {
				$scope.filter.orgaoJudicial = organs.idOrgaoJudiciario;
				$scope.titleCourts = organs.nomeOrgaoJudiciario;

				$scope.clearFilter(
					$scope.filter,
					['fonte', 'identificador', 'composedId', 'valorParametro'],
					false
				);

				$scope.titleSources = 'Todas fontes';

				$scope.requestedProcessesSourcesParams.setItems([]);

				$scope.expandedCourts();
			};

			$scope.btnClearCours = () => {
				$scope.clearFilter($scope.filter, [
					'orgaoJudicial',
					'fonte',
					'identificador',
					'composedId',
					'valorParametro'
				]);
				if ($scope.guardCourts)
					$scope.clientUserJudicialOrgansList.setItems($scope.guardCourts);

				$scope.titleCourts = 'Todos tribunais';
				$scope.titleSources = 'Todas fontes';
				$scope.courtsClose = false;
				$scope.sourcesClose = false;
				$scope.sourcesSearch = '';
				$scope.courtsSearch = '';
				document.getElementById('inputBuscaTribunais').value = '';
				document.getElementById('inputBuscaFontes').value = '';

				if ($scope.guardSources) {
					$scope.requestedProcessesSourcesParams.setItems($scope.guardSources);
				}
			};

			//************************** FONTES *************************

			$scope.expandedSourcesFilter = false;

			/** Método que expande o filtro de fontes personalizado */
			$scope.expandedSources = () => {
				var checkboxes = document.getElementById('checkboxesSources');
				var arrow = document.getElementById('arrowSources');

				setTimeout(() => {
					$scope.closeSources(checkboxes, arrow);
				}, 100);

				if ($scope.requestedProcessesSourcesParams.hasNotItems())
					$scope.changedSources($scope.filter);

				if (!$scope.expandedSourcesFilter) {
					checkboxes.style.display = 'block';
					$scope.expandedSourcesFilter = true;

					arrow.style.transform = 'rotate(180deg)';
				} else {
					checkboxes.style.display = 'none';
					$scope.expandedSourcesFilter = false;

					arrow.style.transform = 'rotate(360deg)';
				}
			};

			/** Método que fecha filtro de tribunais personalidado */
			$scope.closeSources = (checkboxes, arrow) => {
				$(document).on('click', function(e) {
					if (!$(e.target).is('.searchingSources')) {
						if ($scope.expandedSourcesFilter === true) {
							checkboxes.style.display = 'none';
							$scope.expandedSourcesFilter = false;
							arrow.style.transform = 'rotate(360deg)';
						}
					}
				});
			};

			$scope.sourcesSearch = '';
			$scope.sourcesClose = false;
			/** Método para pesquisa de palavra chave dentro do filtro */
			$scope.sourcesPesq = async sources => {
				if (sources.length > 2) {
					if (!$scope.guardSources)
						$scope.guardSources = helper.cloneSimpleObject(
							$scope.requestedProcessesSourcesParams.getItems()
						);

					let record = $scope.guardSources.filter(item => {
						return (
							item.nomeFontePesquisa
								.toLowerCase()
								.indexOf(sources.toLowerCase()) > -1
						);
					});

					$scope.requestedProcessesSourcesParams.setItems(record);

					record.length
						? ($scope.notSources = false)
						: ($scope.notSources = true);

					if (sources.length) $scope.sourcesClose = true;
				} else if (!sources.length && $scope.guardSources) {
					$scope.requestedProcessesSourcesParams.setItems($scope.guardSources);
					$scope.notSources = false;
					$scope.sourcesClose = false;
				}
			};

			$scope.sourcesSelected = sources => {
				$scope.filter.composedId = sources.composedId;
				$scope.titleSources = sources.nomeFontePesquisa;

				$scope.beforeFilterBySourceParams(
					$scope.filter.composedId,
					$scope.filter
				);
				$scope.selectedFilter($scope.filter);

				$scope.expandedSources();
			};

			$scope.btnClearSources = () => {
				$scope.clearFilter($scope.filter, [
					'fonte',
					'identificador',
					'composedId'
				]);
				if ($scope.guardSources)
					$scope.requestedProcessesSourcesParams.setItems($scope.guardSources);

				$scope.titleSources = 'Todas fontes';
				$scope.sourcesClose = false;
				$scope.sourcesSearch = '';
				document.getElementById('inputBuscaFontes').value = '';
			};

			//********* FIM dos MÉTODOS dos FILTROS PERSONALIZADO **********

			/** Método que prepara para enviar/restaurar movimentos */
			$scope.restoreOrSend = (movements, request) => {
				if (!$scope.restore || !$scope.send)
					$scope.sendOrRestoreTrashCan(movements, request);
			};

			/** Método que envia ou restaura movimento (ambiente de lixeira) */

			$scope.sendOrRestoreTrashCan = (movements, request) => {
				if ($scope.restore || $scope.send) return;

				request == 'restore' ? ($scope.restore = true) : ($scope.send = true);

				let movs = [];

				movements[0] ? (movs = movements) : movs.push(movements);

				const objData = movs.map(movement => {
					let movData = {
						idPasta:
							movement.pastasMovimento && movement.pastasMovimento.length > 0
								? movement.pastasMovimento[0].id
								: movement.movimento.pastas &&
								  movement.movimento.pastas.length > 0
								? movement.movimento.pastas[0].idPastaUsuarioCliente
								: null,
						idMovimentoProcessoCliente: movement.movimento.id
					};

					if ($scope.groupUserSelected)
						movData.idGrupoUsuarios = $scope.groupData.idGrupo;
					else movData.idUsuarioCliente = $scope.userData.idUsuarioCliente;

					movData.excluirPrazosVinculados = false;

					if (
						(movement.movimento.prazosAvencer ||
							movement.movimento.prazosVencidos) &&
						$scope.shouldDeleteDeadlineOption == 2
					) {
						movData.excluirPrazosVinculados = true;
					}

					if (movement.movimento.idTipoMovProcesso == -1 && !movData.idPasta) {
						if (
							movement.pastasMovimento &&
							movement.pastasMovimento.length > 0 &&
							movement.pastasMovimento[0].id != null
						) {
							movData.idPasta = movement.pastasMovimento[0].id;
						} else if (
							movement.movimento.pastas &&
							movement.movimento.pastas.length > 0 &&
							movement.movimento.pastas[0].idPastaUsuarioCliente != null
						) {
							movData.idPasta =
								movement.movimento.pastas[0].idPastaUsuarioCliente;
						}
					}

					return movData;
				});

				const palavrasChaveSelecionadas = ($scope.keyWordAccount || []).filter(
					palavraChave => palavraChave.checked
				);
				const emTodasConta = $location.$$url.includes(
					'/movimentacoes/todas-conta'
				);
				const emPublicacoes = $location.$$url.includes(
					'/movimentacoes/publicacoes'
				);
				const possuiFiltroPalavraChave =
					($scope.allOfAccount || emTodasConta || emPublicacoes) &&
					palavrasChaveSelecionadas.length > 0;
				const enviarPorPasta =
					request == 'send' &&
					($scope.folderType == -2 || possuiFiltroPalavraChave);

				let idsPastas = objData
					.map(item => item.idPasta)
					.filter(
						(idPasta, index, items) =>
							idPasta != null && items.indexOf(idPasta) == index
					);

				if ($scope.folderType == -2 && $stateParams.pasta != null)
					idsPastas = [Number($stateParams.pasta)];
				else if (possuiFiltroPalavraChave)
					idsPastas = palavrasChaveSelecionadas
						.map(
							palavraChave =>
								palavraChave.idPastaUsuarioCliente || palavraChave.id
						)
						.filter(
							(idPasta, index, items) =>
								idPasta != null && items.indexOf(idPasta) == index
						);
				else if ($stateParams.pasta != null && idsPastas.length == 0)
					idsPastas = [Number($stateParams.pasta)];

				const payload = {
					movimentosXPastas: objData.map(item => {
						const movimentoXPasta = { ...item };

						delete movimentoXPasta.idPasta;

						return movimentoXPasta;
					}),
					idsPastas
				};

				$http({
					...helper.http(
						API.trashCan,
						enviarPorPasta ? 'sendByFolders' : `${request}`
					),
					method: 'PUT',
					data: enviarPorPasta ? payload : objData,
					messageOverride: {
						success(response, notify) {
							const success =
								request == 'send'
									? 'Enviado para a Lixeira!'
									: 'Documento restaurado!';

							notify.success(success);
						},
						error(response, notify) {
							const error =
								request == 'send'
									? 'Erro ao enviar para Lixeira.'
									: 'Erro ao restaurar documento.';

							notify.danger(error);
						}
					},
					noCancelOnRouteChange: true
				})
					.then(response => {
						if (response.status != 500) {
							const total = $scope.movements.getCheckedItems().length;

							if (total === $scope.quantityPerPage) $scope.listingHibben = true;

							//guarda os movimentos marcados
							let checked = $rootScope.newPublicationChecked
								? $rootScope.newPublicationChecked
								: [];

							//filtra os movimentos para retirar da listagem
							if (checked.length) {
								checked.forEach(c => {
									movs.forEach(m => {
										if (c.idMovProcessoCliente === m.idMovProcessoCliente)
											c.__checked__ = false;
									});
								});
								checked = checked.filter(c => c.__checked__);
								$rootScope.newPublicationChecked = checked;
							} else $rootScope.newPublicationChecked = [];

							//verifica se habilita ou não as ações em lote
							!checked || checked.length < 2
								? ($scope.itemCheckedDisable = true)
								: ($scope.itemCheckedDisable = false);

							$scope.movements.getItems().forEach(m => {
								movs.forEach(r => {
									if (m.idMovProcessoCliente === r.idMovProcessoCliente)
										m.delete = true;
								});
							});

							let mov = $scope.movements.getItems().filter(m => !m.delete);

							$scope.movements.setItems(mov);

							movements.length > 1 &&
								$('#div-check-all input[type=checkbox]').prop('checked', false);

							$scope.callProcAndPublic(movs);
							$rootScope.getTotalNotRead();

							if (
								$scope.movements.getItems().length === 0 ||
								movements.length > $scope.quantityPerPage
							)
								$scope.treatPageMov();

							$scope.sendORestore = request;

							$scope.recordMovements($scope.movements);

							$('#modalDeleteMovementNew').modal('hide');
							$('#modalDeleteMovementWithDeadline').modal('hide');
						} else if (response.status == 500) {
							request == 'send' &&
								notification.danger('Erro ao enviar para Lixeira.');

							$('#modalDeleteMovementNew').modal('hide');
							$('#modalDeleteMovementWithDeadline').modal('hide');

							setTimeout(() => {
								request == 'restore'
									? ($scope.restore = false)
									: ($scope.send = false);
							}, 10);
						}
					})
					.catch(() => {
						$('#modalDeleteMovementNew').modal('hide');
						$('#modalDeleteMovementWithDeadline').modal('hide');
						setInterval(() => {
							request == 'restore'
								? ($scope.restore = false)
								: ($scope.send = false);
						}, 10);
					});
			};

			/** Verifica se os movimentos excluidos para atualizar a listagem de não lidos */
			$scope.callProcAndPublic = movements => {
				let proc = movements.some(mov => mov.movimento.idTipoMovProcesso == -1);
				let publi = movements.some(
					mov => mov.movimento.idTipoMovProcesso == -2
				);

				if (proc) $rootScope.changeProcessOrder('setMovements');
				if (publi) $rootScope.changeKeywordOrder('setMovements');
			};

			/** Método que verifica paginação das movimentações */
			$scope.treatPageMov = () => {
				let page = JSON.parse(sessionStorage.getItem('__pageMovements__'));
				let nova = page > 1 ? page - 1 : 1;

				nova =
					$scope.pagination.paginaAtual == $scope.pagination.paginaTotal
						? 1
						: nova;

				sessionStorage.setItem('__pageMovements__', nova);

				$scope.listingHibben = true;
			};

			/** volta para movimentações se estiver na lixeira ou na
			 * pagina de processos
			 */
			$scope.backMov = () => {
				let modulo = sessionStorage.getItem('modulo');
				let pasta = sessionStorage.getItem('modulo-pasta');

				let beforeQuestionMark =
					modulo && modulo.substring(0, modulo.indexOf('?'));

				if (modulo == 'processos') $rootScope.printingProc = 'click';

				sessionStorage.removeItem('modulo');

				modulo == 'publicacao' && $rootScope.changeAllOfCountValue();
				modulo == 'processos' && $rootScope.deleteAllOfCount(pasta);
				modulo == 'publiPasta' && $rootScope.publicationAccount(pasta);
				modulo == 'todas' && $rootScope.deleteAllOfCountValue();

				// if (modulo == 'publiPasta' || modulo == 'publicacao')
				// 	$rootScope.toggleCollapse('keyword', 'process');
				// else if (modulo == 'processos' || modulo == 'pageProcessos')
				// 	$rootScope.toggleCollapse('process', 'keyword');

				if (modulo && modulo.startsWith('/inss')) {
					const params = {};

					var match = modulo.match(/numeroProcesso=(\d+)/);
					var numeroProcesso = match ? match[1] : null;
					var idProcesso = modulo.match(/idProcesso=(\d+)/)
						? modulo.match(/idProcesso=(\d+)/)[1]
						: null;

					if (modulo == '/inss') {
						$state.go('root.default.movements.inss', params, {
							inherit: false
						});
					} else if (beforeQuestionMark == '/inss/detalhar') {
						var movements = modulo.match(/movements=(\d+)/)
							? modulo.match(/movements=(\d+)/)[1]
							: null;
						var pastaSearchGet = modulo.match(/pasta=(\d+)/)
							? modulo.match(/pasta=(\d+)/)[1]
							: null;

						$state.go(
							'root.default.movements.inssDetails',
							{
								movements: movements,
								pasta: pastaSearchGet,
								numeroProcesso: numeroProcesso,
								idProcesso: idProcesso
							},
							{
								inherit: false
							}
						);
					} else {
						var numero = modulo.split('/').pop();

						numero = numero.match(/\d+/)[0];

						$state.go(
							'root.default.movements.inss1',
							{
								processId: numero,
								numeroProcesso: numeroProcesso,
								idProcesso: idProcesso
							},
							{
								inherit: false
							}
						);
					}
				} else if ((!pasta || pasta == 'null') && modulo != 'pageProcessos') {
					let params =
						modulo == 'publicacao'
							? '2'
							: modulo == 'processos'
							? '4'
							: modulo == 'publiPasta'
							? '3'
							: '1';

					$state.transitionTo(`root.default.movements.list${params}`, {
						inherit: false,
						reload: `root.default.movements.list${params}`
					});
				} else if (modulo == 'pageProcessos') {
					const params = {};

					$state.go('root.default.movements.processList', params, {
						inherit: false
					});
				}
			};

			$scope.goBackMov = () => {
				$state.go(
					'root.default.movements.processList',
					{},
					{
						inherit: false,
						reload: 'root.default.movements.processList'
					}
				);
			};

			$scope.popover = false;
			$scope.invalidName = false;
			$scope.searchTextual = event => {
				let el1 = document.getElementById('textualSearch');

				var nome = el1.value.trim();
				var nomeLenghtSpaces = nome.replace(/\s/g, '').length;

				if (nomeLenghtSpaces < 3 && event != 'blur' && el1.value != '') {
					el1.classList.add('search__input-invalid');
					$scope.popover = true;
					$scope.invalidName = true;
				} else {
					$scope.popover = false;
					event != 'blur' && el1.classList.remove('search__input-invalid');
				}

				if (event != 'blur' && !el1.classList.contains('search__input-invalid'))
					$scope.invalidName = false;
			};

			$scope.validationHours = (sDate, eDate) => {
				const startDate = moment(sDate);
				const endDate = moment(eDate);

				if (!startDate.isValid() || !endDate.isValid()) {
					notification.danger('Informe horários válidos para o compromisso.');

					$rootScope.creationEventLoading = false;

					return false;
				}

				if (endDate.isSameOrBefore(startDate)) {
					notification.danger(
						'Hora final cadastrada no compromisso não pode ser menor ou igual à hora inicial!'
					);

					$rootScope.creationEventLoading = false;

					return false;
				}

				const diffInMinutes = endDate.diff(startDate, 'minutes');

				if (diffInMinutes < 15) {
					notification.danger(
						'O intervalo mínimo entre o horário de início e fim é de 15 minutos.'
					);

					$rootScope.creationEventLoading = false;

					return false;
				}

				return true;
			};

			/*************************** GRID MÉTODOS *****************************/

			$scope.listGrid = preview => {
				if (
					$scope.loadingGrid ||
					preview == $scope.parameterUsers.idTipoVisualizacao
				)
					return;

				$scope.loadingGrid = true;
				$scope.parameterUsers.idTipoVisualizacao = !$rootScope.grid ? -2 : -1;

				$rootScope.grid = !$rootScope.grid;

				let method = !$scope.parameterUsers.naoTipo ? 'PUT' : 'POST';

				$http({
					...helper.http(API.parametersUsers, method),
					data: {
						itens: [
							{
								id:
									method === 'PUT'
										? $scope.parameterUsers.idParamUsuarioProdAdv
										: null,
								idTipoVisualizacao: $scope.parameterUsers.idTipoVisualizacao
							}
						]
					},
					messageOverride: {
						success() {}
					}
				})
					.then(() => {
						$rootScope.grid =
							$scope.parameterUsers.idTipoVisualizacao == -1 ? false : true;

						$scope.parameterUsers.naoTipo = false;

						sessionStorage.setItem(
							'parametros-usuarios',
							JSON.stringify($scope.parameterUsers)
						);
					})
					.finally(() => {
						$scope.loadingGrid = false;
					});
			};

			$scope.toView = () => {
				if (!$scope.parameterUsers.exibirInfo) return;

				$(document).on('click', function(e) {
					var element = document.getElementById('to-view-popover');

					if (!$(e.target).is('.c-view__popover')) {
						if ($scope.popoverGrid) {
							$scope.popoverGrid = false;

							element.style.display = 'none';
						}
					} else if (!$scope.popoverGrid && $scope.parameterUsers.exibirInfo) {
						$scope.popoverGrid = true;

						element.style.display = 'block';
					}
				});

				$scope.exibirInfosView();
			};

			$scope.viewInfos = () => {
				let view = document.getElementById('exibir-infos-grid');

				view.click();

				$scope.parameterUsers.exibirInfo = false;
			};

			$scope.exibirInfosView = () => {
				let method = !$scope.parameterUsers.naoTipo ? 'PUT' : 'POST';

				$http({
					...helper.http(API.parametersUsers, method),
					data: {
						itens: [
							{
								id:
									method === 'PUT'
										? $scope.parameterUsers.idParamUsuarioProdAdv
										: null,
								exibirInfo: false
							}
						]
					},
					messageOverride: {
						success() {}
					}
				}).then(() => {
					$scope.parameterUsers.naoTipo = false;
					$scope.parameterUsers.exibirInfo = false;

					sessionStorage.setItem(
						'parametros-usuarios',
						JSON.stringify($scope.parameterUsers)
					);
				});
			};

			$scope.checkShouldDeleteDeadlineOption = newValue => {
				$scope.shouldDeleteDeadlineOption = newValue;
			};

			$scope.checkDeleteLinkedDeadlines = newValue => {
				$scope.deleteLinkedDeadlines = newValue;
			};

			/********************** FIM DOS GRID MÉTODOS **************************/

			/*************************** AÇÕES ****************************************/

			$scope.actions = (mov, i) => {
				if (!mov.acao) {
					$scope.movements.getItems().forEach((m, index) => {
						if (m.acao) {
							m.acao = false;
							$scope.actionElements('close', index);
						}
					});

					mov.acao = true;

					$scope.actionElements('open', i);
					$scope.closeAction();
				} else {
					mov.acao = false;
					$scope.actionElements('close', i);
				}
			};

			/** Método que fecha filtro de tribunais personalidado */
			$scope.closeAction = () => {
				$(document).on('click', function(e) {
					if (!$(e.target).is('.card__action')) {
						if ($scope.openCardAction) {
							var i = 0;

							$scope.movements.getItems().forEach((m, index) => {
								if (m.acao) {
									m.acao = false;
									i = index;
								}
							});

							$scope.actionElements('close', i);
						}
					}
				});
			};

			$scope.actionElements = (action, i) => {
				let element = document.getElementById(`action${i}`);
				let more = document.getElementById(`more${i}`);
				let close = document.getElementById(`close${i}`);

				element.style.display = action == 'open' ? 'block' : 'none';

				action == 'open'
					? ((more.style.display = 'none'), (close.style.display = 'block'))
					: ((close.style.display = 'none'), (more.style.display = 'block'));

				$scope.openCardAction = action == 'open' ? true : false;
			};

			// Ações Mobile
			$scope.actionsMobile = (mov, i) => {
				if (!mov.acao) {
					$scope.movements.getItems().forEach((m, index) => {
						if (m.acao) {
							m.acao = false;
							$scope.actionElementsMobile('close', index);
						}
					});

					mov.acao = true;

					$scope.actionElementsMobile('open', i);
					$scope.closeActionMobile();
				} else {
					mov.acao = false;
					$scope.actionElementsMobile('close', i);
				}
			};

			/** Método que fecha filtro de tribunais personalidado */
			$scope.closeActionMobile = () => {
				$(document).on('click', function(e) {
					if (!$(e.target).is('.card__action-mobile')) {
						if ($scope.openCardAction) {
							var i = 0;

							$scope.movements.getItems().forEach((m, index) => {
								if (m.acao) {
									m.acao = false;
									i = index;
								}
							});

							$scope.actionElementsMobile('close', i);
						}
					}
				});
			};

			$scope.onInit();

			$scope.actionElementsMobile = (action, i) => {
				let element = document.getElementById(`action-mobile${i}`);
				let more = document.getElementById(`more-mobile${i}`);
				let close = document.getElementById(`close-mobile${i}`);

				element.style.display = action == 'open' ? 'block' : 'none';

				action == 'open'
					? ((more.style.display = 'none'), (close.style.display = 'block'))
					: ((close.style.display = 'none'), (more.style.display = 'block'));

				$scope.openCardAction = action == 'open' ? true : false;
			};

			$scope.closeAllMovements = () => {
				$scope.movements.getItems().forEach((m, index) => {
					if (m.acao) {
						m.acao = false;
						$scope.actionElements('close', index);
						$scope.actionElementsMobile('close', index);
					}
				});
			};

			$scope.checkDisabledProDetails = () => {
				if ($scope.hasNotList) return true;

				return false;
			};

			$scope.returnResume = resume => {
				const str = resume;
				var termo = $scope.stateParamsFilter.pesquisa;

				if (!termo) return resume;

				let str2 = str
					.toLowerCase()
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '');
				let termo2 = termo
					.toLowerCase()
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '');

				function hasInclude() {
					if (str2.includes(termo2)) return true;
					else return false;
				}

				if (!hasInclude()) {
					for (let index = 0; termo.length > 0; index++) {
						const ultima = termo.substring(termo.lastIndexOf(' ') + 1);

						termo = termo.substring(0, termo.length - ultima.length - 1);

						if (hasInclude()) break;
					}

					if (!hasInclude()) return resume;
				}

				if (!hasInclude()) return resume;

				var positionInitial = str2.indexOf(termo2);

				var output = [
					str.slice(0, positionInitial),
					'<span class="termResume">',
					str.slice(positionInitial)
				].join('');

				let output2 = output
					.toLowerCase()
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '');

				var positionEnd = output2.indexOf(termo2) + termo.length;

				output = [
					output.slice(0, positionEnd),
					'</span>',
					output.slice(positionEnd)
				].join('');

				return output;
			};

			$scope.closeDeletedItemsInfo = () => {
				sessionStorage.setItem('__closeTrashInfoMessage__', true);
				$scope.showTrashInfoMessage = false;
			};

			$scope.isMobile =
				window && window.innerWidth && window.innerWidth <= 991 ? true : false;

			$(window).resize(() => {
				let previousIsMobile = $scope.isMobile;

				$scope.isMobile = window.innerWidth <= 991;

				if ($scope.isMobile != previousIsMobile) {
					$scope.$apply();
				}
			});

			/*************************** FIM ****************************************/
		}
	])

	.filter('capitalize', () => {
		return capitalize;
	});

const REGEX_ALL = /([^\W_]+[^\s-]*) */g;
const REGEX_FIRST = /([^\W_]+[^\s-]*)/;

const capitalize = (input, all) => {
	if (!input) return '';

	const regex = all ? REGEX_ALL : REGEX_FIRST;

	return input.replace(
		regex,
		txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
	);
};

const queryConvert = () => {
	var queryStr = window.location.search,
		queryArr = queryStr.replace('?', '').split('&'),
		queryParams = [];

	for (var q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
		var qArr = queryArr[q].split('='),
			obj = {
				key: qArr[0],
				value: qArr[1] ? qArr[1].replace(/%20/g, ' ') : qArr[1]
			};

		queryParams.push(obj);
	}

	return queryParams;
};

const compareDates = (date1, date2) => {
	if (typeof date1 == 'object') {
		date1 = moment(new Date(date1)).format('YYYY-MM-DD[T]00:00:00');
	}
	if (typeof date2 == 'object') {
		date2 = moment(new Date(date2)).format('YYYY-MM-DD[T]23:59:59');
	}

	const formattedDate1 = date1.split('T');
	const formattedDate2 = date2.split('T');

	if (formattedDate1[0] === formattedDate2[0]) {
		return true;
	}

	return false;
};

export default controller;
